export const langEn = {
  // Sidebar Menu
  sidebar_home: 'Home',
  sidebar_invoicing: 'Invoicing',
  sidebar_accounting: 'Accounting',
  sidebar_business: 'My Business',
  sidebar_banks: 'Banks',
  sidebar_customers: 'Customers',
  sidebar_employees: 'Employees',
  sidebar_contractors: 'Contractors',
  sidebar_purchases: 'Purchases',
  sidebar_sales: 'Sales',
  sidebar_travels: 'Travels',
  sidebar_business_info: 'Business Info',
  sidebar_reports: 'Reports',
  sidebar_accounting_reports: 'Accounting Reports',
  sidebar_annual_report: 'Annual Report',
  sidebar_agreements: 'Agreements',
  sidebar_premium: 'Premium',
  sidebar_projects: 'Projects',
  sidebar_financials: 'Financials',
  sidebar_transactions: 'Transactions',
  sidebar_workflows: 'Workflows',
  sidebar_amazon: 'Amazon Seller',
  sidebar_companion: 'companion®',
  sidebar_offer: 'Offers',
  sidebar_support: 'Support',

  // User Menu
  user_menu_profile: 'Profile',
  user_menu_team: 'Team',
  user_menu_refer_a_friend: 'Referral',
  user_menu_manage_subscription: 'Subscription',
  user_menu_billing: 'Billing',
  user_menu_automation: 'Automation',
  user_menu_marketplace: 'Marketplace',
  user_menu_settings: 'Settings',
  user_menu_others: 'Others',
  user_menu_switch_version: 'Switch to previous version',
  user_menu_dark_mode: 'Dark Mode',
  user_menu_light_mode: 'Light Mode',
  user_menu_switch_to_light_mode: 'Switch to light mode',
  user_menu_switch_to_dark_mode: 'Switch to dark mode',
  user_menu_log_out: 'Log out',

  // Page Titles
  page_title_home: 'Hey {{name}}!',
  page_title_invoicing: 'Invoicing',
  page_title_accounting: 'Accounting',
  page_title_business: 'My Business',
  page_title_banks: 'Banks',
  page_title_customers: 'Customers',
  page_title_customer_details: 'Back to Customers',
  page_title_employees: 'Employees',
  page_title_contractors: 'Contractors',
  page_title_purchases: 'Purchases',
  page_title_sales: 'Sales',
  page_title_travels: 'Travels',
  page_title_virtual_office: 'Virtual Office',
  page_title_business_info: 'Business Info',
  page_title_annual_report: 'Annual Reports',
  page_title_bank_details: 'Back to Banks',
  page_title_update_purchase_invoice: 'Back to Purchase',
  page_title_update_sale_invoice: 'Back to Sales',
  page_title_profile: 'Profile',
  page_title_team: 'Team',
  page_title_refer_a_friend: 'Refer a friend!',
  page_title_manage_subscription: 'Manage subscription',
  page_title_marketplace: 'Marketplace',
  page_title_billing: 'Billing',
  page_title_automation: 'Automation',
  page_title_settings: 'Settings',
  page_title_add_card: 'Back to Billing',
  page_title_referral_history: 'Back to Referrals',
  page_title_add_or_edit_user: 'Back to Team',
  page_title_add_or_edit_member: 'Back to registry',
  page_title_add_travel: 'Back to travels',
  page_title_travel_details: 'Back to travels',
  page_title_agreements: 'Agreements',
  page_title_add_agreement: 'Back to Agreements',
  page_title_agreement_details: 'Back to Agreements',
  page_title_transactions: 'Transactions',
  employee_or_contractor_label: 'Employee / contractor',
  member_of_company_label: 'member of the board',
  page_title_secure_download:
    'Here you can view and download all the documents that have been shared with you.',
  page_title_offers: 'Offers',
  page_title_missing_bank: 'Back to Banks',

  // Login Page
  login_welcome: 'Welcome back!',
  login_description_1: 'Enter your email to receive a magic link to access the system.',
  login_description_2: 'You can also log in with your e-Residency card.',
  login_enter_your_email: 'Enter your email',
  login_enter_magic_link_submit: 'Get magic link',
  login_email_valid: 'Email is not valid',
  login_email_required: 'Email is required',
  login_keep_me_logged_in: 'Remember me',
  login_sending_magic_link: 'Sending magic link',
  login_we_sent_you_magic_link_html:
    'We sent you a magic link by email to access Companio. Please, don\'t forget to check your junk mail folder too. If you still can\'t find it, <a href="https://help.companio.co" target="_blank" rel="noreferrer">contact us</a>.',
  login_error_sending_magic_link:
    "An error happened while trying to send your magic link. Don't worry, our IT team is aware of the error, but you can contact us to give us additional information.",
  login_dont_have_account: "Don't have an account?",
  login_sign_up: 'Sign up',
  login_check_your_inbox: 'Check your inbox!',
  login_which_email_page_open: 'Which email page do you want to open?',
  login_didnt_get_the_email: "Didn't get the email?",
  login_resend_code_to_my_email: 'Resend code to my email',
  login_gmail: 'Gmail',
  login_outlook: 'Outlook',
  login_apple: 'Mail',

  // Home Page
  home_accounting_period_tab_label_previous: 'Last month',
  home_accounting_period_tab_label_current: 'This month',
  home_dashboard_walkthrough_button: 'Dashboard Walkthrough',
  home_invoices_and_movements: 'Invoices & Movements',
  home_sales_invoices: 'Sales invoices',
  home_purchase_invoices: 'Purchase invoices',
  home_bank_statements: 'Bank statements',
  home_matchings_pending: '{{ matchings }} matchings pending',
  home_disconnected_bank_accounts: '{{ disconnected_bank_accounts }} bank(s) disconnected',
  home_match_button: 'Match',
  home_upload_button: 'Upload',
  home_connect_button: 'Connect',
  home_statements_button: 'Statements',
  home_submitting_reports: 'Submitting Reports',
  home_tsd_report: 'TSD Report',
  home_vat_report: 'VAT Report',
  home_oss_report: 'OSS Report',
  home_deadline: 'Deadline: {{ date }}',
  home_payment_of_taxes: 'Payment of Taxes',
  home_tsd_taxes: 'TSD Taxes payment',
  home_vat_taxes: 'VAT Taxes Payment',
  home_reference: 'Reference: {{ reference }}',
  home_taxes_how_to: 'Not sure how to do the tax payments?',
  home_taxes_find_out: 'Find out how here! 😉',
  home_important_messages: 'Important messages!',
  home_oss_banner_title: 'Do you sell through Amazon FBA?',
  home_oss_banner_button: 'Talk to us',
  home_oss_banner_description: 'Access full digital accounting tailored for Amazon sellers.',
  home_messages_bank_account_up_to_date_title: 'Bank Connections Up to Date',
  home_messages_bank_account_up_to_date_description:
    'Your bank connections are up to date! Enjoy seamless and secure management of your financial transactions.',
  home_messages_bank_account_disconnected_title: '{{ banks }} Bank account(s) disconnected',
  home_messages_bank_account_disconnected_description: 'Please reconnect your bank accounts',
  home_messages_bank_account_expiring_soon_title: '{{ banks }} Bank connection(s) expiring soon',
  home_messages_bank_account_expiring_soon_description:
    '{{ banks }} bank connection(s) will expire soon. Please reconnect your bank to avoid interruptions in transaction syncing.',
  home_messages_no_pending_invoices_title: 'Your payments are up to date',
  home_messages_no_pending_invoices_description:
    'Great news! You don’t have any pending payments for our services, everything is fully settled.',
  home_messages_invoices_to_pay_title: 'You have {{ invoices }} invoice(s) to pay',
  home_messages_invoices_to_pay_description:
    'You have {{ invoices }} pending invoice(s) for a total of {{ total_value }}',
  home_created_at: 'Created at: {{ date }}',
  home_deadline_at: 'Deadline: {{ date }}',
  home_accounting_report: 'Report',
  terms_and_conditions_modal_title: 'We have updated our Terms of Service',
  terms_and_conditions_modal_description:
    'Please take a moment to read them <a href="https://companio.co/terms-of-service/" target="_blank">here</a> and stay informed about what has changed',
  terms_and_conditions_modal_button: 'Ok',
  terms_update_pending: 'Terms updated successfully',
  terms_update_error: 'There was an error while updating the terms',
  certificate_is_expired_title: 'Your e-Resident card has expired',
  members_certificate_is_expired_title: 'Action required: Member e-Residency expired',
  certificate_is_expired_description:
    '<p>Your current e-Resident card is no longer valid. <bold> Please insert your new card to update your data and continue using our services without interruption.</bold> This step is required to ensure secure access and legal compliance.</p>',
  members_certificate_is_expired_description:
    '<p>We detected that one or more company members have an expired e-Residency card. Please visit the "Registry" section to update their information and maintain compliance.</p>',
  review_members: 'Review members',
  certificate_is_expired_button: 'Connect new card',
  certificate_is_close_to_expire_title: 'Your e-Resident card is about to expire',
  certificate_is_close_to_expire_description: `<p>We've detected that your e-Resident card may be approaching its expiration date. <bold>Please check the card’s expiry and make sure to request a new one or apply for renewal if needed.</bold> Once you receive the new card, connect it again to update your data in our system.</p>`,
  certificate_is_close_to_expire_button: 'Ok',
  certificate_extracting_data: 'We’re extracting data from your card',
  fba_support_message: 'I want to know about Amazon FBA services.',
  financial_period_banner_description:
    'In <b>{{current}}</b>, we prepare your accounts for <b>{{previous}}</b>, so please make sure to <b>upload all your invoices from {{previous}}</b> (both sales and purchases) in the <b>Financials > Sales</b> and <b>Financials > Purchases</b> sections by <b>{{current}} 5th</b>. You can also start uploading your <b>{{current}} invoices</b> now.',
  certificate_signing_modal_error_title: 'Oops! something went wrong',
  certificate_signing_modal_error_description:
    'An error happened while signing the request for your company registration. Please, make sure the USB reader is working, restart the browser or try with a different one. If the problem persists, contact us.',
  certificate_signing_modal_success_title: 'New data have been saved',
  certificate_signing_modal_success_description:
    'Your card information has been securely stored in our system. Thank you for your support!',
  confirmation_code_modal_title: 'We sent you an SMS code',
  confirmation_code_modal_description:
    'Please check your phone, we sent you an SMS message with a code to verify your phone number. Enter it here. If you can’t find it, you can request a new code.',
  verify_code: 'Verify code',
  receive_code_question: 'Didn’t receive any code?',
  resend_again: 'Resend Again',
  request_new_code_in: 'Request new code in',
  request_new_code: 'Request new code',
  instructions: 'Instructions',
  eresidency_about_to_expire_title: 'Your e-Residency Certificate is About to Expire!',
  eresidency_about_to_expire_description:
    'We’ve detected that your e-Residency certificate will expire in less than a month. To avoid losing access to your company and our services, please renew it as soon as possible.',
  terms_update_success: 'Terms accepted successfully',
  financial_period: 'Financial Period',
  eresidency_update_modal_title: 'Update e-Residency card',
  eresidency_update_modal_description:
    '<p><b>Please insert your new card to update your data and continue using our services without interruption.</b> This step is required to ensure secure access and legal compliance.</p>',
  missing_bank_banner_description:
    '<b>There may be a bank account that hasn’t been connected yet.</b> Please review and either connect it or confirm there are no additional accounts.',

  // Walkthrough Guide
  get_started_modal_title: 'Welcome to Companio!',
  get_started_modal_description:
    '<p>You’ve just unlocked your all-in-one dashboard for accounting, compliance, and business management of your company.</p><p><bold>Get ready to experience how Companio makes freedom work, giving you clarity, control, and the confidence to grow without borders.</bold></p><p>We’ll now walk you through the key features of your dashboard so you can discover everything it can do for you.</p>',
  get_started_button: 'Get Started',
  homescreen_guide_step_title: 'Home Screen',
  homescreen_guide_step_description:
    '<p>This is your main hub. Here you’ll see reminders to upload your sales and purchase invoices from each month, <bold>no later than the 5th of the following month.</bold></p><p>You’ll also find the progress of your monthly reports, and reminders when it’s time to pay taxes.</p><p>Plus, you’ll see <bold>important notifications</bold> that let you know right away if any action is required.</p>',
  invoicing_guide_step_title: 'Invoicing',
  invoicing_guide_step_description:
    '<p>Creating an invoice in Companio is quick and easy. Just follow these steps:</p><li>1. Fill in <bold>the invoice data</bold>, as the customer, subject, or any special instructions.</li><li>2. Add your <bold>invoice items.</bold></li><li>3. <bold>Review and preview</bold> your invoice to make sure everything is correct.</li><li>4. Click <bold>Add invoice</bold> — and you’re done!</li>',
  accounting_guide_step_title: 'Accounting',
  accounting_guide_step_description:
    '<p>This section allows you to perform bank reconciliation by matching a transaction or movement with an invoice or a reason.</p><p>Click <bold>Match Transaction</bold> and choose the appropriate matching type. Remember to upload all invoices from the previous month between the 1st and 5th of the current month.</p>',
  financials_guide_step_title: 'Financials',
  financials_guide_step_description:
    '<p>In this section you’ll find the core tools to manage your company’s finances:</p><li> • <bold>Banks:</bold> connect and manage your corporate bank accounts.</li><li> • <bold>Sales and Purchases:</bold> upload and manage your sales and purchase invoices.</li><li> • <bold>Transactions:</bold> review and manage all your bank transactions.</li>',
  my_busisness_guide_step_title: 'My Business',
  my_busisness_guide_step_description:
    '<li>• <bold>Business Info:</bold> core company details.</li><li>• <bold>Customers:</bold> view, add, and manage your clients.</li><li>• <bold>Contractors:</bold> view, add, and manage external collaborators.</li><li>• <bold>Employees:</bold> hire and manage staff in 80+ countries.</li><li>• <bold>Travels:</bold> manage corporate trips.</li><li>• <bold>Agreements:</bold> handle loans.</li>',
  reports_guide_step_title: 'Reports',
  reports_guide_step_description:
    '<p>Here you’ll find two key sections:</p><li>• <bold>Accounting Reports:</bold> track the status of your reports and check detailed information.</li><li>• <bold>Annual Report:</bold> consult its status, review details, or access past years.</li><p>Stay compliant with everything in one place.</p>',
  end_tour_modal_title: 'Thanks for joining the tour!',
  end_tour_modal_description:
    '<p>We hope this walkthrough has helped you discover the essentials of your all-in-one accounting dashboard.</p><p>Want to dive deeper? <bold>Explore each section in detail through the Dashboard Walkthrough button</bold> on your home screen, where you’ll find step-by-step video tutorials.</p><p>And remember, if you ever need help, our team is just a message away in <a>the chat</a>.</p>',
  finish_tour_button: 'Finish tour',
  need_more_details: '<p>Need more details? <a><bold>Watch the video tutorial</bold></a></p>',
  dont_show_walkthrough: "Don't show again",

  // Dashboard Walkthrough
  page_title_dashboard_walkthrough: 'Back to Home',
  dashboard_walkthrough_page: 'Dashboard Walkthrough',
  create_new_invoices: 'Create new invoices',
  connecting_banks: 'Connecting banks',
  amazon_fba: 'Amazon FBA',
  getting_started_video_title: 'Getting Started with Your Companio Dashboard',
  getting_started_video_description:
    'In this video, you’ll learn how to use the “Home” section of your all-in-one accounting dashboard.',
  manage_sales_invoice_video_title: 'How to Manage Your Sales Invoices',
  manage_sales_invoice_video_description:
    'In this video, you’ll learn how to use the “Sales” section of your all-in-one accounting dashboard',
  use_accounting_section_video_title: 'Stay Compliant, Accurate and Organized',
  use_accounting_section_video_description:
    'In this video, you’ll learn how to use the “Accounting” section of your all-in-one dashboard',
  manage_international_employees_video_title: 'How to Manage International Employees',
  manage_international_employees_video_description:
    'In this video, you’ll learn how to use the “Employees” section of your all-in-one accounting dashboard',
  manage_contractors_video_title: 'How to Manage Contractors Internationally',
  manage_contractors_video_description:
    'In this video, you’ll learn how to use the “Contractors” section of your all-in-one accounting dashboard',
  manage_busisness_expenses_video_title: 'How to Manage Your Business Expenses',
  manage_busisness_expenses_video_description:
    'In this video, you’ll learn how to use the “Purchases” section of your all-in-one accounting dashboard',
  anual_report_video_title: 'Estonian Annual Report',
  anual_report_video_description:
    'In this video, we guide you through the entire Estonian Annual Report process in Companio 2.0, from payment to final submission. ',

  // Secure download
  your_shared_documents: 'Your shared documents',
  security_code_required: 'Security Code Required',
  enter_security_code_sent_to_email: 'Please enter the security code that was sent to your email',
  enter_the_6_digit_code_sent_to_your_email: 'Enter the 6-digit code we sent to your email.',
  verifying_code: 'Verifying code...',
  code_verified_successfully: 'Verification successful. You can now download your documents.',
  invalid_security_code: 'Invalid security code. Please try again.',
  creation_date: 'Creation date',
  who_sent_it: 'Who sent it',
  download_document: 'Download document',
  download_selected: 'Download selected',
  error_loading_documents: 'Error loading documents. Please try again.',
  no_documents_shared: 'No documents have been shared with you.',
  financial_periods: 'Financial periods',
  verify: 'Verify',
  having_troubles: 'Having troubles?',
  get_help: 'Get help',
  security_code_resent_successfully: 'Security code has been resent to your email',
  error_resending_security_code: 'Error resending security code. Please try again.',
  please_wait_before_requesting_new_code: 'Please wait before requesting a new code',

  // Sales/Purchases Page
  sales_table_title: 'Sales invoices',
  purchases_table_title: 'Purchases invoices',
  invoices_table_header_name: 'Document name',
  invoices_table_header_date: 'Date',
  invoices_table_header_status: 'Status',
  invoices_table_header_transaction: 'Transaction',
  invoices_table_header_out_of_pocket: 'Out of pocket',
  invoices_table_header_bulk_actions: 'Bulk actions',
  sales_table_header_multi_button: 'Add invoice',
  purchases_table_header_add_invoice_button: 'Add invoice',
  invoices_filter_uploaded: 'Uploaded',
  invoices_filter_processing: 'Processing',
  invoices_filter_processed: 'Processed',
  invoices_filter_rejected: 'Rejected',
  invoices_filter_matched: 'Matched',
  invoices_filter_unmatched: 'Unmatched',
  invoices_table_header_create_new_invoice: 'Create new invoice',
  invoices_table_header_import_amazon: 'Import Amazon sales',
  invoices_table_header_import_sales: 'Import sales from CSV',
  invoices_table_header_upload_invoices: 'Upload invoices',
  invoice_status_uploaded: 'Uploaded',
  invoice_status_processing: 'Processing',
  invoice_status_processed: 'Processed',
  invoice_status_rejected: 'Rejected',
  invoice_status_deleted: 'Deleted',
  invoices_origin: 'From {{company}}. total: {{total}} {{ currency }}',
  invoices_uploaded: 'Uploaded {{ date }}',
  invoices_empty_state: 'No documents were found for this selection. Please, choose another.',
  invoices_transaction_invalid_invoice:
    'AI detected this as an invalid invoice, no invoice number, no seller info, no buyer...',
  invoices_transaction_button_link: 'Link',
  invoices_table_options_edit: 'Edit',
  invoices_table_options_download: 'Download',
  invoices_table_options_change_type: 'Edit type',
  invoices_table_options_move_to: 'Move to {{ date }}',
  invoices_table_options_move_to_pending: 'Updating documents date...',
  invoices_table_options_move_to_success: 'Documents date updated successfully.',
  invoices_table_options_move_to_error: 'There was an error while updating the documents date.',
  invoices_table_options_mark_as_out_of_pocket: 'Mark as out of pocket',
  invoices_table_options_remove_out_of_pocket: 'Remove out of pocket',
  invoices_table_options_edit_name: 'Edit name',
  invoices_table_options_edit_description: 'Edit description',
  sales_table_why_rejected: 'Why was it rejected?',
  invoices_table_options_replace: 'Replace with correct document',
  invoices_table_options_match: 'Match with transaction',
  invoices_table_options_unmatch: 'Unmatch',
  invoices_table_options_clone_invoice: 'Clone invoice',
  invoices_table_options_delete: 'Delete',
  cannot_delete_matched_invoice: 'Cannot delete a matched invoice. Please unmatch it first.',
  invoice_date_update_pending: 'Updating document date...',
  invoice_date_update_success: 'Document date updated successfully.',
  invoice_date_update_error: 'There was an error while updating the document date.',
  invoice_out_of_pocket_pending: 'Updating document ...',
  invoice_out_of_pocket_success: 'The document has been marked as out of pocket.',
  invoice_out_of_pocket_error: 'There was an error while updating the document.',
  sales_invoice_cannot_be_modified_modal_title: 'Invoice cannot be modified',
  sales_invoice_cannot_be_modified_modal_title_multiple: 'Invoices cannot be modified',
  sales_invoice_cannot_be_modified_modal_description_html:
    'This invoice cannot be edited as it has already been included in the accounting books.',
  sales_invoice_cannot_be_modified_modal_description_multiple_html:
    'One or more of the invoices have already been added to the accounting books, please generate a new rectification invoice.',
  sales_invoice_cannot_be_modified_modal_button: 'Ok',
  invoice_description_modal_title: 'Edit description',
  invoice_description_modal_cancel_button: 'Cancel',
  invoice_description_modal_save_button: 'Save',
  invoice_description_modal_input_placeholder: 'Max {{ characters }} char.',
  invoice_description_modal_pending: 'Updating documents description.',
  invoice_description_modal_success: 'Documents description updated successfully.',
  invoice_description_modal_error: 'There was an error while updating the documents description.',
  invoice_description_modal_warning: 'Description is the same as the previous one',
  invoice_update_multiple_pending: 'Updating documents.',
  invoice_update_multiple_success: 'Documents updated successfully.',
  invoice_update_multiple_error: 'There was an error while updating the documents.',
  invoice_name_modal_title: 'Edit name',
  invoice_name_modal_cancel_button: 'Cancel',
  invoice_name_modal_save_button: 'Save',
  invoice_name_modal_input_placeholder: 'Enter the new document name here',
  invoice_name_modal_warning:
    'Document name is the same as the previous one, please enter a new name.',
  invoice_name_modal_pending: 'Updating document name...',
  invoice_name_modal_success: 'Document name updated successfully.',
  invoice_name_modal_error: 'There was an error while updating the document name.',
  invoice_type_modal_title: 'Edit type',
  invoice_type_modal_pending: 'Updating document type',
  invoice_type_modal_success: 'Document type updated successfully.',
  invoice_type_modal_error: 'An error occurred while updating the document type.',
  invoice_type_modal_warning_same_type: 'Type selected is the same as the previous one.',
  invoice_type_modal_description: 'Select a new type',
  invoice_type_modal_cancel_button: 'Cancel',
  invoice_type_modal_confirm_button: 'Confirm',
  delete_invoice_modal_title: 'Confirm deletion',
  delete_invoice_modal_description_single:
    'Are you sure you want to delete this document? This action cannot be undone. Once deleted, you will not be able to upload the document again, as our system remembers a digital fingerprint of the file to prevent for duplicate submissions.',
  delete_invoice_modal_description_multiple:
    'Please, confirm that you want to delete the following documents:',
  delete_invoice_modal_cancel_button: 'Cancel',
  delete_invoice_modal_confirm_button: 'Confirm',
  delete_invoice_modal_pending: 'Deleting document(s)...',
  delete_invoice_modal_success: 'The document(s) were deleted successfully',
  delete_invoice_modal_error: 'There was an error while deleting the document(s)',
  sales_upload_invoice_modal_title: 'Upload invoices',
  sales_upload_invoice_modal_description:
    'Effortlessly upload your invoices by dragging and dropping them here. Click to select files. Streamline your process with Companio.',
  sales_upload_invoice_modal_drop_files_description: 'You can also drop your files here',
  sales_upload_invoice_modal_cancel_button: 'Cancel',
  sales_upload_invoice_modal_add_button: 'Add',
  sales_import_from_csv_modal_premium_alert_title:
    'Upgrade to PREMIUM to Unlock CSV Invoice Import!',
  sales_import_from_csv_modal_premium_alert_description_html:
    "If you wish to avail of this feature, you'll need to upgrade to our PREMIUM plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  sales_import_from_csv_modal_premium_alert_reject_button: 'No, thanks',
  sales_import_from_csv_modal_premium_alert_upgrade_button: 'Yes, upgrade',
  sales_import_from_csv_modal_title: 'Import CSV file',
  sales_import_from_csv_modal_description_html:
    'Our Import functionality allows you to import multiple sales invoices from a CSV with a specific format <a target="_blank" rel="noreferrer" href="https://api.companio.co/uploads/files/companio_csv_upload_template.csv" download>click here to download a sample file</a>.',
  sales_import_from_csv_modal_drop_files_description: 'Upload a valid CSV file to begin',
  sales_import_from_csv_modal_conversion_error_html:
    'Oops! Some documents could not be converted correctly 😓, we recommend that you re-upload them.',
  sales_import_from_csv_modal_conversion_error_html_2:
    ' Detailed error information is available in the ',
  sales_import_from_csv_modal_conversion_step_1: 'Read file contents successfully',
  sales_import_from_csv_modal_conversion_step_2: 'Checking required header information',
  sales_import_from_csv_modal_conversion_step_3: 'Checking required rows information',
  sales_import_from_csv_modal_conversion_step_4: 'Extracting number of sales in document',
  sales_import_from_csv_modal_conversion_step_5: 'Generating invoices from CSV',
  sales_import_from_csv_modal_conversion_not_started: 'Not started',
  sales_import_from_csv_modal_conversion_in_progress: 'In progress',
  sales_import_from_csv_modal_conversion_done: 'Done',
  sales_import_from_csv_modal_conversion_error: 'Error',
  sales_import_from_csv_modal_conversion_sales_found: '{{ totalSales }} sales found',
  sales_import_from_csv_modal_completed_title: 'Invoices CSV Import completed',
  sales_import_from_csv_modal_completed_description:
    '{{ successfully_converted_files }} of {{ total_files }} invoices imported. You can close this window now.',
  sales_import_from_csv_modal_completed_button: 'Ok',
  sales_import_from_csv_modal_partial_import_alert_title: 'Partial Conversion Alert',
  sales_import_from_csv_modal_partial_import_alert_message_details:
    'Detailed error information is available in the <0>Download report</0>.',
  invoices_table_options_match_as_net: 'Match as net settlement',
  invoices_filter_deleted: 'Deleted',
  invoices_table_options_appeal: 'Appeal rejection',
  invoices_transaction_rejected_confirmed:
    'Our accounting department has confirmed the rejection of this document...',
  rejected_reason_modal_title: 'Why was it rejected?',
  rejected_reason_modal_description_one: 'This document was rejected for the following reasons:',
  rejected_reason_modal_description_two:
    'Correct and replace the invoice following <a href="https://help.companio.co/en/article/what-can-i-do-if-my-invoice-has-been-rejected-1phv6eb/" target="_blank" rel="noreferrer" >this step-by-step tutorial</a>.',
  rejected_reason_modal_description_three:
    'If the invoice <strong style="font-weight: bold">has been automatically rejected </strong> by the system and you believe it to be correct, you can appeal the rejection by following <a href="https://help.companio.co/en/article/how-to-appeal-the-rejection-of-a-document-in-companio-7aikj8/" target="_blank" rel="noreferrer">this tutorial</a>.',
  rejected_reason_modal_description_four:
    'If the invoice <strong style="font-weight: bold">has been rejected by the accounting team</strong>, it must always be corrected and replaced.',
  rejection_unknown_reason: 'The document does not meet the requirements for a valid invoice.',
  rejection_ai_algorithm:
    'After analyzing the document, our AI algorithm thinks this is not really a valid invoice',
  rejection_many_items: 'Too many items in the document, it looks like a list of payments',
  rejection_no_invoice_number: 'There is no invoice number in this document',
  rejection_no_issue_date: 'There is no issue date in this document',
  rejection_no_buyer_info: 'There is no buyer info in this document',
  rejection_no_seller_info: 'There is not seller info in this document',
  rejection_unreadable_document: 'The document is either in an unsupported format or is unreadable',
  rejection_duplicate_invoice:
    'This invoice has already been uploaded and processed, no need to process it twice',
  rejection_wrong_vat: 'The specified VAT amount is incorrect',
  rejection_wrong_amounts:
    "There's a discrepancy between the subtotal from items plus VAT and the total amount",
  replace_document_pending: 'Replacing document, please wait...',
  replace_document_success: 'Document successfully replaced',
  appeal_rejection_modal_title: 'Let us know why we should accept this document',
  appeal_rejection_not_filled_warning: 'Please fill out the reason for the appeal rejection',
  appeal_rejection_sent_success_modal_title: 'We’ve received your appeal!',
  appeal_rejection_sent_success_modal_description:
    'Thanks for providing more details. Your request has been forwarded to the accountant and we’ll notify you as soon as there’s an update.',
  unlink_entity_from_matching_by_transaction_id_pending: 'Unmatching document, please wait...',
  unlink_entity_from_matching_by_transaction_id_success: 'Document successfully unmatched',
  sales_to_estonia: 'Sales to Estonia',
  no_tag_selected: 'No Tag Selected',
  sales_vat_exempt: 'Sales VAT exempt',
  unlink_documents_confirm_modal_title: 'Wait! This action will unlink these documents',
  unlink_documents_confirm_modal_description:
    'Changing the type of these documents will unlink them from the transactions. Are you sure you want to continue?',
  invoices_table_options_out_of_pocket: 'Out of pocket',
  sales_upload_pdf_image: 'Upload a valid PDF, PNG or JPG file to begin',
  fiscal_month: 'Month',
  current_month: 'Current month',
  last_month: 'Previous month',
  csv_unsuccessfull_download_error:
    'An unexpected error occurred while trying to download the csv file.',
  import_amazon_sales_error_modal_title: 'Oops! something went wrong 😓',
  import_amazon_sales_error_modal_description:
    'A verification error has occurred with the CSV columns. Please review the CSV structure and retry.',
  error_processing_the_csv_file:
    'A processing error has occurred with the CSV file. Please attempt the operation again later.',
  csv_headers_malformed:
    'The CSV headers appear malformed. Please verify the document’s integrity and resubmit.',
  amazon_csv_error_item: 'An error occurred while processing the sale',
  advanced_search_title: 'Search filters',
  time_range: 'Issue date',
  counterparty: 'Counterparty',
  invoice_total: 'Invoice total',
  advanced_search: 'Advanced search',
  invoicing_edit_title: 'Edit invoice',
  invoicing_edit_alert:
    'Please review all data before editing the invoice. You can see a preview by clicking on the "Preview invoice" button below.',
  updating_invoice_loading: 'Updating invoice, please wait...',
  updating_invoice_success: 'Invoice successfully updated',
  invoicing_button_update_invoice: 'Update invoice',
  invoicing_edit_success_modal_title: 'Invoice successfully edited',
  invoicing_edit_success_modal_description: 'Your invoice has been successfully edited.',
  generate_pro_forma: 'Generate Pro Forma',
  invoicing_generate_pro_forma_pending: 'Generating pro forma invoice, please wait...',
  invoicing_generate_pro_forma_success: 'Pro forma invoice successfully generated',
  updating_document_tag_loading: 'Updating document tag, please wait...',
  document_tag_updated_successfully: 'Document tag successfully updated',
  invoices_table_options_disable_reminder: 'Disable invoice reminders',
  invoices_table_options_enable_reminder: 'Enable invoice reminders',
  enabling_reminder_loading: 'Enabling reminder, please wait...',
  enabling_reminder_success: 'Reminder successfully enabled',
  removing_reminder_loading: 'Removing reminder, please wait...',
  removing_reminder_success: 'Reminder successfully removed',
  advanced_search_note:
    'Advanced search only works with documents that have already been analyzed by our platform.',
  sales_import_from_csv_modal_description_html_2:
    'Use the Import functionality following <a href="https://help.companio.co/en/article/how-to-import-your-invoices-in-companio-with-the-automatic-csv-invoice-import-functionality-1mrd6mr/" target="_blank" rel="noreferrer">this step-by-step tutorial</a>.',
  sales_upload_invoice_modal_close_button: 'Close',
  import_amazon_sales_modal_premium_alert_title:
    'Upgrade to PREMIUM to Unlock Amazon Sales Import!',
  import_amazon_sales_modal_premium_alert_description_html:
    'To access this feature, please upgrade to our PREMIUM plan. For details on monthly pricing, visit our  <a href="https://companio.co/pricing/" target="_blank" rel="noreferrer">Pricing Page</a>. Ready to upgrade?',
  tag: 'Tag',
  sales_upload_invoice_modal_dismiss_button: 'Dismiss',
  sales_upload_invoice_modal_uploading_files:
    'Uploading 1 - Uploaded {{filesUploaded}} of {{filesToUpload}} successfully',
  sales_upload_invoice_modal_uploaded_files:
    'Uploaded {{filesUploaded}} of {{filesToUpload}} successfully',
  sales_upload_invoice_modal_uploaded_files_failed: '- {{filesFailed}} failed',
  upload_again: 'Upload again',
  generated_date: 'Generated {{date}}',
  back_to_invoicing: 'Back to Invoicing',
  email_dropbox_banner_description:
    'To add documents to this section, you can also send them to the following email: <strong style="font-weight: bold">{{email}}</strong>. Your automated invoice Dropbox email is always available in <strong style="font-weight: bold">Settings > Automation</strong>.',
  email_dropbox_notification_dont_show_me_again: 'Don’t show me again',
  advanced_search_sales_table_title: 'Advanced search: Sales invoices',
  advanced_search_purchases_table_title: 'Advanced search: Purchase invoices',
  select_tag: 'Select tag',
  document_tooltip_description:
    '<strong style="font-weight: bold">Description: </strong>{{description}}',
  document_tooltip_from: '<strong style="font-weight: bold">From: </strong>{{counterparty}}',
  invoice_out_of_pocket_unmarked_success: 'The document has been unmarked as out of pocket.',
  back_to_customers: 'Back to Customers',
  document_tooltip_to: '<strong style="font-weight: bold">To: </strong>{{counterparty}}',
  hide_closed_bank_accounts: 'Hide closed bank accounts',
  hide_balances: 'Hide balances',
  invoice_regular: 'Regular',
  invoice_savings: 'Savings',
  invoice_preview_unauthorized: 'Unauthorized JSON response',
  invoice_preview_network_not_ok_error: 'Network response was not ok',
  confirm_delete_invoice_modal_title: 'You are about to delete this invoice(s)',
  invoices_table_options_can_not_move: 'Cannot be moved anymore',
  sales_import_from_csv_modal_friendly_messages_title: 'Unable to import the CSV',
  sales_import_from_csv_modal_friendly_messages_description:
    'Some of the required fields were not properly filled according to the <a href="https://help.companio.co/en/article/how-to-import-your-invoices-in-companio-with-the-automatic-csv-invoice-import-functionality-1mrd6mr/" target="_blank" rel="noreferrer">manual</a>, find below the wrong columns:',
  sales_import_from_csv_modal_friendly_messages_error: '<strong>Reason: </strong>{{error}}',
  sales_import_from_csv_modal_friendly_messages_instruction:
    '<strong>Instruction: </strong>Our Import functionality allows you to import multiple sales invoices from a CSV with a specific format. Download the template <a href="https://api.companio.co/uploads/files/companio_csv_upload_template.csv">here</a> and adjust it as needed before uploading again.',
  invoice_table_bulk_action_match_all_with_transaction: 'Match all with transaction',
  selected_documents_already_matched_error:
    'Some selected items are already matched. Please uncheck or unmatch them to continue.',
  none_selected_documents_error:
    'No documents selected. Please select at least one document to continue.',
  no_documents_selected_for_matching:
    'No documents selected for matching were found. Please return to the previous page and try again.',
  matching_type_not_found:
    'Matching type not found. Please return to the previous page and try again.',
  selected_documents_have_blocking_status_error:
    'Some selected items have a blocking status, as REJECTED or DELETED. Please uncheck them to continue.',
  invoice_not_parsed: 'No data parsed from the invoice.',
  search_documents_by: 'Search by name, description, tag or amount',
  unparsed_document_modal_description:
    'It seems the contents of file cannot be read or analyzed. Would you like to download it?',
  failed_to_read_document: "This file couldn't be read",

  // Invoicing Page
  invoicing_step_label_data: 'Invoice data',
  invoicing_step_label_items: 'Invoice items',
  invoicing_step_label_summary: 'Summary',
  invoicing_step_title: 'Create new invoice',
  invoicing_field_customer: 'Customer',
  invoicing_field_full_name: 'Full Name',
  invoicing_field_address: 'Address',
  invoicing_field_tax_id: 'Registry number',
  invoicing_field_vat_number: 'Vat number',
  invoicing_field_country: 'Country',
  invoicing_field_subject: 'Subject',
  invoicing_field_invoice_number: 'Invoice number',
  invoicing_field_currency: 'Currency',
  invoicing_field_currency_rate: 'Currency Rate',
  invoicing_field_issue_date: 'Issue Date',
  invoicing_field_due_date: 'Due Date',
  invoicing_field_transaction_date: 'Transaction Date',
  invoicing_field_penalty: 'Apply late payment penalty ',
  invoicing_field_penalty_tooltip: "(What's this?)",
  invoicing_field_penalty_tooltip_content:
    'This will add a penalty clause to your invoice of 0.5% per day of late payment after the due date. That means you can claim an extra 0.5% increase in the cost of the products or services sold per day of late payment to your customer, but it is your responsibility to claim it.',
  invoicing_field_pro_forma: 'This is a pro forma invoice',
  invoicing_field_instructions: 'Custom payment instructions',
  invoicing_field_instructions_tooltip: "(What's this?)",
  invoicing_field_instructions_tooltip_content:
    "Here you can add custom payment instructions for this specific invoice. If you don't write anything here, the client's payment instructions will appear if they have been defined for this client, or otherwise, the global payment instructions defined in settings will be applied (if any).",
  invoicing_button_go_back: 'Go back',
  invoicing_button_next_step: 'Next step',
  invoicing_button_add_invoice: 'Add invoice',
  invoicing_button_preview_invoice: 'Preview invoice',
  invoicing_item_title_open: 'Item {{ index }}',
  invoicing_item_title_closed:
    'Item {{ index }}: {{ name }}, {{ cost }}, VAT {{ vat }}, VAT Amount {{ vatAmount }}, total {{ totalPrice }}.',
  invoicing_field_description: 'Description',
  invoicing_field_quantity: 'Quantity',
  invoicing_field_vat: 'VAT',
  invoicing_field_price: 'Price',
  invoicing_field_subtotal: 'Subtotal',
  invoicing_field_vat_amount: 'VAT Amount',
  invoicing_field_total: 'Total',
  invoicing_button_add_item: 'Add another item',
  invoicing_button_delete_item: 'Delete',
  invoicing_summary_alert:
    'Please review all data before generating the invoice. You can see a preview by clicking on the "Preview invoice" button below.',
  invoicing_summary_data_of_the_buyer: 'Data of the buyer',
  invoicing_summary_invoice_data: 'Invoice data',
  invoicing_summary_invoice_items: 'Invoice items',
  invoicing_summary_total: 'Total (Including VAT)',
  invoicing_sellers_data: 'Seller’s data',
  invoicing_invoice_data: 'Invoice data',
  invoicing_add_more: 'Add more',
  invoicing_total_section: 'Total (Including VAT)',
  invoicing_update_button: 'Update',
  invoicing_no_customers_found: 'No customers found',
  add_new_customer: 'Add new customer',
  invoicing_preview_pending: 'Generating invoice preview...',
  invoicing_preview_success: 'Invoice preview successfully generated',
  invoicing_preview_error: 'Failed to generate invoice preview',
  invoicing_add_pending: 'Creating invoice, please wait...',
  invoicing_add_success:
    'Invoice successfully generated. <0>Send email to customer {{ name }} ({{ email }})</0> or <1>download it</1>.',
  invoicing_add_error: 'Failed to generate new invoice',
  invoicing_email_pending: 'Sending email, please wait...',
  invoicing_email_sent: 'The invoice was successfully sent to the email address',
  invoicing_email_error: 'There was an error sending the email',
  invoicing_field_penalty_rate: 'Penalty rate %',
  invoicing_field_penalty_interval: 'Penalty interval',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  penalty_rate_info: 'Late penalty ({{rate}}% after due date): ',
  penalty_rate_info_description: 'Total {{total}}.',
  invoicing_field_invoice_template: 'Invoice template',
  modern: 'Modern',
  bold: 'Bold',
  tekkie: 'Tekkie',
  elegant: 'Elegant',
  vibrant: 'Vibrant',
  default: 'Default',
  invoicing_field_pro_forma_info: '(What’s this?)',
  pro_forma_info_modal_title: 'Important Information About Pro Forma Invoices',
  pro_forma_info_modal_description_one:
    'A Pro Forma invoice is a preliminary document that provides an estimation of the transaction details, including the total payable amount before goods or services are provided. It’s a non-binding agreement to help you and your customer foresee the transaction.',
  pro_forma_info_modal_description_two:
    'This invoice is for <strong style="font-weight: bold">visualization purposes only</strong> and will not be stored in the system with other sales invoices. It will not be included in your accounting records or the sales section. You can download it for reference, but <strong style="font-weight: bold">it will not be saved in the system.</strong>',
  preview_template: 'Preview template',
  invoicing_add_success_modal_title: 'Invoice successfully generated',
  invoicing_add_success_modal_description: 'Invoice successfully generated.',
  invoicing_add_success_modal_description_email_button: 'Send email to customer {{ name }}',
  invoicing_add_success_modal_description_email: '({{email}}) or ',
  invoicing_add_success_modal_description_download_button: 'download it.',
  email_dropbox_notification_please_note: 'Please note',
  email_dropbox_notification_body:
    'To add documents to this section, you can also send them to the following email:',
  email_dropbox_notification_dont_show_again: 'Don’t show again',
  email_dropbox_notification_dismiss: 'Dismiss',
  email_dropbox_notification_email_copied: 'Email copied to clipboard!',
  invoice_parsing_details_failed_to_load: 'Failed to load invoice preview',
  invoice_data: 'Invoice data',
  payment_info: 'Payment information',
  parsing_document_loading: 'Parsing document, please wait...',
  parsing_document_success: 'Document parsed successfully',
  add_payment_reminders: 'Add payment reminders',
  frequency_of_reminder: 'Frequency of reminders',
  message_of_reminder: 'Message',
  payment_reminders_modal_title: 'Set reminders',
  update_vat_number_modal_title: 'Update VAT number',
  update_vat_number_modal_description:
    'You can update or remove this customer’s VAT number. <strong>Please choose how you’d like to proceed.</strong>',
  update_vat_number_modal_option_change: 'Change it',
  update_vat_number_modal_option_change_subtitle:
    'VAT numbers usually start with a 2-letter country code (e.g. ESXXXXXXXXX or FRXXXXXXXXX)',
  update_vat_number_modal_option_remove: 'Remove it',
  update_vat_number_modal_option_remove_subtitle: 'This customer no longer has a valid VAT number.',
  update_vat_number_modal_error_description:
    '<strong>This VAT number may be incorrect.</strong> Verify it  <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noopener noreferrer">here</a> to avoid accounting and compliance issues, and make sure it belongs to your customer before continuing.',
  update_vat_number_modal_success_description:
    '<strong>This VAT number is correct.</strong> You can proceed with the update.',
  update_vat_number_modal_placeholder: 'Enter VAT number',

  invoicing_table_title: 'Generated invoices',
  invoicing_table_add_buttonn: 'New invoice',
  invoicing_invoice_info: 'Invoice info',
  invoicing_invoice_info_number: 'Invoice {{ number }}',
  invoicing_invoice_info_number_not_parsed: 'Invoice',
  invoicing_invoice_date: 'Dates',
  invoicing_vat_info_vat_amount: 'Amount: ',
  invoicing_vat_info_vat_rate: 'Rate: ',
  invoicing_vat_info: 'VAT info',
  invoicing_customer_vat_number: 'VAT Number: {{ vatNumber }}',
  invoicing_customer: 'Customer',
  invoicing_total: 'Total',
  invoicing_table_options_resend: 'Send via email',
  invoicing_table_options_edit: 'Edit',
  invoicing_table_options_download: 'Download',
  all_clients_placeholder: 'All customers',
  payment_reminder_added_modal_title: 'Reminder added!',
  payment_reminder_added_modal_description:
    'We’ll make sure your client gets regular updates until they complete the payment.',
  invoice_template: 'Invoice template selected',
  edit_customer: 'Update info',
  change_customer_invoice_template: 'Change invoice template',
  delete_customer: 'Delete',
  customer_details_is_not_company: 'This customer is not a company',
  delete_customer_modal_title: 'Please confirm customer elimination',
  delete_customer_modal_description:
    'Are you sure you want to delete this customer? This action cannot be undone.',
  delete_customer_success_modal_title: 'The customer has been removed',
  delete_customer_success_modal_description:
    'If you want to have that client back on your list, you will have to add it again.',
  customer_updated_success_modal_title: 'Customer successfully updated!',
  customer_updated_success_modal_description:
    'The customer’s information has been updated successfully. You can now continue issuing and sending invoices to them.',
  customer_added_success_modal_title: 'Customer successfully added!',
  customer_added_success_modal_description:
    'The customer’s information has been added successfully. You can now start issuing and sending invoices to them',
  customer_update_template_modal_title: 'Update invoice template',
  customer_update_template_modal_description:
    'This template will be used every time you create a new invoice for this client.',
  invoice_templates: 'Invoice templates',
  preview: 'Preview',
  invoice_template_changed_pending: 'Updating invoice template, please wait...',
  invoice_template_successful_changed_modal_title: 'Template successfully updated!',
  invoice_template_successful_changed_modal_description:
    'The invoice template for {{customerName}} has been successfully updated. All future invoices will automatically use the new design',
  confirm_invoice_number_decrease_modal_title: 'Warning: Previous Invoice Number',
  confirm_invoice_number_decrease_modal_description:
    'You’re trying to use an invoice number that’s lower than one you’ve already used. You should only do this if you’re absolutely sure that there’s no other invoice with the same number. <strong style="font-weight: bold">Using duplicate invoice numbers can cause issues with the Estonian tax authorities.</strong> Are you sure you want to continue?',
  rejection_vat_number_invalid: 'The VAT number is not valid or missing',
  issue_date_column: 'Issued: {{date}}',
  uploaded_date_column: 'Uploaded: {{date}}',
  invoicing_field_supplier: 'Supplier',
  invoicing_field_instructions_supplier: 'Supplier payment instructions',
  invoices_table_options_associate_to_contractor: 'Associate to contractor',
  associate_to_contractor_modal_title: 'Associate invoice to contractor',
  associate_to_contractor_modal_description: 'Please select a contractor for this invoice.',
  associate_to_contractor_modal_table_header_description: 'Description',
  associate_to_contractor_modal_table_header_date: 'Date',
  associate_to_contractor_modal_table_header_total: 'Total',
  associate_to_contractor_modal_select_contractor_label: 'Contractor',
  confirm_associate_invoice_to_contractor_modal_title: 'You are about to associate this invoice',
  confirm_associate_invoice_to_contractor_modal_description:
    'Before proceeding, are you sure you want to associate the invoice to the contractor <strong style="font-weight: bold">{{contractorName}}</strong>?',
  contractor_not_selected_error: 'Please select a contractor to proceed',
  invoice_associate_to_contractor_success: 'The invoice has been successfully associated.',
  invoice_associate_to_contractor_success_description:
    'You can now view it in the contractor’s profile.',
  associating_invoice_to_contractor_loading: 'Associating invoice to contractor, please wait...',
  confirm_invoice_belongs_to_another_contractor_modal_title:
    'It seems that this invoice belongs to another contractor',
  confirm_invoice_belongs_to_another_contractor_modal_description:
    'Our system thinks this invoice belongs to a contractor named "{{invoiceContractorName}}" (Tax ID {{invoiceContractorTaxId}}), but the contractor you chose is "{{selectedContractorName}}" (tax ID {{selectedContractorTaxId}}). <strong style="font-weight: bold">Are you sure you want to continue and associate the invoice to contractor "{{selectedContractorName}}"?</strong>',
  invoices_table_options_detach_from_contractor: 'Detach from contractor',
  detach_invoice_from_contractor_modal_title: 'You are about to detach this invoice',
  detach_invoice_from_contractor_modal_description:
    'Before proceeding, are you sure you want to detach the invoice from the contractor <strong style="font-weight: bold">{{contractorName}}</strong>?',
  detaching_invoice_from_contractor_loading: 'Detaching invoice from contractor, please wait...',
  detaching_invoice_from_contractor_success:
    'The invoice has been successfully detached from the contractor.',
  confirm_leave_invoicing_page_modal_title: 'Are you sure you want to leave this invoice?',
  confirm_leave_invoicing_page_modal_description:
    'If you go back, all entered information will be lost, and you’ll need to re-enter it to create the invoice.',
  custom_payment_instructions_modal_title: 'Custom Payment Instructions',
  custom_payment_instructions_modal_description_row_one:
    'In this field, you can enter specific payment instructions for the selected invoice. If no information is provided, the system will automatically apply the customer’s default payment instructions (if defined).',
  custom_payment_instructions_modal_description_row_two:
    'If no customer-specific instructions are available, the global payment instructions configured in Settings will be used.',
  late_penalty_instructions_modal_title: 'Apply late payment penalty',
  late_penalty_instructions_modal_description_row_one:
    'This option adds a late payment penalty clause to the invoice.',
  late_penalty_instructions_modal_description_row_two:
    'The penalty amount is determined by the value specified in the Penalty Rate field and applied according to the interval defined in the Penalty Interval field, starting after the due date.',
  late_penalty_instructions_modal_description_row_three:
    'This allows you to charge an additional fee on the products or services sold for each late payment interval.',
  late_penalty_instructions_modal_description_row_four:
    'Please note that <strong style="font-weight: bold">it is your responsibility to claim this additional payment.</strong>',
  choose_customer_first_placeholder: 'Choose a customer first',
  payment_reminders_modal_description:
    'By setting up a reminder, your client will automatically receive periodic notifications until the invoice is fully paid.',
  schedule: 'Schedule',
  invoicing_step_one_title: 'Invoice data',
  invoicing_step_two_title: 'Invoice items',
  invoicing_step_three_title: 'Summary',
  invoicing_no_customers_alert:
    'You don’t have any customers yet. Add one in My Business → <a href="/customers">Customers</a> to start creating invoices.',
  invoice_total_quantity: 'Quantity:',
  invoice_total_vat: 'VAT:',
  invoice_total_vat_amount: 'VAT Amount:',
  invoice_total_price: 'Total Amount:',
  invoice_total_title: 'Total',
  checking_vat: 'Checking customer VAT',
  not_valid_vat_modal_title: 'The VAT for this customer is no longer valid',
  not_valid_vat_modal_description_row_one:
    'The VAT number <strong> {{vatNumber}} </strong> for this customer no longer appears as valid in the <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noreferrer">VIES registry </a>. Continuing with outdated VAT details may result in invoice rejection or accounting issues.',
  not_valid_vat_modal_description_row_two:
    'Do you want to update the VAT information now before proceeding?',
  update_vat: 'Update VAT',
  vat_number_updated_successfully: 'VAT number updated successfully',
  vat_check_success: 'VAT number validated successfully',
  vat_wizard_modal_title: 'VAT Wizard',
  vat_wizard_modal_description:
    '<p>Not sure which VAT rate to apply? You’re not alone. This quick guide will help you find the correct VAT for your invoice based on a few simple questions.</p><p>It only takes a moment. <strong>Let’s start with a simple question to guide you in the right direction.</strong></p>',
  vat_wizard_first_option: 'Yes, I have a valid VAT number',
  vat_wizard_second_option: "No, I don't have a valid VAT number",
  has_valid_vat_number_label: 'Does your business have a valid VAT number?',
  vat_wizard_has_vat_description:
    '<p>Great. Now let’s look at where your client is located, this helps us determine the correct VAT rules.</p>',
  vat_wizard_has_vat_select_label: 'Where is your client located?',
  country_of_company_option: 'In',
  another_eu_country_option: 'In another EU country',
  outside_eu_option: 'Outside the EU',
  same_country_as_company: 'the same country as my business',
  vat_wizard_has_vat_country_of_company_description:
    '<p><strong>Domestic transaction</strong></p><p>Since both your company and your client are in {{countryName}}, this invoice is treated as a local sale.</p><p>👉 The correct VAT rate for this invoice is {{vatRate}}.</p>',
  vat_wizard_has_vat_another_eu_country_description:
    '<p>Almost there. One more detail about your client so we can narrow this down.</p>',
  vat_wizard_has_vat_another_eu_country_select_label: 'Is your client a company or an individual?',
  vat_wizard_eu_individual_option: 'Individual',
  vat_wizard_eu_company_option: 'Company',
  vat_wizard_has_vat_outside_eu_description:
    '<p><strong>Client outside the EU.</strong></p><p>Under EU VAT rules, sales to non-EU countries are treated as exports, so no VAT is added.</p><p>This applies regardless of: <ul><li>whether your client is a company or an individual</li><li>whether your business has a VAT number or not</li></ul></p><p>👉 The correct VAT rate for this invoice is 0%</p>',
  apply_vat: 'Apply VAT',
  restart_vat_wizard_process: 'Reset process',
  vat_wizard_eu_individual_description:
    '<p>Got it. Now let’s check one last detail to determine how VAT should be applied.</p>',
  vat_wizard_eu_company_description:
    '<p>Just one last check to confirm how VAT should be applied.You can verify your client’s VAT number in the <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noreferrer">official VIES registry</a>.</p>',
  vat_wizard_eu_company_select_label: 'Does your client have a valid VAT number?',
  vat_wizard_eu_company_has_vat_option: 'Yes, this client has a valid VAT number',
  vat_wizard_eu_company_no_vat_option: 'No, this client does not have a valid VAT number',
  vat_wizard_eu_company_has_vat_description:
    '<p><strong>EU VAT-registered company.</strong></p><p>As both companies have intra-communiatry VAT numbers from different countries, 0% reverse intra-communitary VAT applies.</p><p>👉 The correct VAT rate for this invoice is 0%</p>',
  vat_wizard_eu_company_no_vat_description:
    '<p><strong>EU company without VAT number.</strong></p><p>Since your client is not VAT-registered, VAT must be charged by the seller.</p><p>👉 The correct VAT rate for this invoice is {{countryName}} VAT: {{vatRate}}</p>',
  vat_wizard_no_vat_description:
    '<p>Got it. Now let’s understand the nature of this transaction — this helps us determine whether VAT applies at all.</p>',
  vat_wizard_button: 'VAT Wizard',
  same_country_option: 'Same country as my busisness',
  different_country_eu_option: 'A different country in the EU',
  vat_wizard_no_vat_outside_eu_description:
    '<p><strong>0% VAT applies</strong></p><p>Since your business does not have a valid EU VAT number and this transaction is an export (outside the EU), export rules apply.</p><p>👉 The correct VAT rate in this case is 0%</p>',
  vat_wizard_no_vat_same_country_description:
    '<p><strong>No VAT applies</strong></p><p>Since your business does not have a valid EU VAT number and this transaction is not an export, VAT should not be applied.</p><p>The only exception is for Spanish businesses invoicing within Spain, where Spanish IVA may apply.</p><p>👉 The correct option in this case is “No VAT”.</p>',
  vat_wizard_no_vat_different_country_eu_description:
    '<p><strong>No VAT applies</strong></p><p>Since your business does not have a valid EU VAT number and this transaction is not an export, VAT should not be applied.</p><p>The only exception is for Spanish businesses invoicing within Spain, where Spanish IVA may apply.</p><p>👉 The correct option in this case is “No VAT”.</p>',
  vat_wizard_eu_individual_select_label:
    'Is your business registered for the One-Stop Shop (OSS) scheme?',
  vat_wizard_eu_individual_has_oss_option: 'Yes',
  vat_wizard_eu_individual_no_oss_option: 'No',
  vat_wizard_eu_individual_has_oss_description:
    '<p><strong>OSS VAT applies</strong></p><p>When invoicing an individual (not a company) in the EU under the OSS scheme, VAT must be charged based on the customer’s country.</p><p>👉 Please select your client’s country from the dropdown to apply the correct VAT rate.</p>',
  vat_wizard_eu_individual_has_oss_select_label: '',
  vat_wizard_eu_individual_no_oss_description:
    '<p><strong>Standard VAT applies</strong></p><p>When invoicing an individual (not a company) in the EU, VAT must be charged from the seller’s country.</p><p>👉 The correct VAT rate for this invoice is {{vatRate}}</p>',
  vat_wizard_warning: 'Unsure about which VAT to apply? <strong>The VAT Wizard can help.</strong>',
  vat_wizard_check_for_me: 'Check for me',
  vat_wizard_eu_company_vat_check_invalid_description:
    '<p><strong>EU company without VAT number.</strong></p><p>Since your client is not VAT-registered, VAT must be charged by the seller.</p><p>👉 The correct VAT rate for this invoice is {{countryName}} VAT: {{vatRate}}</p>',
  vat_wizard_eu_company_vat_check_valid_description:
    '<p><strong>EU VAT-registered company.</strong></p><p>As both companies have intra-communiatry VAT numbers from different countries, 0% reverse intra-communitary VAT applies.</p><p>👉 The correct VAT rate for this invoice is 0%</p>',
  is_checking_vat: 'Just a moment, we’re checking...',
  vat_wizard_vat_check_error:
    'We’re having trouble verifying the information at the moment. Please try again later.',
  vat_number_update_failed:
    'Failed to update VAT number. Please try again with a valid VAT number.',
  invalid_vat_format: 'Invalid VAT format.',
  vat_number_checked_successfully: 'VAT number checked successfully',
  customer_vat_number_update_pending: 'Updating customer VAT number...',
  unable_to_proceed: 'Unable to proceed. Please try again.',
  vat_still_valid_confirm_remove_modal_title: 'This VAT number is still valid',
  vat_still_valid_confirm_remove_modal_description_row_one:
    'We’ve checked this VAT number {{vatNumber}} in the VAT/VIES registry and it is still valid.',
  vat_still_valid_confirm_remove_modal_description_row_two:
    'Please only remove it if you’re sure this customer no longer uses this VAT number or if it was added by mistake.',
  keep_vat_number: 'Keep VAT number',
  vat_number_removed: 'The VAT number has been removed.',
  no_vat: 'No VAT',

  // Matching Page
  invoice_matching_gross_and_fee: 'Gross: {{ gross }}, fee: {{ fee }}',
  invoice_matching_bank_entity: 'Bank entity',
  invoice_matching_bank_status: 'Status',
  invoice_matching_missing_documents_alert:
    'This transaction has missing documents. Please attach the necessary items.',
  invoice_matching_other_transactions: 'Other transactions',
  invoice_matching_matching_items: 'Matchings document, salary or trip',
  invoice_matching_filter_similar_amount: 'Similar amount',
  invoice_matching_filter_incoming_only: 'Incoming only',
  invoice_matching_filter_show_matched: 'Show matched',
  invoice_matching_other_transactions_add_button: 'Add new',
  invoice_matching_other_transactions_empty_state: 'There are no other transactions yet',
  invoice_matching_matching_add_invoices_button: 'Add uploaded invoices',
  invoice_matching_matching_upload_button: 'Upload document',
  invoice_matching_table_document: 'Document name',
  invoice_matching_table_date: 'Date',
  invoice_matching_table_status: 'Status',
  invoice_matching_table_date_from: 'From: ',
  invoice_matching_table_date_to: 'To: ',
  invoice_matching_table_status_matched: 'Matched',
  invoice_matching_table_status_unmatched: 'Unmatched',
  invoice_matching_table_status_linked: 'Salary is linked',
  invoice_matching_table_status_not_linked: 'Salary has not been linked',
  invoice_matching_table_status_link_button: 'Link',
  invoice_matching_table_status_unlink_button: 'Unlink',
  investment_add_funds: 'Investment - Added funds',
  investment_withdraw_funds: 'Investment - Withdrawn funds',
  inner_trading: 'Internal Trading',
  bank_cashback: 'Bank Cashback',
  commission_earnings: 'Commission Earnings',
  released_fund_reserve: 'Released Fund Reserve',
  received_interest: 'Received Interest',
  card_verification: 'Card verification',
  state_refund: 'State refund',
  matched_status: 'Matched',
  unmatched_status: 'Unmatched',
  bank_statement: 'Bank statement',
  other_transactions_reference: 'TRANSFER: {{ reference }} | {{ recipient }}',
  unmatch: 'Unmatch',
  confirm_unmatch_modal_title: 'Confirm matching deletion for transaction',
  confirm_unmatch_modal_description:
    'This will remove the current matching for this bank transaction. This action cannot be undone. Are you sure?',
  confirm_unmatch_invoice:
    'This will remove the current matching for this invoice. This action cannot be undone. Are you sure?',
  invoice_matching_transaction_unmatched_successfully: 'Transaction unmatched successfully.',
  confirm_unmatch_modal_error: 'Failed to unmatched transaction.',
  invoice_matching_unmatching_transaction: 'Unmatching transaction',
  confirm_upload_document_modal_title: 'Confirm document upload',
  confirm_upload_document_modal_description:
    'This transaction has already been linked to an invoice, was this transaction a payment for several invoices?',
  adding_document_to_matching_loading: 'Adding document to matching...',
  adding_document_to_matching_success: 'Document added to matching successfully.',
  back_to_sales: 'Back to sales',
  back_to_purchases: 'Back to purchases',
  back_to_matching_details: 'Back to Matching details',
  back_to_home: 'Back to Home',
  back_to_transactions: 'Back to Transactions',
  back_to_contractor: 'Back to Contractor',
  invoice_number: 'Invoice number',
  issue_date: 'Issue date',
  supplier: 'Supplier',
  total_including_vat: 'Total (including VAT)',
  match_transactions: 'Match transactions',
  match_sales_invoice: 'Match sales invoice',
  match_purchases_invoice: 'Match purchases invoice',
  transactions_table_header_description: 'Description',
  transactions_table_header_date: 'Date',
  transactions_table_header_amount: 'Amount',
  banking_fee: 'Banking fee',
  gross: 'Gross',
  held_fund_reserve: 'Held Fund Reserve',
  internal: 'Internal',
  personal_expense_refund: 'Personal Expense Refund',
  refunded_sale: 'Refunded Sale',
  refunded_purchase: 'Refunded Purchase',
  initial_principal_payment: 'Loan principal',
  repayment_installment: 'Repayment Installment',
  transactions_table_header_status: 'Status',
  match_type_error: 'This transaction is not of the same type as the document.',
  incoming_transaction_expenses:
    "You're attempting to match an incoming transaction as an expense. This can only happen for credit invoices issued by your suppliers for refunds. Is this a credit invoice? Are you certain you want to proceed with matching it as an expense?",
  outgoing_transaction_sales:
    "You're attempting to match an outgoing transaction as a sale. This can only happen for credit invoices issued to your clients for refunds. Is this a credit invoice? Are you certain you want to proceed with matching it as a sale?",
  cant_check_transaction_document:
    'This invoice is still being processed, so we can’t confirm whether it matches the transaction. <strong style="font-weight: bold;">If you continue, the match may be inaccurate.</strong>',
  linking_entity_to_transaction_success: 'Entity linked to transaction successfully.',
  linking_entity_to_transaction_error: 'Error linking entity to transaction.',
  linking_entity_to_transaction_loading: 'Linking entity to transaction...',
  adding_transaction_to_matching_loading: 'Adding transaction to matching...',
  adding_transaction_to_matching_success: 'Transaction added to matching successfully.',
  unable_to_match: 'Unable to complete the match. Please retry the process.',
  invoice_transaction_amounts_dont_match:
    'The amounts of the invoice ({{invoiceAmount}}) and the transaction ({{transactionAmount}}) do not match. This can only occur if the invoice was paid in multiple installments or if the transaction covers multiple invoices. Are you certain you want to proceed with matching this document with this transaction?',
  loan_agreement: 'Loan Agreement',
  lent_to: 'Lent to',
  borrowed_from: 'Borrowed from',
  interest_and_installment: 'at {{interest}}% interest in {{installment}} installments',
  in_progress: 'In progress',
  created: 'Created',
  started: 'Started',
  concluded: 'Concluded',
  invoice_matching_no_customer_info: 'No customer info',
  transactions_unmatched_success_modal_title: 'Transaction unmatched successfully.',
  transactions_unmatched_success_modal_description:
    'All the entities have been unmatched successfully.',
  travel_employee_name: 'Name',
  to: 'To',
  out_of_pocket: 'Out of pocket',
  match_document: 'Match document',
  net_settlement: 'Net settlement',
  matching_document_pending: 'Matching document...',
  matching_document_success: 'Document matched successfully.',
  matching_document_error: 'Error matching document.',
  documents_already_linked: 'Documents already linked',
  match_transaction: 'Match transaction',
  unlink_entity_from_matching_by_matching_id_pending:
    'Unlinking entity from matching by matching id...',
  unlink_entity_from_matching_by_matching_id_success: 'Entity unlinked successfully.',
  unlink_entity_from_matching_by_matching_id_error:
    'Error unlinking entity from matching by matching id.',
  matching_autor: 'Matched by: {{ author }}',
  total_documents: 'Total documents: {{ total }}',
  total_transactions: 'Total transactions: {{ total }}',
  match_documents: 'Match documents',
  add_uploaded_invoices_navigation_error:
    'No document type found. Please return to the previous page and retry.',
  transaction_not_found: 'Transaction not found',
  transaction_matching_file: 'Transaction matching file',
  reason_empty_data_matching_document:
    'Fields will display data once the document has been analyzed by our algorithm.',
  time_range_advanced_search: 'Date range (Issue date)',
  uncategorized: 'Uncategorized',
  back_to_advanced_search_sales: 'Back to sales',
  back_to_advanced_search_purchases: 'Back to purchases',
  back_to_matching_items: 'Back to matching items',
  incomplete_invoice_data: 'Incomplete invoice data',
  documents_have_mixed_currencies:
    'The invoices have mixed currencies. Your invoices must have the same currency.',

  // Banks Page
  banks_title: 'All bank accounts',
  banks_statements_button: 'Statements',
  banks_add_new_button: 'Add new',
  bank_reconnect_button: 'Reconnect',
  bank_provide_information_button: 'Provide information',
  bank_provide_information_description:
    'Please provide additional information about this bank account.',
  bank_upload_button: 'Upload a bank statement',
  bank_dropdown_details: 'Details',
  bank_dropdown_upload_statement: 'Upload statement',
  bank_dropdown_change_name: 'Edit name',
  bank_dropdown_reconnect: 'Reconnect',
  bank_dropdown_closed: 'Account closed',
  banks_empty_state:
    'No bank accounts linked to your company were found. To match bank movements with invoices, salaries or trips, or get stats of revenue and expenditure of your business, <0>link your first bank account now</0>.',
  banks_change_name_modal_title: 'Edit bank name',
  banks_change_name_modal_placeholder: 'Enter the new bank name here',
  banks_change_name_modal_cancel_button: 'Cancel',
  banks_change_name_modal_save_button: 'Save',
  banks_change_name_modal_warning:
    'Bank name is the same as the previous one, please enter a new name.',
  banks_change_name_modal_success: 'Bank name changed successfully.',
  banks_change_name_error: 'There was an error while changing the bank name.',
  banks_delete_success: 'Bank disabled successfully.',
  banks_delete_bank_error: 'There was an error while deleting the bank account.',
  banks_get_authorization_link_error: 'There was an error while connecting the bank account.',
  bank_type_crypto: 'Type: Crypto',
  bank_type_bank: 'Type: Bank',
  bank_status_needs_migration: 'Needs migration',
  bank_status_expires_soon: 'Expires soon',
  bank_status_needs_confirm_investment_account: 'Needs confirm',
  bank_status_has_investments_earnings: 'Investments earnings',
  bank_status_investment_account: 'Investment acct',
  bank_status_closed: 'Closed',
  bank_status_pending_review: 'Pending Review',
  bank_dropdown_enable_automatic_invoice_downloads: 'Retrieves invoices automatically',
  bank_dropdown_disable_automatic_invoice_downloads: 'Stop retrieving invoices automatically',
  bank_dropdown_confirm_investment_account: 'Confirm account type',
  bank_dropdown_this_is_not_investment_account: 'This is NOT an investment account',
  bank_dropdown_this_is_investment_account: 'This is an investment account',
  bank_dropdown_update: 'Update',
  bank_filter_active: 'Active',
  bank_filter_closed: 'Closed',
  bank_filter_pending_review: 'Pending Review',
  bank_filter_missing_bank_account: 'Missing bank account',
  document_upload_pending: 'Uploading bank statement...',
  document_upload_success: 'Bank statement uploaded successfully.',
  upload_statement_premium_upgrade_title: 'Join the PREMIUM plan',
  upload_statement_premium_upgrade_description:
    "To efficiently manage your company’s accounting and facilitate seamless invoice reconciliation, access to all your bank accounts is crucial. Please note that our Pro plan does not include crypto accounts. If you wish to link this crypto wallet or account, you’ll need to upgrade to our Premium plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  deleting_bank_loading: 'Marking bank account as closed...',
  deleting_bank_success: 'Bank account marked as closed successfully.',
  confirm_delete_bank_modal_title: 'Confirm action',
  confirm_delete_bank_modal_description:
    'This will mark the bank account as closed or inactive. Choose this action if you closed your bank account or it no longer exists. If the bank account is inactive -no activity- but still open, kindly reconnect it and keep it connected. Are you sure you want to mark this account as closed now?',
  banks_get_authorization_link_loading: 'Getting authorization link...',
  banks_set_investment_property_loading: 'Setting investment property...',
  banks_set_investment_property_success: 'Investment property set successfully.',
  confirm_account_type_modal_title: 'Are you sure you want to change the account type?',
  confirm_account_type_modal_description:
    'Changing your account type can directly impact your financial transaction records. If you proceed with the change, our accounting team will review to ensure the correct account type is being applied. Please note that any changes will take some time due to the manual review process.',
  confirm_investment_account_modal_title: 'Are you sure you want to change the account type?',
  confirm_investment_account_modal_description:
    'Changing your account type can directly impact your financial transaction records. If you proceed with the change, our accounting team will review to ensure the correct account type is being applied. Please note that any changes will take some time due to the manual review process.',
  banks_ask_to_change_investment_property_loading: 'Asking to change investment property...',
  banks_ask_to_change_investment_property_success:
    'Investment property asked to change successfully.',
  banks_ask_to_change_investment_property_error:
    'An error occurred while setting the account as an investment account. Please try again.',
  bank_type_investment_account: 'Type: Investment Account',
  add_new_bank_premium_upgrade_description:
    "To efficiently manage your company’s accounting and facilitate seamless invoice reconciliation, access to all your bank accounts is crucial. Please note that our Pro plan covers up to 3 bank accounts. If you wish to link additional bank accounts, you'll need to upgrade to our Premium plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  add_new_bank_ultra_upgrade_title: 'Join the ULTRA plan',
  add_new_bank_ultra_upgrade_description:
    "To efficiently manage your company’s accounting and facilitate seamless invoice reconciliation, access to all your bank accounts is crucial. Please note that our Premium plan covers up to 5 bank accounts. If you wish to link additional bank accounts, you'll need to upgrade to our Ultra plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  confirm_bank_account: 'Confirm Bank Account',
  bank_account_doesnt_associated_with_company:
    "It appears that this bank account is associated with {{accountHolder}}, and we couldn't verify if it belongs to your business, {{companyName}}. Kindly ensure that you're linking the bank account specifically for your business, not a personal account or one belonging to another business. Could you please confirm that this account is indeed the corporate bank account for your business?",
  no_disconnect_it: 'No, disconnect it',
  yes_confirm_it: 'Yes, I confirm it',
  connect_bank_account_again:
    'We removed the bank account. Please connect your bank account again.',
  connect_bank: 'Connect bank',
  bank_filter_needs_migration: 'Needs migration',
  bank_filter_disconnected: 'Disconnected',
  bank_filter_expires_soon: 'Expires soon',
  bank_filter_connected: 'Connected',
  bank_filter_manual: 'Manual',
  bank_dropdown_delete: 'Account closed',
  bank_ownership_modal_title:
    'This bank account appears to belong to a different entity than your company.',
  bank_ownership_modal_description_1:
    'Using or reusing personal bank accounts, or bank accounts belonging to other businesses (even if you are the sole proprietor) for your company activity can create serious accounting problems, especially when personal and business transactions become mixed together. It can also raise <b>anti-money laundering (AML)</b> concerns and lead to legal or regulatory consequences.',
  bank_ownership_modal_description_2:
    'Please make sure this account is legitimately used just for your company before continuing. <a target="_blank" rel="noreferrer" href="https://help.companio.co/en/article/can-i-use-the-same-stripe-or-payment-account-for-multiple-companies-cvi3f/">Learn more</a>.',
  provide_information: 'Provide information',
  provide_information_description: 'Please provide additional information about this bank account.',
  bank_account_status_title: 'What is the current status of this bank account?',
  bank_account_status_description:
    'We need to confirm whether this bank account is still active. Please review the account details and select the option that best describes its current status.',
  bank_account_status_banner_title: 'CONFIRM YOUR BANK ACCOUNT STATUS:',
  bank_account_status_banner_description:
    'Please review whether your bank account is still active.',
  accountant_request_bank_status_active_transactions:
    'The bank account is active and has transactions. I will reconnect it to ensure they appear.',
  accountant_request_bank_status_active_no_transactions:
    'The bank account is active but has no recent transactions.',
  accountant_request_bank_status_closed:
    'The bank account has been closed and is no longer active.',
  accountant_request_bank_status_action_loading: 'Updating bank account status...',
  confirm_status: 'Confirm status',
  bank_account_status_modal_title: 'Upload a recent bank statement',
  bank_account_status_modal_description_1:
    'Since this account has no recent transactions, we need a recent bank statement to confirm everything is in order. Please upload a bank statement from the date of the last transaction until today.',
  bank_account_status_modal_description_2:
    'We will review it and let you know if anything else is needed.',
  accountant_request_upload_statement: 'Upload a valid PDF, PNG or JPG file to begin',
  statement_uploaded_success_modal_title: 'Statement uploaded successfully',
  statement_uploaded_success_modal_description:
    'Your bank statement has been received. We will review it and notify you if anything else is needed.',
  confirm_bank_account_closure_title: 'Confirm bank account closure',
  confirm_bank_account_closure_description_1:
    'You indicated that this bank account has been closed. <strong>Please confirm that the account has been officially closed with the bank, not just inactive or without recent transactions.</strong>',
  confirm_bank_account_closure_description_2:
    'If the account is still open but has no activity, please select "The bank account is active but has no recent transactions."',
  let_me_check_first: 'Let me check first',
  bank_account_closed_success_modal_title: 'Bank account closed',
  bank_account_closed_success_modal_description:
    'The account has been marked as closed in the system.',
  invalid_bank_connection_type: 'Invalid bank connection type. Please try again.',
  non_connected_bank_account: 'Non-connected Bank Account',
  missing_bank_card_description:
    '<b>There may be a bank account that hasn’t been connected yet.</b> Review the details and either connect it or confirm there are no additional accounts.',

  // Bank Account Description
  bank_account_configured_pre: 'Your {{ bankName }}',
  bank_account_configured_post: ' account is configured ',
  crypto_wallet_configured_post: ' crypto wallet is configured ',
  _and_linked: '& the API has been linked.',
  _but_not_linked: ' but no API is available.',
  crypto_eth_only_note: ' Only ETH movements are tracked on this card.',
  expired: 'Expired',
  authorization_expires: 'Authorization expires in {{days}}.',
  bank_account_deleted: ' account was closed. It is not available anymore.',

  // Add Bank Page
  banks_add_new_title: 'Connect your bank accounts',
  banks_add_new_description:
    'Please, choose a bank provider to get started. The banking solutions we recommend are marked with a green badge.',
  banks_add_new_open_account_button: 'Open Bank account',
  banks_add_new_connect_account_button: 'Connect account',
  bank_sort_option_popular: 'Popular',
  bank_sort_option_by_country: 'By country',
  bank_sort_option_crypto_wallets: 'Crypto Wallets',
  bank_sort_option_ethereum_based_coins: 'Ethereum Based Coins',
  bank_sort_option_others: 'Others',
  bank_provider_description_allows_bank_statements:
    '{{ bank }} allows us to read your bank statements, but does not allow us to prepare the Tax Office payments.',
  bank_provider_description_crypto_wallet:
    'We will have <strong style="font-weight: bold;">view-only access</strong> to your wallet: we can see balances and transactions, but can never move or control your funds.',
  bank_provider_description_no_bank_statements:
    '{{ bank }} does NOT allow us to read your bank statements or prepare Tax Office payments.',
  bank_provider_description_exchange_api:
    'Connect your {{ bank }} account via API to automatically sync deposits, withdrawals and balances.',
  banks_connect_exchange_api_modal_title: 'Connect your {{ bank }} account',
  banks_connect_exchange_api_modal_description_html:
    'Enter your {{ bank }} API credentials to connect your account. Create a <strong>read-only</strong> API key.',
  banks_connect_exchange_api_modal_api_key_input: 'API Key',
  banks_connect_exchange_api_modal_api_secret_input: 'API Secret',
  banks_connect_exchange_api_modal_bank_name_input: 'Account name',
  banks_connect_exchange_api_modal_bank_name_helper:
    'Provide a descriptive and distinctive name for your {{ bank }} account to easily identify it within your dashboard.',
  banks_connect_through_api_modal_cancel_button: 'Cancel',
  banks_connect_through_api_modal_link_button: 'Link',
  banks_connect_through_api_modal_title: 'Connect your {{ bank }} account',
  banks_connect_through_api_modal_description_html:
    'To link your {{ bank }} account, we need you to get a token that will allow us to access your bank statements and prepare your payments to the tax office. In <a href="https://help.companio.co/en/article/non-open-banking-banks-how-to-connect-them-1jvm3gr/" target="_blank" rel="noreferrer">this tutorial</a> we explain how to do it.',
  banks_connect_through_api_modal_token_input: 'API Token',
  banks_connect_through_api_modal_bank_name_input: 'Bank name',
  banks_connect_through_api_modal_linking_title: 'Linking your account',
  banks_connect_through_api_modal_linking_description:
    'We are linking your bank account and loading your bank statements. This may take a couple of minutes. Please, wait until the process has finished and don’t close or reload this page.',
  banks_connect_through_api_modal_success_title: 'You are now done!',
  banks_connect_through_api_modal_success_description:
    'Bank account successfully linked to your account. Thank you! Please kindly allow 24-48h for the transactions to start appearing in your Bank Movements section. Don’t forget to link any other bank account of your company.',
  banks_connect_through_api_modal_success_button: 'Ok',
  banks_connect_through_api_modal_error_title: 'Something went wrong!',
  banks_connect_through_api_modal_error_description: '',
  banks_connect_through_api_modal_error_button: 'Ok',
  banks_connect_kraken_modal_title: 'Connect your Kraken account',
  banks_connect_kraken_modal_description_html:
    'To link your Kraken account we need a <strong>read-only</strong> API key. In Kraken, go to <em>Settings → API</em>, create a new key and enable only these permissions: <strong>Query Funds</strong>, <strong>Query Ledger Entries</strong>, <strong>Query Open Orders &amp; Trades</strong> and <strong>Query Closed Orders &amp; Trades</strong>. Then paste the API key and private key (secret) below. We will never be able to trade or withdraw.',
  banks_connect_kraken_modal_api_key_input: 'API key',
  banks_connect_kraken_modal_api_secret_input: 'Private key (secret)',
  banks_connect_kraken_modal_bank_name_input: 'Account name',
  banks_connect_kraken_modal_cancel_button: 'Cancel',
  banks_connect_kraken_modal_link_button: 'Connect',
  banks_connect_kraken_modal_linking_title: 'Linking your account',
  banks_connect_kraken_modal_linking_description:
    'We are linking your Kraken account and loading your data. This may take a few moments. Please don’t close or reload this page.',
  banks_connect_kraken_modal_success_title: 'You are now done!',
  banks_connect_kraken_modal_success_description:
    'Kraken account successfully linked. Thank you! Please kindly allow some time for the transactions to start appearing in your Bank Movements section.',
  banks_connect_kraken_modal_success_button: 'Ok',
  banks_connect_kraken_modal_error_title: 'Something went wrong!',
  banks_connect_kraken_modal_error_description:
    'We couldn’t connect to Kraken with those API credentials. Check that the API key and secret are correct and have the read-only query permissions, then try again.',
  banks_connect_kraken_modal_error_button: 'Ok',
  banks_connect_through_open_banking_modal_title: 'Connect your {{ bank }} account',
  banks_connect_through_open_banking_modal_description:
    'Provide a descriptive and distinctive name for your bank account to facilitate easy identification within your dashboard.',
  banks_connect_through_open_banking_modal_bank_name_input: 'Bank name',
  banks_connect_through_open_banking_modal_cancel_button: 'Cancel',
  banks_connect_through_open_banking_modal_link_button: 'Link',
  banks_connect_through_open_banking_modal_toast_pending: 'Redirecting to the bank...',
  banks_connect_manual_modal_title: 'Linking your account',
  banks_connect_manual_modal_bank_type_input: 'Bank name',
  banks_connect_manual_modal_account_holder_input: 'Bank account holder name',
  banks_connect_manual_modal_Balances: 'Balances',
  banks_connect_manual_modal_iban_input: 'IBAN',
  banks_connect_manual_modal_currency_input: 'Currency',
  banks_connect_manual_modal_balance_name_input: 'Balance name',
  banks_connect_manual_modal_add_more_button: 'Add more',
  banks_connect_manual_modal_success_description:
    "Bank account successfully linked to your account. Thank you! Don't forget to link any other bank account of your company.",
  banks_connect_ibrit_modal_title: 'Connect Interactive Brokers',
  banks_connect_ibrit_modal_description:
    'Enter your IBRIT Web Service credentials. You can find your Token and Query ID in your Interactive Brokers Portal under Reporting > Third-Party Reports > Third-Party Data Feeds.',
  banks_connect_ibrit_modal_token_input: 'Token',
  banks_connect_ibrit_modal_query_id_input: 'Query ID',
  banks_connect_ibrit_modal_bank_name_input: 'Bank account name',
  banks_connect_ibrit_modal_success_description:
    'Interactive Brokers account successfully linked. Your balances and transactions will be synced automatically.',
  banks_connect_ibrit_modal_error_description:
    'Could not link your Interactive Brokers account. Please verify your Token and Query ID are correct and try again.',
  banks_connect_crypto_modal_title: 'Add data from your new wallet',
  banks_connect_crypto_modal_wallet_name_input: 'Wallet name',
  banks_connect_crypto_modal_wallet_name_description:
    "Use a descriptive and unique name for your wallet to easily identify it among others in your control panel. For example, 'Cryptocurrency savings' or 'Trading wallet'.",
  banks_connect_crypto_modal_wallet_address_input: 'Wallet address',
  banks_connect_crypto_modal_wallet_address_description:
    "This is a unique alphanumeric string that serves as the virtual location where your cryptocurrency is stored. Each cryptocurrency has a different address format, so be sure to enter the correct one that corresponds to your wallet's currency type.",
  banks_connect_crypto_modal_wallet_cancel_button: 'Cancel',
  banks_connect_crypto_modal_wallet_add_button: 'Link',
  banks_connect_crypto_modal_wallet_next_button: 'Next',
  banks_connect_crypto_modal_verification_title: 'Proof of wallet ownership',
  banks_connect_crypto_modal_verification_description:
    'Please upload a document proving ownership of this wallet. Accepted formats: PDF, JPG, PNG (max 2 MB).',
  banks_connect_crypto_modal_verification_upload_description:
    'Drop your file here or click to browse',
  banks_connect_crypto_modal_verification_back_button: 'Back',
  banks_connect_crypto_modal_verification_submit_button: 'Submit',
  banks_connect_crypto_modal_linking_title: 'Linking your account',
  banks_connect_crypto_modal_linking_description:
    'We are linking your crypto wallet and loading your bank statements. This may take a couple of minutes. Please, wait until the process has finished and don’t close or reload this page.',
  banks_connect_crypto_modal_success_title: 'You are now done!',
  banks_connect_crypto_modal_success_description:
    'Crypto wallet successfully linked to your account. Thank you! Please kindly allow 24-48h for the transactions to start appearing in your Bank Movements section. Only ETH movements are tracked on this wallet — if this address also holds ERC-20 tokens (USDC, USDT, …), connect each one separately in the “Ethereum Based Coins” tab to track them as independent assets. We import your available history starting with the most recent transactions; wallets with a very large history may be imported partially. Don’t forget to link any other wallet of your company.',
  banks_connect_crypto_modal_success_button: 'Ok',
  banks_connect_crypto_modal_pending_title: 'Under Review',
  banks_connect_crypto_modal_pending_description:
    'Your crypto wallet has been successfully submitted and is currently under review. Please allow 24-48 hours for us to verify the proof of ownership. We will contact you if any questions arise, otherwise your wallet will be connected automatically.',
  banks_connect_crypto_modal_error_title: 'Oops! something went wrong.',
  banks_connect_crypto_modal_error_description:
    'The provided cryptocurrency address is invalid. Please check the address and try again. Cryptocurrency addresses should conform to the correct format and length specified for the respective blockchain. Ensure there are no typos or extra spaces.',
  banks_connect_crypto_modal_error_button: 'Ok',
  bank_provider_description_erc20_wallet:
    'We will have <strong style="font-weight: bold;">view-only access</strong> to your wallet: we can see balances and transactions, but can never move or control your funds.',
  banks_connect_erc20_modal_title: 'Add ERC-20 Token Wallet',
  banks_connect_erc20_address_input: 'ERC-20 wallet address',
  banks_connect_erc20_address_description:
    'Enter the wallet address that holds the ERC-20 tokens you want to track.',
  banks_connect_erc20_discover_button: 'Discover Tokens',
  banks_connect_erc20_discovering_title: 'Discovering tokens',
  banks_connect_erc20_discovering_description: 'Scanning your address for ERC-20 tokens...',
  banks_connect_erc20_no_tokens_found:
    'No ERC-20 tokens with a balance were found for this address.',
  banks_connect_erc20_select_token_title: 'Select a token',
  banks_connect_erc20_select_token_description: 'Choose one token to link as a separate account.',
  banks_connect_erc20_wallet_name_input: 'Wallet name (optional)',
  banks_connect_erc20_wallet_name_description: 'A friendly name to identify this token account.',
  banks_connect_erc20_cancel_button: 'Cancel',
  banks_connect_erc20_link_button: 'Link token',
  banks_connect_erc20_linking_title: 'Linking your token',
  banks_connect_erc20_linking_description: 'We are creating your ERC-20 token account...',
  banks_connect_erc20_success_title: 'Token linked successfully!',
  banks_connect_erc20_success_description:
    'Your ERC-20 token wallet is now connected. Please allow 24-48h for transactions to appear. We import your available history starting with the most recent transactions; wallets with a very large history may be imported partially.',
  banks_connect_erc20_success_button: 'Ok',
  banks_connect_erc20_error_title: 'Something went wrong.',
  banks_connect_erc20_error_description:
    'We could not link this token. Please check the address and try again.',
  banks_connect_erc20_error_button: 'Ok',
  banks_add_new_get_banks_by_country_error:
    'There was an error while retrieving the country banks.',
  banks_add_new_crypto_wallets_description:
    'Only supported cryptocurrencies are allowed. Make sure to choose one from the list below. Need a different one? <a href="https://help.companio.co/en/" target="_blank" rel="noreferrer">Contact us</a>.',
  bank_connect_button_popular: 'Connect existing account',
  bank_connect_button_by_country: 'Connect existing account',
  bank_connect_button_crypto_wallets: 'Link new wallet',
  bank_connect_button_ethereum_based_coins: 'Connect Wallet',
  banks_erc20_grid_info_message:
    'Only supported cryptocurrencies are allowed. Make sure to choose one from the list below. Need a different one? <a href="mailto:support@companio.co">Contact us.</a>',
  banks_erc20_grid_search_placeholder: 'Search by name or ERC-20 code',
  bank_connect_button_others: 'Connect existing account',
  bank_connect_country_description:
    '{{bank}} allows us to read your bank statements, but does not allow us to prepare the Tax Office payments.',
  open_bank_account: 'Open bank account',
  banks_connect_through_link_modal_title: 'Connect your {{ bank }} account',
  banks_connect_through_link_modal_description:
    'Provide a descriptive and distinctive name for your bank account to facilitate easy identification within your dashboard.',
  banks_connect_through_link_modal_bank_name_input: 'Bank name',
  banks_connect_through_link_modal_cancel_button: 'Cancel',
  banks_connect_through_link_modal_link_button: 'Link',
  banks_create_payoneer_registration_link_loading: 'Creating Payoneer registration link...',
  banks_connect_manual_modal_balance_name_input_kraken: 'Kraken Public ID',
  banks_create_kraken_authorization_link_loading: 'Creating Kraken authorization link...',
  banks_connect_manual_modal_balance_name_input_interactive_brokers: 'Account Number',
  banks_connect_through_open_banking_info_modal_title: 'Before you connect your Wise account',
  banks_connect_through_open_banking_info_modal_description:
    'During the connection process, you’ll need to <strong>manually select all currency balances</strong> so we can access the complete bank data.',
  banks_connect_through_open_banking_info_modal_continue_button: 'Continue',
  // Customers Page
  customers_title: 'All customers',
  customers_add_customer: 'Add customer',
  customers_table_column_name: 'Full name',
  customers_table_column_location: 'Location',
  customers_table_column_tax: 'Tax ID and VAT',
  customers_table_column_email: 'Email and phone',
  customers_actions_see_details: 'See details',
  customers_actions_add_new_invoice: 'Add new invoice',
  customers_person: 'Individual / Person',
  customers_company: 'Business client',
  customers_cell_tax_id: 'TAX ID: {{ tax_id }}',
  customers_cell_vat: 'VAT: {{ vat }}',
  customers_deleted_pending: 'Deleting customer...',
  customers_deleted_success: 'Customer deleted successfully.',
  customers_deleted_error: 'There was an error while deleting the customer.',
  customers_empty_state: 'No customers were found.',
  customer_modal_add_title: 'Add customer',
  customer_modal_edit_title: 'Update customer',
  customer_modal_image_description:
    'A picture of the client will make it easier for you to locate this customer in the list. <br />Max Photo size 2 MB.',
  customer_modal_upload_photo: 'Upload photo',
  customer_create_pending: 'Creating customer...',
  customer_create_success: 'Customer created successfully.',
  customer_create_error: 'There was an error while creating the customer.',
  customer_edit_pending: 'Updating customer...',
  customer_edit_success: 'Customer updated successfully.',
  customer_edit_error: 'There was an error while updating the customer.',
  customer_filter_placeholder: 'Name, Email, Country, Phone number',
  customers_actions_update_customer: 'Update customer',

  // Customer Details
  customer_details_invoice_number: 'Next invoice number: #{{ invoice_number }}',
  customer_details_is_company: 'This customer is a company',
  customer_details_edit_customer: 'Edit customer',
  customer_details_latest_invoices: 'Latest invoices',
  customer_details_new_invoice: 'New invoice',
  customer_details_column_document: 'Document name',
  customer_details_column_date: 'Date',
  customer_details_column_status: 'Status',
  customer_details_latest_invoices_tooltip:
    '<strong style="font-weight: bold;">Note:</strong> This list contains only invoices generated through Companio’s tools.',
  preferred_currency: 'Preferred currency for invoices',

  customer_details_search_placeholder: 'Search invoice',

  // Settings Page
  settings_tab_profile: 'Profile',
  settings_tab_team: 'Team',
  settings_tab_referral: 'Referral',
  settings_tab_billing: 'Billing',
  settings_tab_automation: 'Automation',
  settings_tab_others: 'Others',
  settings_tab_subscription: 'Subscription',
  contact_us: 'Contact us',

  // Profile Page
  settings_profile_title: 'Edit profile',
  settings_edit_user_title: 'Edit User',
  settings_profile_avatar:
    'Your photo will be shown to others when sending or replying to messages. Max Photo size 2 MB.',
  user_profile_update_pending: 'Updating profile...',
  user_profile_update_success: 'Profile updated successfully.',
  user_profile_update_error: 'There was an error while updating your profile.',
  user_profile_create_pending: 'Creating user...',
  user_profile_create_success: 'User created successfully.',
  user_profile_create_error: 'There was an error creating the user.',
  settings_email_modal_title: 'Check your inbox',
  settings_email_modal_description:
    'We sent you an email with a confirmation link. Click on it to confirm your new email address.',
  add_member_title: 'Add User',
  send_verification_code: 'Sending verification code...',
  send_verification_code_success: 'Verification code sent successfully',
  send_verification_code_error: 'There was an error while sending the verification code',
  check_verification_code: 'Checking verification code...',
  check_verification_code_success: 'Verification checked successfully',
  check_verification_code_error: 'There was an error while checking the verification code',

  // Team Page
  team_table_title: 'Team',
  search_team_member: 'Search team member',
  set_user_representative_pending: 'Updating user...',
  set_user_representative_success: 'User role updated successfully.',
  set_user_representative_error: 'There was an error while updating the user role.',
  delete_user_pending: 'Deleting user...',
  delete_user_success: 'User deleted successfully.',
  delete_user_error: 'There was an error while deleting the user.',
  confirm_deletion_description: 'Are you sure you want to delete this user?',
  invalid_email_form_error: 'Please enter a valid email address, example: name@example.com',
  delete_user: 'Delete user',
  full_name_and_role: 'Full name and role',
  e_residency_dates: 'e-Residency Card Dates',
  contact_details: 'Contact details',

  // Manage Subscription Page
  manage_subscription_title: 'Manage subscription',
  manage_subscription_plan_information: 'Plan information',
  cancelation_plan_modal_title: 'Cancellation requires assistance',
  cancelation_plan_modal_description:
    'To proceed with the cancellation, please contact our Customer Support team via <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. One of our agents will assist you with the offboarding process.',
  one_month_from_last_change:
    '<strong>You already have a plan change scheduled for {{date}}.</strong> Please wait until it’s completed or cancel it to make a new change.',
  plan_changed_too_soon:
    '<strong>Your plan was changed recently</strong>. You can change your plan again on <strong>{{date}}</strong>',
  plan_changed_recently: 'Plan changed recently',

  // Chnage Plan Page
  confirm_change_plan: 'Confirm',
  page_title_change_plan: 'Back to manage subscription',
  plan_info_request_error: 'Error while geting the plan information',
  plan_description_pro:
    'Includes full company accounting and monthly reports in compliance with regulations, with support for 1 bank account and up to 100 documents.',
  plan_description_premium:
    'Includes full company accounting and monthly reports in compliance with regulations, plus support for up to 3 bank accounts and 500 documents, along with access to crypto and investment tracking.',
  plan_description_ultra:
    'Includes full company accounting and monthly reports in compliance with regulations, with support for up to 10 bank accounts and 5,000 documents.',
  change_plan_warning:
    'By upgrading your plan, a new amount will be charged according to the plan you select. Please note that the benefits and features of your subscription will change. We recommend carefully reviewing what’s included in your new plan before confirming.',
  month_abreviation: 'mo',
  plan_title_pro: 'Pro plan',
  plan_title_premium: 'Premium plan',
  plan_title_ultra: 'Ultra plan',
  change_plan_modal_title: 'Are you sure you want to change your plan?',
  change_plan_modal_description:
    'You will be charged the new amount on your next invoice. Remember that this may change the features you had in your previous plan.',
  change_plan_modal_confirm_button: `Let's do it!`,
  change_plan_modal_cancel_button: 'I changed my mind',
  plan_update_pending: 'Updating plan...',
  plan_update_error: 'Error while updating plan',
  update_plan_modal_title_upgrade: `You've upgraded your plan!`,
  update_plan_modal_title_downgrade: `You've downgraded your plan!`,
  update_plan_modal_description:
    'You can see the details in your configuration. You will pay the new amount on your next bill.',
  cannot_downgrade_modal_title: 'You can’t downgrade your plan right now',
  cannot_downgrade_modal_description_one:
    'Your account currently includes features that are only available on the Premium plan.',
  cannot_downgrade_modal_description_two:
    'To switch to a lower plan, these features would need to be removed first.',
  cannot_downgrade_modal_description_three:
    '<strong>Please, reach out to </strong> us via <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> — we’ll be happy to assist you.',
  cannot_downgrade_modal_description_four:
    'Once your account meets the requirements of the selected plan, you’ll be downgraded.',
  pending_plan_change_modal_title: 'Pending plan change',
  pending_plan_change_modal_description:
    '<strong>You already have a plan change scheduled for {{date}}</strong>. Please wait until it’s completed or cancel it to make a new change.',
  change_plan_modal_title_downgrade: 'Are you sure you want to downgrade your plan?',
  change_plan_modal_title_upgrade: 'Are you sure you want to upgrade your plan?',
  change_plan_modal_description_downgrade_one:
    'Your plan won’t be downgraded immediately. If you continue, the change will automatically take effect <strong>after your next monthly billing cycle.</strong>',
  change_plan_modal_description_downgrade_two:
    '<strong>Please note:</strong> premium features such as Projects, Workflows, OSS, and other advanced tools are included in the Premium plan and will be disabled if you downgrade.',
  change_plan_modal_description_upgrade_one:
    'Your plan won’t be upgraded immediately. If you continue, the change will take effect <strong>after your next monthly billing cycle.</strong>',
  change_plan_modal_description_upgrade_two:
    'Remember that this may unlock new features not included in your current plan.',

  // Pro benefits
  total_remote_transactions: 'Up to 1,000 transactions',
  total_bank_accounts_remote:
    'Up to 3 <a href="https://companio.co/supported-banks/">supported</a> bank accounts',
  total_annual_report_remote: 'Annual report (+€250/year)',
  total_board_member_remote: '+€89 per Board Member salary',
  total_incorporation_fee_remote: '€390 one-time company incorporation fee',
  hire_freelancers: 'Hire & pay freelancers',

  // Premium benefits
  total_transactions_crypto: 'Up to 1,000 transactions',
  total_bank_accounts_crypto:
    'Up to 5 <a href="https://companio.co/supported-banks/">supported</a> bank accounts',
  total_board_member_salary_crypto: '+€59 per Board Member salary',
  total_annual_report_crypto: 'Annual report (+€250/year)',
  total_incorporation_fee_crypto: '<s>€390</s> €265 one-time company incorporation fee',

  // Ultra benefits
  total_transactions_ultra:
    'Unlimited transactions. <a href="https://companio.co/?page_id=12450&preview=true#">See more</a>',
  total_bank_accounts_ultra:
    'Unlimited <a href="https://companio.co/supported-banks/#section_3">supported</a> bank accounts',
  total_board_member_salary_ultra: '+€59 per Board Member salary',
  total_annual_report_ultra: 'Annual report (+€250/year)',
  total_incorporation_fee_ultra: '<s>€390</s> €265 one-time company incorporation fee',

  // All plan benefits
  legal_address: 'Legal address & person of contact',
  full_accounting: 'Full accounting & compliance',
  all_in_one_dashboard: 'All-in-one dashboard',
  automatic_bank_reconciliation: 'Automatic bank reconciliation',
  crypto_payments:
    'Crypto payments & investments on <a href="https://companio.co/supported-banks/#section_3">supported</a> platforms',
  trading_and_investments:
    'Trading & investments on <a href="https://companio.co/supported-banks/#section_3">supported</a> platforms',
  oss: 'OSS & Amazon FBA',
  hiring_international_employees:
    'Hiring international employees (<a href="https://companio.co/hiring-internationally/">add-on</a> required)',

  // Referral Page
  referral_header_title: 'Refer a friend and get 50€!',
  referral_header_subtitle: 'How does the Referral Program work?',
  referral_header_description:
    'Are you a happy Companio user? We hope so! Now you can refer our services to other entrepreneurs and freelancers. Both of you will get a €50 discount. So how does it work?',
  referral_step_1_title: 'Share your link',
  referral_step_1_description:
    "Share the link you'll find below on your blog, social media profile or Youtube channel, or just send it to a friend.",
  referral_step_2_title: 'Get 50€!',
  referral_step_2_description:
    'Every time someone registers their business using your link, they will get a €50 discount in the company registration price, and you will get a €50 discount in your next monthly fee.',
  referral_sharing_title: 'Start sharing your link!',
  referral_sharing_description:
    'Simply click on the button to copy the referral link, or use one of the social sharing buttons below to send it directly.',
  referral_link: 'Your Referral Link',
  referral_share_your_link: 'Share your link!',
  referral_history_button: 'View referral history',
  referral_copy_button: 'Copy Referral Link',

  // Referral History Page
  referral_table_title: 'Referrals history',
  referral_type_received_discount: 'Received',
  referral_type_discount_applied_in_accountancy: 'Applied',
  referral_description_received_discount: 'Referral link used by',
  referral_description_discount_applied_in_accountancy: 'Discount applied to monthly services',
  referral_description_monthly_accountancy: 'Monthly accountancy',
  balance: 'Balance',
  total_earned: 'Total earned',

  // Billing page
  add_payment_method_button: 'Add New Payment Method',
  set_primary_payment_method_pending: 'Setting primary payment method...',
  set_primary_payment_method_success: 'Primary payment method set successfully.',
  set_primary_payment_method_error: 'There was an error while setting the primary payment method.',
  delete_payment_method_pending: 'Deleting payment method...',
  delete_payment_method_success: 'Payment method deleted successfully.',
  delete_payment_method_error: 'There was an error while deleting the payment method.',
  transaction_history_title: 'Transaction history',
  save_credit_card: 'Save credit card',
  card_added_success: 'Card successfully added',
  suggest_sales_email_request_error: 'Error while getting sales suggested e-mail',
  suggest_purchase_email_request_error: 'Error while getting purchase suggested e-mail',
  upload_proof_of_payment: 'Upload proof of payment',
  customer_charged_success: 'You were successfully charged!',
  retry_payment_processing_status:
    'Payment is processing, once the payment settles we will notify you!',
  retry_payment_requires_action_status:
    'Your payment requires attention. Please take the necessary action by clicking the three-dot menu on this transaction line.',
  error_message_title: 'Oops! something went wrong \uD83D\uDE14',
  confirm_payment: 'Confirm payment',
  search_reports: 'Search reports',
  travels_table_header_status: 'status',
  proof_of_payment_upload_error: 'Error in uploading proof of payment',
  transaction_table_header_status: 'Status',
  transaction_table_title: 'Billing history',
  payment_status_processing: 'Processing',
  payment_status_requires_action: 'Requires action',
  retry_payment_pending: 'Retrying payment...',
  retry_payment_error: 'There was an error while processing the payment retry',
  bank_card: 'Bank card',
  no_payment_method: 'No payment method found',
  search_transactions: 'Search by service',
  plan: 'Plan',
  invoices_transaction_history: 'Invoices',
  discount: 'Discount:',
  penalty: 'Penalty:',
  no_charge_information_available: 'No charge information available',
  tier_1: 'tier 1',
  tier_1_40: 'tier 1 - 40',
  tier_41_200: 'tier 41 - 200',
  tier_201_500: 'tier 201 - 500',
  tier_501_1000: 'tier 501 - 1000',
  tier_1000_plus: 'tier 1000+',
  confirm_delete_payment_card_modal_title: 'You’re about to delete a payment method',
  confirm_delete_payment_card_modal_description:
    'Once you delete this card, <strong>it won’t be available for future payments</strong>. You can always add it again if needed. <br /> <br /> We’ll automatically use your other saved card for upcoming charges.',
  full_amount_to_pay: 'Full amount: {{amount}}',
  payment_verified_success: 'Payment verified successfully',
  base_amount: 'Base amount: {{baseAmount}}',
  penalty_days: 'Number of late days: {{penaltyDays}}',
  penalty_amount: 'Penalty amount: {{penaltyAmount}}',
  blocked: 'Blocked',
  payment_blocked_modal_title: 'Your payment method is blocked',
  payment_blocked_modal_description:
    'The payment could not be completed because this card has been blocked by your bank. <br /> <br /> <strong>Please replace the payment method to continue your purchase.</strong>',
  add_payment_blocked_title: 'This payment method is listed as blocked',
  add_payment_blocked_description:
    'This card was previously used for a payment that was blocked by your bank. <br /> <br /> If the issue has been resolved, <strong>you can try adding the card again</strong>. Otherwise, we recommend contacting your bank before proceeding.',
  add_again: 'Add again',
  updating_blacklist_payment_methods: 'Adding payment method, please wait...',
  card_already_added:
    'Oops! This card has already been added to your payment methods. Please try again with a different card.',

  // Travels page
  travels_title: 'Travels',
  travels_add_new_button: 'Add new',
  travels_filter_arriving: 'Arriving',
  travels_filter_arrived: 'Arrived',
  travels_filter_pending_payment: 'Pending Payment',
  travels_filter_shipment_paid: 'Shipment Paid',
  travels_filter_sent: 'Sent',
  travels_filter_delivered: 'Delivered',
  travels_filter_lost: 'Lost',
  travels_filter_permission_needed: 'Permission Needed',
  travels_table_header_add_travel_button: 'Add new',
  travels_table_title: 'All Travels',
  travels_table_header_employee: 'Traveler',
  travels_table_header_Locations: 'Locations',
  travels_table_header_dates: 'Dates',
  travels_table_header_expenses: 'Expenses',
  travels_table_daily_allowance: 'Daily allowance',
  travels_table_daily_status: 'Status',
  travel_source: 'Origin',
  travel_destination: 'Destination',
  travel_date_from: 'From',
  travel_date_to: 'To',
  travel_expenses_accom: 'Accom',
  travel_expenses_travel: 'Travel',
  travel_daily_expense_allowed: 'Allowed',
  travel_daily_expense_not_allowed: 'Not allowed',
  see_travel_details: 'See travel details',
  download_busisness_contract: 'Download the official busisness trip report',
  add_non_deductible_receipt: 'Add a non-deductible receipt or ticket',
  daily_allowance_info: 'How much is daily allowance?',
  mark_as_completed: 'Mark as completed',
  mark_as_completed_success:
    '<strong>The {{type}} report has been marked as completed.</strong> Thanks for staying on top of your accounting!',
  SHIPMENT_PAID: 'SHIPMENT PAID',
  board_members: 'Board members',
  contractors_and_employees: 'Contractors & Employees',
  approved: 'Approved',
  completed: 'Completed',
  deleted: 'Deleted',
  rejected: 'Rejected',
  daily_allowance_info_text:
    'If you are a board member, you have the right to ask for daily allowances for your trips once they are approved. The amount of money you can pay to your personal bank account is 75 € the first 15 days of the trip and 32 € the following days. <strong style="font-weight: bold;">For this concrete trip, you can pay yourself: {{dailyAllowance}}</strong>',
  daily_allowance_modal_title: 'How much is daily allowance? 🤔',
  edit_information: 'Edit information',
  travel_start_date: 'Start date',
  travel_end_date: 'End date',
  travel_expenses: 'Travel expenses',
  accomodation_expenses: 'Accomodation expenses',
  daily_allowance: 'Daily Allowance',
  trip_reason: 'Detailed trip purpose (Min 20 characters)',
  travel_expenses_document: 'Travel expenses document',
  documentary_proof_of_travel: 'Documentary proof of travel',
  travel_update_success: 'Travel updated successfully.',
  travel_update_error: 'There was an error while updating the travel.',
  no_action: 'No action',
  delete_travel_title: 'Are you sure you want to delete this travel',
  travel_update_pending: 'Updating travel...',
  download_report: 'Download report',
  update_start_date: 'Update start date',
  update_end_date: 'Update end date',
  update_origin_country: 'Update origin country',
  update_destination_country: 'Update destination country',
  travel_start_date_edit_modal_title: 'Update start date',
  travel_end_date_edit_modal_title: 'Update end date',
  travel_origin_edit_modal_title: 'Update country of origin',
  travel_destination_edit_modal_title: 'Update country of destination',
  employee_or_contractor_option_title: 'An employee or contractor',
  employee_or_contractor_option_text:
    'Choose this option for contractors or Companio Work employees that are not board members.',
  member_of_company_option_title: 'A member of the company',
  member_of_company_option_text:
    'Choose this if the traveler is a board member. The trip will be eligible for daily allowance.',
  upload_travel_file: 'Upload a file (Choose a PDF)',
  get_employess_error: 'Error while getting employees',
  get_board_member_error: 'Error while getting board members',
  not_applicable: 'Not applicable',
  request_daily_allowance: 'Request daily allowance for the trip.',
  calculate_daily_allowance_error: 'Failed to calculate daily allowance',
  travel_create_pending: 'Creating travel...',
  travel_create_success: 'Travel created successfully',
  travel_create_error: 'There was an error while creating the travel.',
  option_contractor: '(Contractor)',
  option_employee: '(Employee)',
  option_board_member: '(Board member)',
  convert_to_purchase_invoice: 'Convert to purchase invoice',
  travels_documents_table_title:
    'Business trip documents (official report & non-deductible expense receipts)',
  add_receipt_button: 'Add receipt',
  travel_documents_list_header_document: 'Document',
  travel_documents_list_header_date: 'Date',
  travel_documents_list_header_status: 'Status',
  upload_receipt: 'Upload receipt',
  upload_receipt_description:
    'Effortlessly upload your receipts by dragging and dropping them here. Click to select files.',
  document_update_success: 'Document updated successfully',
  document_update_error: 'There was an error while updating the travel',
  end_date_after_start_date: 'The end date must be greater than the start date',
  board_member: 'Board member',
  contractor: 'Contractor',
  delete_travel_modal_title: 'Are you sure you want to delete this travel?',
  delete_travel_modal_description: 'Please consider that this action cannot be undone.',
  mark_travel_as_complete_modal_title: 'Are you sure you want to mark this travel as completed?',
  mark_travel_as_complete_modal_description:
    'Before proceeding, please make sure that all documents have been uploaded, including both non-deductible expenses (via Travels section) and deductible expenses (via Purchases section). Do you want to continue?',
  who_is_traveling: 'Who’s traveling?',
  who_is_traveling_description:
    'Easily manage and notify the travel plans of your company’s members or individual employees. Calculate daily allowances and enter all necessary data for comprehensive record-keeping. Streamline your travel tracking and ensure accurate and efficient management of all travel-related information.',
  travel_deleted_successfully: 'The trip has been successfully deleted.',
  document_deleted_successfully: 'The document has been successfully deleted.',
  trip_reason_min_length: 'The trip reason must be at least 20 characters long',
  travel_information: 'Travel information',
  origin: 'Origin',
  trip_reason_details_page: 'Detailed trip purpose',
  trip_details: 'Trip details',
  business_trip_no_members_found:
    'No board members were found for your company. Please contact the support team.',

  // Add Payment Method Page
  add_payment_method_title: 'Add new payment method',
  add_travel_button: 'Add travel',
  upload_document: 'Upload document',

  // Automation Page
  automation_title: 'Invoice Forwarding Email',
  automation_intro_text:
    'Automate your accounting with personalized invoice forwarding addresses. You can generate unique email addresses to receive:',
  automation_list_sales_invoices: 'Sales invoices from your clients',
  automation_list_purchase_invoices: 'Purchase invoices from your suppliers',
  automation_list_bank_statements: 'Bank statements from your bank',
  automation_description:
    'Any document attached to emails sent to these addresses will be automatically processed and added to your accounting records, saving you time and manual effort.',
  automation_alert:
    'Please note: to avoid misuse of this feature, there is a limit of one email per minute.',
  customize_email: 'Customize email',
  customize_email_description:
    'Please enter a preferred name to generate a unique email address for receiving your',
  custom_email_placeholder: 'Enter your desired company name here.',
  custom_email_address_label: 'custom email address',
  email_warning: 'Oops! That email looks taken',
  new_email_option: 'We can add a ‘-{{number}}’ to create a unique version:',
  change_email_option: 'Let me change it',
  keep_email_option: 'Looks good!',
  generated_email_success: 'Email generated successfully!',
  generated_email_success_description: 'This new email will be used from now on to receive your',
  dropbox_email_create_pending: 'Creating custom email...',
  dropbox_email_create_success: 'Custom email created successfully',
  dropbox_email_create_error: 'There was an error while creating custom email',
  dropbox_email_already_taken_error: 'Email already in use by another company',
  invalid_email_messsage_error: 'Invalid e-mail',
  confirm_delete_custom_email_modal_title: 'You are about to delete this customized email',
  confirm_delete_custom_email_modal_description:
    'Once you delete this address, <strong>you won’t be able to use it anymore</strong>. If you need it again, you can create a new one or use any other address you’ve already generated. <br> </br> Are you sure you want to continue?',
  automated_email_deleted:
    'The email address <strong>"{{email}}"</strong> has been removed from your forwarding addresses.',
  this_field_is_required: 'This field is required',
  invoice_forwarding_email_bank_statements_description:
    'You can see generated unique email addresses for each of your active bank accounts. <strong>There are no emails for closed bank accounts.</strong> Any document attached to emails sent to these addresses will be automatically added to the dashboard.',
  invoices_automation_sales: 'sales invoices',
  invoices_automation_purchases: 'purchase invoices',

  // Other Settings Page
  other_settings_title: 'Others',
  other_settings_invoice_payment_instructions: 'Invoice payment instructions',
  other_settings_invoice_payment_instructions_description:
    'Add invoice payment instructions for all your customers here. They will appear in all the invoices generated in the Sales section unless specific instructions are defined.',
  company_settings_update_pending: 'Updating company settings...',
  company_settings_update_success: 'Company settings updated successfully.',
  company_settings_update_error: 'There was an error while updating the company settings.',
  other_settings_invoice_payment_instructions_placeholder:
    'Enter your payment instructions here...',
  before_you_go_modal_title: 'Before you go…',
  before_you_go_modal_description:
    'We noticed you have unsaved changes. Would you like to save them or leave without saving?',
  leave_anyway: 'Leave anyway',

  // Bank Details
  bank_details_add_new_balance: 'Add new Balance',
  bank_details_transactions_title: 'Transactions',
  bank_details_transactions_upload_button: 'Upload a bank statement',
  bank_details_transactions_header_description: 'Description',
  bank_details_transactions_header_type: 'Type',
  bank_details_transactions_header_date: 'Date',
  bank_details_transactions_header_matched: 'Matched',
  bank_details_transactions_header_amount: 'Amount',
  bank_details_transactions_header_origin: 'Origin',
  bank_details_transactions_banking_fee: 'Banking fee',
  bank_details_transactions_gross: 'Gross',
  bank_details_balances_button: 'Balances',
  no_balances: 'No balances found',
  bank_details_account: 'Account {{account}}',
  bank_details_transactions_statements_button: 'Statements',
  bank_details_account_savings: 'Savings Account {{account}}',

  // 404 Page
  not_found_title: 'Looking for something Sherlock?',
  not_found_description:
    'We couldn’t find the page you’re looking for. Maybe the clues are hidden somewhere else on the dashboard, or perhaps it’s time to return to the homepage and start a new investigation!',
  not_found_button: 'Return to main page',

  // Document Types
  document_type_purchase_invoice: 'Purchase invoice',
  document_type_sales_invoice: 'Sales invoice',
  document_type_bank_statement: 'Bank statement',
  document_type_non_deductible_trip_expense: 'Non-deductible trip expense',

  // Document Status
  document_status_uploaded: 'Uploaded',
  document_status_processed: 'Processed',
  document_status_processing: 'Processing',
  document_status_rejected: 'Rejected',
  document_status_deleted: 'Deleted',
  document_status_approved: 'Approved',

  // Invoice Status Descriptions
  document_status_description_uploaded:
    'The data has been analyzed by our algorithm but has not yet been verified or processed by our accounting department.',
  document_status_description_processed:
    'The data has been thoroughly verified and processed by our accounting department, ensuring its accuracy and reliability.',
  document_status_description_processing: '---',
  document_status_description_rejected: '---',
  document_status_description_deleted: '---',

  // Payment Status
  payment_status_failed: 'Failed',
  payment_status_succeeded: 'Succeeded',
  payment_status_open: 'Pending',
  payment_status_pending: 'Pending',
  payment_status_paid: 'Paid',

  // Bank Status
  bank_status_manual: 'Manual',
  bank_status_linked: 'Connected',
  bank_status_expired: 'Disconnected',

  // Transactions Types
  debit: 'Debit',
  credit: 'Credit',

  // Matched to
  sales_invoice: 'Sales Invoice',
  purchase_invoice: 'Purchase Invoice',
  canceled: 'Canceled',
  not_matched: 'No',

  // Report Status
  report_status_requirements: 'Requirements',
  report_status_preparation: 'Preparation',
  report_status_done: 'Ready',
  report_status_not_started: 'Not Started',
  report_status_verified: 'Verified',
  report_status_not_needed: 'Not Needed',
  report_status_prepared: 'Prepared',
  report_status_completed: 'Completed',
  report_status_in_preparation: 'In preparation',
  report_status_submitted: 'Pending Taxes',
  report_status_submitted_no_pay: 'Submitted',
  report_status_taxes_paid: 'Taxes paid',
  report_status_ready: 'Ready',
  report_status_calculating: 'Calculating',

  // User Roles
  admin: 'Administrator',
  representative: 'Representative',
  accountant: 'Accountant',
  human_resources: 'Human resources',
  secretary: 'Secretary',
  accountant_estonia: 'Accountant',

  // Subscription Plans
  pro_plan: 'Pro Plan',
  remote_plan: 'Pro Plan',
  premium_plan: 'Premium Plan',
  crypto_plan: 'Premium Plan',
  virtual_plan: 'Virtual Plan',
  ultra_plan: 'Ultra Plan',
  pro_plan_description:
    'Includes full company accounting and monthly reports in compliance with regulations, with support for 1 bank account and up to 100 documents.',
  premium_plan_description:
    'Includes full company accounting and monthly reports in compliance with regulations, plus support for up to 3 bank accounts and 500 documents, along with access to crypto and investment tracking.',
  virtual_plan_description:
    'This option offers a virtual office, a dedicated point of contact, and postal mail forwarding. It excludes accounting services.',
  ultra_plan_description:
    'Includes full company accounting and monthly reports in compliance with regulations, with support for up to 10 bank accounts and 5,000 documents.',
  premium_upgrade_loading: 'Upgrading to PREMIUM...',
  premium_upgrade_success: 'PREMIUM plan upgraded successfully!',
  premium_upgrade_error: 'An error occurred while upgrading to PREMIUM.',
  plan_upgrade_loading: 'Upgrading plan...',
  plan_upgrade_success: 'Plan upgraded successfully!',
  plan_upgrade_error: 'An error occurred while upgrading your plan.',

  // Other
  filter_button: 'Filter',
  filter_save: 'Save these filters',
  react_select_no_options_message: 'No options',
  select_country_placeholder: 'Select a country',
  drop_files_button: 'Browse files',
  drop_files_delete: 'Delete',
  default_form_error_message: 'Please fill all required fields.',
  default_api_error_message: 'An unexpected error occurred. Please try again later.',
  download: 'Download',
  duplicate: 'Duplicate',
  cancel: 'Cancel',
  delete: 'Delete',
  save: 'Save',
  discard_changes: 'Discard changes',
  add: 'Add',
  edit: 'Edit',
  search: 'Search',
  send_by_email: 'Send by email',
  invoice_preview_pdf_error: 'An unexpected error occurred while trying to preview the invoice.',
  invoice_download_error: 'An unexpected error occurred while trying to download the invoice.',
  no_currencies_found: 'No currencies found',
  matched_by_admin: 'Matched by the accountant',
  matched_by_customer: 'Matched by your team',
  matched_by_automatic: 'Matched automatically',
  matched_by_unmatched: 'Unmatched',
  header_feedback_button: 'Feedback',
  support_pin: 'Support PIN',
  full_name: 'Full name',
  first_name: 'First name',
  last_name: 'Last name',
  city: 'City',
  zip_code: 'Zip code',
  language: 'Language',
  role: 'Role',
  email: 'Email',
  email_address: 'Email Address',
  address: 'Address',
  address_street: 'Address street',
  phone: 'Phone',
  phone_number: 'Phone number',
  tax_id: 'Tax ID',
  vat_number: 'VAT number',
  custom_payment_instructions: 'Custom payment instructions',
  initial_invoice_number: 'Initial invoice number',
  country: 'Country',
  check_vat: 'Check VAT',
  check_vta_loading: 'Validating VAT...',
  check_vta_invalid:
    'This VAT number does not seem to be valid. Please check the number and try again. Alternatively, you can leave this field empty if the customer does not have a VAT number.',
  check_vta_valid: 'The VAT number has been successfully verified!',
  check_vta_error: 'There was an error while validating the VAT number.',
  current_photo: 'Current photo',
  upload_photo: 'Upload photo',
  ok: 'Ok',
  copy_error: 'An error occurred while trying to copy the text to the clipboard.',
  copied: 'Text copied to the clipboard!',
  set_primary: 'Set as primary',
  date: 'Date',
  service: 'Service',
  status: 'Status',
  generate_and_copy: 'Generate and copy',
  bank_statements: 'Bank statements',
  add_member: 'Add user',
  delete_member: 'Delete member',
  view_details: 'View details',
  update_eresident_card: 'Update e-Resident card',
  cancel_subscription: 'Cancel subscription',
  upgrade_plan: 'Upgrade plan',
  downgrade_plan: 'Downgrade plan',
  amount: 'Amount',
  type: 'Type',
  description: 'Description',
  set_representative: 'Set as representative',
  location: 'Location',
  confirm_deletion: 'Confirm deletion',
  confirm: 'Confirm',
  see_details: 'See details',
  file_size_exceeded: 'The selected file is too large. Please upload a file no bigger than 2 MB.',
  file_type_not_allowed: 'File type not allowed',
  please_check_data: 'Please check this data',
  details: 'Details',
  type_here: 'Type here',
  upload: 'Upload',
  upload_file: 'Upload a file',
  upload_file_optional: 'Upload a file (optional)',
  under_review: 'Under review',
  yes_confirm: 'Yes, confirm',
  document_name: 'Document name',
  transaction: 'Transaction',
  generate: 'Generate',
  options: 'Options',
  actions: 'Actions',
  document_not_found: 'Document not found',
  select_an_option: 'Select an option',
  choose_an_option_first: 'Choose an option first',
  match: 'Match',
  non_business_expense: 'Non-business expense',
  active: 'Active',
  terminated: 'Terminated',
  download_contract: 'Download contract',
  current_photo_optional: 'Current photo (optional)',
  continue: 'Continue',
  previous_step: 'Previous step',
  company: 'Company',
  uploaded: 'Uploaded',
  yes: 'Yes',
  no: 'No',
  select_file_and_drag_and_drop: 'Select a file or drag and drop here',
  upload_valid_pdf_file: 'Upload a valid PDF file to begin',
  file_added: 'File added',
  upload_new_photo: 'Upload new photo',
  dismiss: 'Dismiss',
  update: 'Update',
  view_online: 'View online',
  matched: 'Matched',
  unmatched: 'Unmatched',
  loading_wait_a_moment: 'Loading, wait a moment...',
  submit: 'Submit',
  close: 'Close',
  proceed: 'Proceed',
  got_it: 'Got it',
  see_more: 'See more',
  allowed_extension_error: 'Only {{extensions}} files are allowed',
  category: 'Category',
  from: 'From:',
  subtotal: 'Subtotal:',
  total: 'Total:',
  business_or_member: 'Business or member',
  dates: 'Dates',
  add_new: 'Add new',
  interest: 'Interest',
  installments: 'Installments',
  select_date_range: 'Select date range',
  date_ascending: 'Date ascending',
  date_descending: 'Date descending',
  date_asc: 'Date ascending',
  date_desc: 'Date descending',
  reset: 'Reset',
  i_understood: 'I understood',
  representative_name: 'Representative name',
  representative_tax_id: 'Representative tax id',
  end_date: 'End date',
  hold_on_let_me_check: 'Hold on, let me check',
  proceed_anyway: 'Proceed anyway',
  disabled: 'Disabled',
  closed: 'Closed',
  bulk_actions: 'Bulk actions',
  unmatch_all: 'Unmatch all',
  transaction_total: 'Transaction total',
  transaction_date: 'Transaction Date',
  recipient: 'Recipient',
  unknown: 'Unknown',
  reference: 'Reference',
  let_me_check_again: 'Let me check again',
  let_me_check: 'Let me check',
  failed: 'Failed',
  no_results_found: 'No results found',
  connect: 'Connect',
  update_now: 'Update now',
  upload_valid_csv_file_to_begin: 'Upload a valid CSV file to begin',
  try_again: 'Try again',
  confirm_payment_modal_title: 'Secure Payment Verification',
  confirm_payment_modal_description:
    'To complete your payment of {{amount}}, due to Monthly accountancy, {{company_name}}, {{date}}, invoice {{invoice_number}}., a quick security check is required.',
  what_to_expect: 'What to Expect:',
  confirm_payment_modal_item_1:
    "1 .You'll be prompted to verify your identity, typically on your bank's secure page.",
  confirm_payment_modal_item_2:
    '2. This might involve entering a password, a code sent to your phone, or another verification method provided by your bank.',
  confirm_payment_modal_item_3: "3. It's quick and ensures your payment is secure!",
  proceed_to_payment: 'Proceed to payment',
  payment_successful: 'Payment Successful!',
  payment_error: 'Payment failed!',
  confirm_payment_modal_success_description:
    'Thank you for performing this verification to reduce fraud, and for your payment.',
  confirm_payment_modal_error_description:
    'The payment has failed. Please ensure you have sufficient funds to cover the costs.',
  processing_3d_verification_title: 'Payment Verified, Processing Payment...',
  processing_3d_verification_message:
    'Thank you for verifying the payment. It is now being processed. Once it settles, we will notify you promptly.',
  recommended: 'Recommended',
  not_recommended: 'Not recommended',
  mark_as_concluded: 'Mark as concluded',
  file_type_error:
    'We can’t accept that file type. Please upload a file with one of the following extensions: {{extensions}}',
  file_size_error: 'The selected file is too large. Please upload a file no bigger than {{size}}',
  too_many_files_error:
    'You’ve uploaded too many files at once. Please select a maximum of {{maxFiles}} files to upload.',
  stay_here: 'Stay here',
  leave: 'Leave',
  company_plan_virtual: 'Virtual',
  company_plan_remote: 'Pro',
  company_plan_crypto: 'Premium',
  company_plan_ultra: 'Ultra',
  company_status_registered: 'Account opened',
  company_status_pending_email_confirmed: 'Pending email confirmation in the registry',
  company_status_eresidency_requested: 'e-Residency requested',
  company_status_pending_company_data: 'Pending company data',
  company_status_pending_company_payment: 'Pending company payment',
  company_status_pending_company_user_confirmation: 'Waiting for user signature for the contract',
  company_status_pending_company: 'In registration',
  company_status_pending_bank_account: 'Pending bank account',
  company_status_pending_vat_number: 'Requesting VAT number',
  company_status_ready: 'In accounting',
  company_status_deleted: 'Account terminated',
  company_status_off_board_requested: 'Off-board Requested',
  company_status_pending_members_signature: 'Pending signature of members in the registry',
  company_status_onhold: 'On Hold',
  company_status_stop: 'Account terminated',
  company_status_pending_company_archives: 'Pending previous provider archives',
  company_status_pending_reinstatement: 'Pending reinstatement on the Registry',
  company_status_pending_power_of_attorney: 'Pending power of attorney permission',
  roles: 'Roles',
  capital_amount: 'Capital amount',
  id_expiration_date: 'ID expiration date',
  shareholder: 'Shareholder',
  id_expiration_tooltip_expired: 'The certificate is expired',
  id_expiration_tooltip_expiring_soon: 'The certificate is about to expire',
  edit_member: 'Edit member',
  total_subtotal: 'Subtotal: {{subtotal}}, Total: {{total}}',
  success: 'Success',
  loading: 'Loading',
  only_accept_euro_as_currency: 'We only accept the euro as currency.',
  upload_modal_description:
    'Effortlessly upload your file by dragging and dropping it here. Click to select a file. Streamline your process with Companio.',
  upload_pdf_file_description: 'Upload a valid PDF, PNG or JPG file to begin',
  result_per_page: 'Results per page',
  send: 'Send',
  phone_verification_modal_title: 'We’d love to have a backup way to reach you',
  phone_verification_modal_title_reminder: 'Phone number verification required',
  phone_verification_modal_description_1:
    'Sometimes emails get lost, blocked, or filtered by mistake. Sharing your phone number helps us make sure <b>we can still reach you quickly if there’s ever something important about your account that needs your attention</b>.',
  phone_verification_modal_description_1_reminder:
    '<b>To continue using the dashboard, you need to verify your phone number.<b>',
  phone_verification_modal_description_2:
    '<b>We’ll only use it for essential communication</b> — never for marketing or spam.',
  phone_verification_modal_description_2_reminder:
    '<span>This helps us keep your account secure and ensures we can reach you quickly if there’s ever an important update or issue.</span><span>We’ll only use it for essential communication — never for marketing or spam.</span>',
  confirm_phone: 'Confirm phone',
  sent_sms_activation_code: "We've sent an SMS with an activation code to your phone {{phone}}",
  phone_verified: 'Phone Verified',
  phone_verified_success_description:
    'Your number is confirmed and your account is now more secure.',
  verification_failed: 'Verification failed',
  phone_verified_error_description: 'We couldn’t verify your number. Please try again.',
  insert_the_code: 'Insert the code',
  ill_do_it_later: "I'll do it later",
  unsupported_country_phone_error:
    'Unfortunately, phone numbers from {{country_name}} are not supported. Please use a phone number from a different country or provider.',
  formik_error_message:
    'Please fill all required fields. The "{{fieldLabel}}" field is missing or invalid.',
  unknown_user: 'Unknown User',
  skip: 'Skip',
  next: 'Next',
  previous: 'Previous',
  end_tour: 'End Tour',
  delete_it: 'Delete it',
  user_not_found: 'User not found',
  upgrade: 'Upgrade',
  customer_phone_number: 'Phone number (optional)',
  uploading_file: 'Uploading file...',
  email_duplicated_exception: 'This email is linked to another account. Try a different email.',
  please_wait: 'Please wait...',
  continue_anyway: 'Continue anyway',
  connect_anyway: 'Connect anyway',
  change_vat: 'Change VAT',
  some_required_fields_are_missing:
    'Some required fields are missing. Please complete them to continue',
  at_least_one_is_required_please_complete:
    'At least one item is required. Please complete all its fields to continue',
  pay_now: 'Pay now',
  open: 'Open',
  complete: 'Complete',
  sign: 'Sign',
  period: 'Period',
  review_now: 'Review now',
  clone: 'Clone',
  duplicate_invoice: 'Duplicate invoice',
  enabled: 'Enabled',

  // Annual Report
  ar_banner_title: 'Time to do the annual report!',
  ar_banner_description:
    'We’ll guide you step by step to prepare, review, and submit your annual report — quickly and without stress.',
  ar_banner_button_text: 'Start now',
  annual_report_charge_title: 'Get Started with Your Annual Report!',
  annual_report_charge_description:
    'Take advantage of our early bird discount and secure the annual report for just {{ price }}€. This amount will be charged to your designated payment method on the <a href="/settings/billing" target="_blank" rel="noreferrer">billing section</a>.',
  proceed_and_pay: 'Let’s do it!',
  maybe_later: 'Maybe later',
  loading_wait: 'Loading, please wait...',
  we_are_processing_your_payment: 'We are processing your payment',
  we_are_processing_your_payment_description:
    'We’re confirming your payment. As soon as it’s completed, we’ll begin preparing your annual report.\n <b>If we need anything from you, we’ll let you know by email.</b>',
  ok_button: 'Ok',
  annual_report_payment_approved_title: 'Your payment has been approved',
  annual_report_payment_approved_description:
    'Your payment was successful. <b>Our system will now start preparing your annual report</b> — we’ll keep you updated as we move forward.',
  annual_report_payment_error_title: "Payment couldn't be completed",
  annual_report_payment_error_description:
    'It seems your payment didn’t go through. Please check your payment method or make sure there are enough funds available. You can update your details anytime under <a href="/settings/billing" target="_blank" rel="noreferrer">Billing</a>.',
  complete_requirements_annual_report_title: 'Complete the requirements for your annual report',
  complete_requirements_annual_report_description:
    'To proceed with your annual report, <b style="font-weight: bold;"> we need you to fulfill certain requirements </b>. This may include uploading documents, reconnecting accounts, or matching existing documents.',
  check_this_later: 'Check this later',
  go_to_annual_report: 'Go to Annual Report',
  go_to_billing: 'Go to billing',
  annual_report_status_title: 'Annual report {{year}}',
  annual_report_requisites_pending_user_subtitle:
    'Please provide the <b>necessary information</b> or complete the <b>required actions</b> so we can continue preparing your annual report.',
  annual_report_requisites_in_preparation_subtitle:
    'We are collecting the necessary details to begin your annual report. <b>You will be notified once we need your input.</b>',
  annual_report_verifying_requisites_subtitle:
    '<b>We are reviewing the submitted requirements.</b> We’ll notify you once the verification is complete or if any additional information or actions are needed from your side.',
  annual_report_accounting_preparing_reports_subtitle:
    'We are preparing the necessary reports for your annual report.',
  annual_report_reports_pending_approval_subtitle:
    '<b>Your reports are ready for review</b>. Please confirm to proceed with your annual report.',
  annual_report_pending_payment_subtitle:
    'Your annual report can’t be processed yet. Please complete the payment to continue with the submission.',
  annual_report_ready_to_signed_subtitle:
    'Your annual report is <b>ready for submission</b>. Please review the details and complete the signing process in the e-Business Register.',
  annual_report_not_all_signed_subtitle:
    'Some documents <b>still require your signature</b>. Complete this step to finalize your annual report.',
  annual_report_signed_subtitle:
    'All documents have been signed. <b>We are verifying everything to finalize your annual report.</b>',
  annual_report_submitted_subtitle:
    'Your annual report has been successfully submitted to the Estonian authorities.',
  requirements: 'Requirements',
  in_preparation: 'In preparation',
  pending_payment: 'Pending Payment',
  review_needed: 'Review needed',
  ready_to_submit: 'Ready to submit',
  pending_signature: 'Pending signature',
  signed: 'Signed',
  requisites: 'Requisites',
  review_your_documents_title: 'Review your annual report documents',
  review_your_documents_description:
    'Your documents have been prepared. <strong style="font-weight: bold">Please review and confirm them to move forward.</strong>',
  sing_annual_report_ebusiness_title: 'Sign your annual report in the e-Business Register',
  sing_annual_report_ebusiness_text:
    'To finalize your annual report, please <strong style="font-weight: bold">sign it in the e-Business Register</strong>. You can find all the necessary details in the annual report section.',
  add_signature_annual_report_title: 'Add your Annual Report Signatures',
  add_signature_annual_report_text:
    '<strong style="font-weight: bold">Some of the documents still require signature</strong>. Please complete this step to proceed with submission.',
  annual_report: 'Annual Report',
  all_reports: 'All reports',
  annual_report_table_details: 'Details',
  annual_report_table_paid: 'Paid',
  annual_report_table_start_date: 'Start date',
  annual_report_table_status: 'Status',
  annual_report_table_getting_started: 'Getting started',
  annual_report_table_requisites: 'Requisites',
  annual_report_table_pending: 'Pending',
  annual_report_table_ready_for_submission: 'Ready for submission',
  annual_report_table_signed: 'Signed',
  annual_report_table_not_all_signed: 'Not all signed',
  annual_report_table_not_required: 'Not required',
  annual_report_table_not_started: 'Not started',
  annual_report_table_submitted: 'Submitted',
  annual_report_table_unfinished: 'Unfinished',
  annual_report_table_review_needed: 'Review needed',
  thank_you_for_starting_annual_report: 'Thanks for Starting Your Annual Report with Us!',
  gathering_requirements_description:
    'We’re gathering all the necessary requirements for your annual report, and you’ll receive a notification as soon as we have everything sorted out.',
  back_to_annual_report: 'Back to Annual Report',
  annual_report_details_step_payment: '1. Payment',
  annual_report_details_step_requisites: '2. Requisites',
  annual_report_details_step_preparation: '3. Preparation & Confirmation',
  annual_report_details_step_signatures: '4. Signature & Submission',
  annual_report_details_step_payment_submitted: 'Submitted',
  chat_with_us: 'Chat with us',
  annual_report_requirements_description:
    'Before we can start preparing your annual report, we need to have all these requisites fulfilled.',
  annual_report_deadline_description: 'You need to fulfill all requisites before March 31',
  all_requirements_fulfilled: 'All requisites fulfilled',
  pending: 'Pending',
  done: 'Done',
  permission_for_the_accountant: 'Permission for Companio',
  missing_bank_statements: 'Missing bank statements',
  missing_documents: 'Missing documents for transactions',
  banks_reconnect: 'Check that your banks are connected',
  give_permission_to_accountant_description:
    'Grant permission to CompanioEstonia OÜ’s registry code: 14522788. You can learn how to give permissions <a href="https://help.companio.co/en/article/how-to-grant-permission-to-prepare-the-annual-report-1ohq0d6/" target="_blank" rel="noreferrer" style="text-decoration: none">here</a>.',
  i_have_already_given_the_permissions: 'I’ve Granted Permissions',
  already_given_permission_to_companio:
    'The permission for CompanioEstonia OÜ’s registry code: 14522788, was already granted.',
  missing_bank_statements_description:
    'Upload the bank statement from each bank by clicking ’Upload’.',
  confirm_missing_bank_statements_description:
    'Click the button below to confirm that you have uploaded all the bank statements.',
  confirm_missing_bank_statements_button: 'Confirm statements',
  bank_statement_description: '{{currency}} {{account}} bank statement for {{date}}',
  wait_a_minute: 'Wait a minute!',
  confirm_document_deletion:
    'Are you sure you want to unmatch this document? This action cannot be undone.',
  changed_my_mind: 'I changed my mind',
  delete_requisites_association_error:
    'There was an error while deleting the requisites association',
  confirm_banks_reconnect_description:
    'Once your bank accounts are reconnected, click the button below.',
  confirm_banks_reconnect_button: 'All banks connected',
  reconnect_your_bank_account: 'Please reconnect your {{bank_name}} bank account',
  requisites_documents_approved_banner_title: 'Great News! Your Documents Have Been Approved!',
  requisites_documents_approved_banner_text:
    "While they're not available for download just yet, our accountant is already hard at work preparing them for your review. We'll keep you updated every step of the way!",
  ready_to_download: 'Ready to download',
  review_documents_first:
    'Please carefully review the Statement of Financial Position and the Statement of Profit or Loss. If you’re unsure what the Statement of Financial Position is, click <a href="https://help.companio.co/en/article/understanding-my-annual-report-r9b8so/" target="_blank" rel="noreferrer">here</a>, and if you need clarification on the Statement of Profit or Loss, click <a href="https://help.companio.co/en/article/understanding-my-annual-report-r9b8so/" target="_blank" rel="noreferrer">here</a>.',
  document_verification: 'Document verification',
  upload_attachments: 'Upload Attachments',
  statement_of_financial_position: 'Statement of financial position',
  statement_of_profit_or_loss: 'Statement of profit or loss',
  decline_documents: 'Decline Documents',
  confirm_documents: 'Confirm Documents',
  decline_documents_title: 'Are you sure you want to reject the documents?',
  decline_documents_description:
    'If you want to reject the documents, <b>please let us know why</b> so we can review and fix the issue quickly.',
  reasoning_rejection_documents_title: 'Please Clarify the Issue',
  reasoning_rejection_documents_description:
    'Explain in detail in the box below what is incorrect and upload a document if necessary.',
  submit_comment: 'Submit Comment',
  confirm_rejection_message_modal_title: 'Comment Successfully Submitted!',
  confirm_rejection_message_modal_description:
    'Our accountant will review your comment and address any possible errors. We’ll notify you once everything is ready.',
  confirm_rejection_need_help_modal_footer:
    'Need help? <a href="/support" target="_blank" rel="noreferrer" style="text-decoration: none">Contact support here</a>',
  comment_submitted: 'Comment Submitted',
  comment_submited_description:
    'Here you can find the comment you’ve left us and the document (if uploaded).',
  preparation_alert_description:
    'The accountant has already prepared the annual report! Confirm that everything is ok',
  preparation_alert_rejection_description:
    'We are sorry for what happened. We will let you know when the accountant reviews everything',
  profit_loss: 'Profit or Loss',
  profit_title: 'You made a profit of {{profit}}€',
  profit_description:
    'Please confirm the amount of profits you have earned by typing the same amount. If it’s a different amount, please enter it. Then click ’Confirm Profits’.',
  confirm_profits: 'Confirm Profits',
  company_registered_before_2023_warning:
    '<b>Reminder: </b>If your company was registered before 2023, make sure your share capital has been fully <a href="https://help.companio.co/en/article/how-to-declare-the-share-capital-vh1ic8/" target="_blank" rel="noopener noreferrer">registered and paid</a> <b>before distributing any dividends.</b>',
  annual_report_admin_profit_rejection_alert:
    '<b>IMPORTANT:</b> The selected profit amount requires an update. Review our feedback and submit a new amount to continue.',
  annual_report_admin_loss_rejection_alert:
    '<b>IMPORTANT:</b>  Update your selection to proceed. The option you chose can’t be accepted. Review the comments and select another option.',
  invalid_profit_error:
    'Please enter a positive amount of dividends to distribute, making sure it doesn’t exceed €{{profit}}.',
  confirm_documents_modal_title: 'Are You Sure You Want to Confirm the Documents?',
  confirm_documents_modal_description_1:
    'Before proceeding, please make sure the documents are correct.',
  confirm_documents_modal_description_2:
    'Accurate uploads and permissions will help our system process your annual report smoothly.',
  annual_report_preparation_confirm_success_title: 'Documents confirmed successfully',
  annual_report_preparation_confirm_success_description:
    'Your documents have been successfully confirmed. You’ll be automatically redirected to the next step.',
  waiting_for_submission_banner_title: 'We’re glad to hear everything is okay!',
  waiting_for_submission_banner_text:
    'Relax and take it easy while the accountant carefully reviews the details.',
  loss_title: 'You had a loss of {{loss}}€',
  loss_description:
    'The financial reports show that your company had losses during the financial year. The accountant has specified some ways in which you can prevent this scenario, and we need you to pick one and upload the appropriate document, signed digitally with your e-Residency card. More info <a href="https://help.companio.co/en/article/i-have-losses-what-can-i-do-12qy9j6/" target="_blank" rel="noreferrer" style="text-decoration: none">here.</a>',
  intangible_assets: 'Intangible assets',
  intangible_assets_description:
    'One option is to classify certain expenses as intangible assets, meaning they are treated as investments in the business rather than expenditure. For example, intellectual property, development and design expenses may be considered intangible assets if they were genuinely invested in the development or construction of the company’s technological infrastructure.<br/> <br/>In such cases, you’ll need a digitally signed letter from the shareholders explaining that the expenses relate to intangible assets X and Y, and that their value is intrinsically invested in the company and its technology platform.<br/> <br/>This option will not remove the loss, but it can help prevent a bankruptcy-like situation that occurs when a company has losses it cannot justify or cover.<br/><br/>Download the template <a href="/assets/docs/intangible_assets.docx" download target="_blank" rel="noreferrer">here</a>, fill it in, sign it digitally with DigiDoc, and upload the .asice document. <b>If you choose this option, you will need to upload the signed document.</b>',
  waive_debt: 'Personal loan',
  waive_debt_description:
    'If you gave the business a loan and the business hasn\'t paid, that can also lead to bankruptcy. To avoid this, you can give up your rights to ask your company to pay you back. In that case, we also need a letter signed digitally by all the shareholders, expressing this resignation.<br/><br/> Download the template <a href="/assets/docs/waive_debt.docx" download target="_blank" rel="noreferrer">here</a>, fill it in, sign it digitally with DigiDoc, and upload the asice document. <b>If you choose this option, you will need to upload the signed document.</b>',
  increase_share_capital: 'Increase share capital',
  increase_share_capital_description:
    "One of the easiest options is to increase the company's share capital and make the payment of that share capital. If you have questions about how to pay (and optionally increase) the share capital, read <a href='https://help.companio.co/en/article/share-capital-in-estonia-how-to-increase-it-uyqpsq/' target='_blank' rel='noreferrer'>this article</a>. If you choose this option, you will be asked to upload a bank payment receipt of the increased share capital, signed digitally with DigiDoc (asice document). <b>If you choose this option, you will need to upload the signed document.</b>",
  first_financial_year: 'First financial year',
  first_financial_year_description:
    'By selecting this option, you are choosing to submit the annual report reflecting a loss, as it is your company’s first financial year.',
  changing_loss_document_modal_title: 'You are about to change your option',
  changing_loss_document_modal_description:
    'The document you previously uploaded will be deleted, and you’ll need to upload a new document for the new option you selected. <br/><strong style="font-weight: bold">Do you want to change the selection?</strong>',
  company_has_loss_covered:
    'Although your company experienced losses during the fiscal year, they were subsequently covered by profits, so THERE IS NO NEED FOR ANY SPECIAL ACTION ON YOUR PART. Simply confirm the report and results to allow our accountants to proceed to the next stage.',
  missing_documents_for_transactions_description:
    'Please select one option for each document. Some options require you to upload a document.',
  all_ready_to_sign: 'All ready to sign',
  sign_annual_report_instructions:
    'Exciting news! Your Annual Report has been uploaded to the Estonian Registry and is ready for your signature. <br/>Here’s how to complete it:',
  sign_annual_report_step_one:
    '<b>Log in to the <a href="https://ariregister.rik.ee/eng/" target="_blank" rel="noreferrer">e-Business Register</a></b> and select “Submission of the annual report.”',
  sign_annual_report_step_two:
    '<b>Compile the report:</b> review the summary and make sure all information is correct.',
  sign_annual_report_step_three: '<b>Review the details</b> to ensure accuracy.',
  sign_annual_report_step_four:
    '<b>Sign the report:</b> add the date if needed and digitally sign it with your e-Residency card.',
  annual_report_submission_final_description_1:
    'If you need help with the signing process, you can check our <a href="https://help.companio.co/en/article/how-to-sign-my-annual-report-step-4-and-how-to-download-it-1tj4api/" target="_blank" rel="noreferrer">step-by-step guide</a> in our Knowledge Base, where we explain how to sign your annual report in the Estonian Registry.',
  annual_report_submission_final_description_2:
    '<b>Once you’ve signed the report, come back to the dashboard and click the button</b> to confirm that the submission is complete. Our system will handle the next steps and send it to the authorities.',
  annual_report_submission_final_description_3:
    'Thank you for your cooperation throughout this process!',
  complete_steps_sign_description:
    'Once you’ve completed these steps, simply press the button below to notify us that your report has been submitted. This allows us to integrate it into our accounting system.',
  sign_steps_final_description: 'Thank you for your cooperation throughout this process! 🤗',
  everything_signed: 'Everything’s signed',
  verifying_signature_title: 'Our accountant is verifying the signatures',
  verifying_signature_description:
    'We’ve received your notification and are reviewing the register. If all is well, we’ll submit the report. Otherwise, we may ask you to verify your signature. Please <strong style="font-weight: bold">give us a couple of days </strong> to complete this process.',
  not_all_signed_header:
    'We had a look at the Annual Report but it seems it has not been signed by all members of the company 🧐',
  not_all_signed_description:
    'Could you please access the registry to ensure that the annual report has been signed?',
  completed_annual_report_banner_title:
    'Congratulations! You’ve completed the annual report process!',
  completed_annual_report_banner_description:
    'Your annual report has been successfully submitted to the Estonian authorities.<br/>You’ll receive a confirmation email shortly with the submission details.',
  this_is_purchase_invoice_option:
    'This is a purchase, I will upload a purchase invoice from the supplier',
  dont_have_invoice_purchase_option:
    'I don’t have the invoice. Please classify this as a Non-Business Related Expense (25% tax applies)',
  refund_money_to_customer_option:
    'I refunded the money to the customer, I will upload a credit invoice',
  choose_another_matching_type_option: 'I will choose another matching option',
  this_is_sales_invoice_option: 'This is a sale, I will upload a sales invoice',
  will_generate_sales_invoice_option:
    'I will generate an invoice and match it with this transaction',
  refund_from_supplier_option:
    'I received a refund from a supplier, I will upload a credit invoice from them',
  confirm_remove_bank_transaction:
    'Are you sure you want to remove the current matching for this bank transaction? This action cannot be undone.',
  show_match_menu_options_modal_title: 'What is the type of this transaction?',
  select_an_transaction_to_match: 'Please select a transaction to match',
  confirm_movements: 'Confirm movements',
  missing_other_documents: 'Missing other documents',
  missing_other_documents_description:
    'Please upload the documents (invoices, salaries, receipts, etc) that accountant requested.',
  profit_not_distributable_subtitle:
    'Congratulations! Your company had a profit last year, but it cannot be distributed until your share capital is registered.',
  profit_not_distributable:
    '⚠️<strong style="font-weight: bold">IMPORTANT!</strong> Before distributing dividends, you must first register your company\'s share capital. Currently, the share capital for your business has not been registered, so dividends cannot be distributed at this time. You can learn more about how to register your share capital <a href="https://help.companio.co/en/article/how-to-declare-the-share-capital-vh1ic8/" target="_blank" rel="noreferrer" style="text-decoration: none">here</a>.',
  confirm_signature_annual_report_modal_title: 'You are about to confirm this action',
  confirm_signature_annual_report_modal_description:
    'Are you sure that the annual report has been successfully signed in the registry?',
  requisites_uploaded_banner_title: 'Thank You for Uploading the Documents!',
  requisites_uploaded_banner_description:
    'Our accountant will now begin verifying the information you’ve provided to ensure accuracy. If we require any additional documents, we’ll notify you via email.',
  confirm_all_requisites_modal_title: 'Ready to move forward?',
  confirm_all_requisites_modal_description_1:
    'Before continuing, please make sure you’ve completed all requisites.',
  confirm_all_requisites_modal_description_2:
    'Accurate uploads and permissions will help our system process your annual report smoothly.',
  all_correct: 'All Correct',
  i_will_review_them: 'I’ll review them',
  balances: 'Balances',
  add_to_financial_report: 'Add to financial report',
  delete_duplicated: 'Delete duplicated',
  choose_other_option: 'Choose another option',
  choose_one: 'Choose one',
  choose_one_option: 'Choose one option',
  today: 'Today',
  yesterday: 'Yesterday',
  last_week: 'Last week',
  this_month: 'This month',
  last_quarter: 'Last quarter',
  missing_payment_documents: 'Missing payments for documents',
  missing_payments_documents_description:
    'Please upload the documents (invoices, salaries, receipts, etc) that accountant requested.',
  will_write_debit: 'I would like you to write off the debt for this.',
  will_pay_next_year: 'I will pay it next year.',
  will_upload_purchase_credit_note:
    'I will upload a purchase credit note that the supplier sent to me.',
  it_is_paid_purchase:
    'The invoice was paid from the business bank account, I will upload a statement or payment confirmation as a proof.',
  was_paid_out_of_pocket:
    'I paid this invoice. I will upload the payment bank statement confirmation.',
  will_upload_sales_credit_note: 'I will upload a sales credit note.',
  will_get_payment_next_year: 'I will get the payment next year.',
  it_is_paid_sales: 'It is paid. I will upload the payment bank statement confirmation.',
  there_is_bank_transactions_already_i_will_match:
    'There is a bank transaction already on the dashboard. I want to match.',
  confirm_unlink_entity_from_matching_modal_description:
    'Are you sure you want to delete this document? This action cannot be undone.',
  transaction_unlinked_successfully: 'Transaction unlinked successfully',
  entity_not_found: 'Entity not found',
  bank_statement_document: 'Bank statement document',
  bank_statement_removed_successfully: 'Bank statement removed successfully',
  no_extra_action_required: 'No extra action is required',
  invalid_document_type: 'Invalid document type',
  select_bank_modal_title: 'Select a bank',
  must_select_a_bank: 'You must select a bank to proceed',
  bank_statement_uploaded_successfully: 'Bank statement uploaded successfully',
  confirm_redirect_to_matching_page_modal_description:
    'This action will redirect you to the document matching page. Are you sure you want to proceed?',
  confirm_unmatch_transaction_modal_description:
    'This will remove the current matching for this bank transaction. This action cannot be undone. Are you sure?',
  confirm_payments: 'Confirm payments',
  uploading_document: 'Uploading document',
  document_uploaded_successfully: 'Document uploaded successfully',
  annual_report_requirements_banking_fee: 'Banking fee',
  annual_report_requirements_gross: 'Gross',
  annual_report_contract: 'Annual report contract',
  annual_report_contract_description_1:
    'Welcome to Companio. These Terms and Conditions (hereinafter, the “Terms”) govern the contractual relationship between the client (hereinafter, the “Client”) and CompanioEstonia OÜ (hereinafter, “Companio” or the “Provider”), a company registered in Estonia under registration number 14522788, authorized by the Estonian Financial Intelligence Unit (FIU000295), with its registered office at Lõõtsa 5, 11415, Tallinn, Harju County, Estonia.',
  annual_report_contract_description_2:
    'Companio operates as a Business-as-a-Service (BaaS) platform aimed at simplifying business operations for digital and international entrepreneurs. Through a 100% remote and digital approach, it offers accounting, tax compliance, company formation, legal address and contact services, virtual office, strategic financial support, and international employment management.',
  annual_report_contract_early_bird:
    'Take advantage of our early bird discount and secure your annual report for just <0>€250 + VAT</0>. This amount will be charged to your default payment method in the <1>Billing section</1>.',
  accept_our_terms_and_conditions: 'Accept our <0>Terms and Conditions</0>.',
  before_processing_with_the_payment: 'Before proceeding with the payment',
  preparation: 'Preparation',
  preparation_and_confirmation: 'Preparation & Confirmation',
  profit_or_loss: 'Profit or Loss',
  signature_and_submission: 'Signature & Submission',
  annual_report_requisites_header_title: 'All requisites must be completed before March 31',
  annual_report_requisites_header_description:
    'Please review the requisites below and complete any pending actions. <b>Our system will guide you through each step</b> until everything is ready to start your annual report.',
  annual_report_requisites_permission_for_accountant_title: 'Permission for the accountant',
  annual_report_requisites_permission_for_accountant_description:
    'Give access to ID {{id}}, {{name}}. See how <a href="https://help.companio.co/en/article/how-to-grant-permission-to-prepare-the-annual-report-1ohq0d6/" target="_blank">here</a>.',
  annual_report_requisites_banks_connected_title: 'Check that your banks are connected',
  annual_report_requisites_banks_connected_description:
    'Total disconnected banks: {{disconnected_banks}}',
  annual_report_requisites_bank_statements_title: 'Missing bank statements',
  annual_report_requisites_bank_statements_description:
    'Total of missing statements: {{bank_statements}}',
  annual_report_requisites_documents_for_transactions_title: 'Missing documents for transactions',
  annual_report_requisites_documents_for_transactions_description:
    'Total of missing documents: {{documents}}',
  annual_report_requisites_payments_for_documents_title: 'Missing payments for documents',
  annual_report_requisites_payments_for_documents_description:
    'Total missing payments: {{payments}}',
  annual_report_requisites_other_documents_title: 'Missing other documents',
  annual_report_requisites_other_documents_description:
    'Total missing documents: {{other_documents}}',
  granted: 'Granted',
  review: 'Review',
  start: 'Start',
  back_to_requisites: 'Back to requisites',
  reconnect_your_bank_accounts: 'Reconnect your bank accounts',
  upload_bank_statements_from_each_bank:
    "Upload the bank statement from each bank by clicking 'Upload'.",
  proceed_to_invoicing_modal_title: 'You’re about to open the Invoicing tool',
  proceed_to_invoicing_modal_description_1:
    'This action will take you to our invoicing tool so you can create your invoice.',
  proceed_to_invoicing_modal_description_2:
    'Once it’s done, <b>you’ll be automatically redirected back here to continue.</b>',
  creating_invoice_for_annual_report_alert:
    'You are generating an invoice to match with a transaction from the Annual Report: "{{transaction_name}}"',
  invoicing_from_annual_report_value_error:
    'The total value of the invoice must be equal to the total value of the transaction.',
  hold_on_wait_a_minute: 'Hold on, wait a minute!',
  confirm_annual_report_signature_modal_title: 'Have you signed your Annual Report?',
  confirm_annual_report_signature_modal_description:
    'Please confirm that the signing is complete in the e-Business Registry so we can finalize the process.',
  verifying_signature_banner_title: 'We are verifying the signature',
  verifying_signature_banner_description:
    'We’ve received your notification and we are reviewing the register. If everything is correct, your annual report will be submitted automatically. Otherwise, we’ll contact you if any additional action is required. Please allow a couple of days for this process to be completed.',
  not_all_signed_annual_report_alert:
    '<b>IMPORTANT:</b> It looks like the annual report hasn’t been signed by all company members yet. Please ensure that every required signature is completed before proceeding.',
  rounded_amounts_annual_report_alert:
    'Amounts displayed in the Estonian e-Business Register may be rounded by their system for reporting purposes, <b>so totals may not exactly match the sum of individually rounded accounting figures shown on the dashboard</b> (differences may be around 1 euro). The final submitted reports remain accurate in both accounting records and the e-Business Register.',
  please_upload_or_match_missing_documents:
    'Please upload or match the missing documents (invoices, salaries, receipts, etc.) related to these payments.',
  please_upload_confirmation_documents_from_bank:
    'Please upload confirmation documents from bank or match with options related to these invoices.',
  annual_report_other_documents_description_2:
    'Please upload the missing documents for the items below. If you don’t have a document, leave a short comment so we know how to proceed.',
  document_request: 'Document request',
  i_will_upload_it: 'I will upload it',
  dont_have_it_leave_comments: "I don't have it. Leave your comments.",
  edit_comment: 'Edit comment',
  add_comment: 'Add comment',
  add_your_comment: 'Add your comment',
  annual_report_getting_started_banner_title: 'Thanks for Starting Your Annual Report with Us!',
  annual_report_getting_started_banner_december_description:
    'Thanks for paying early! Annual Reports officially begin at the start of the year. As one of the early payers, your report is already in the priority queue and will be among the first we start. Please sit tight — we’ll get to yours as soon as the season begins.',
  annual_report_getting_started_banner_early_january_description:
    'The Annual Report season has just begun, and we’re currently reviewing all accounts and preparing the required documents for submission. You’ll receive an email with instructions as soon as the requirements for your report are ready.',
  annual_report_getting_started_banner_mid_january_description:
    'Thanks for your recent payment! We’re reviewing your accounting data and compiling the requirements for your Annual Report. This process can take a few days — if you don’t hear from us within the week, feel free to reach out.',
  annual_report_getting_started_banner_late_january_description:
    'We prioritize Annual Reports based on the payment date, and yours is already in the queue. If it’s been over a week since you paid and you haven’t heard from us yet, feel free to reach out — we’re here to help.',
  annual_report_requisites_fulfilled_banner_title: 'Thank you for fulfilling your requisites!',
  annual_report_requisites_fulfilled_banner_description_1:
    'Our system will now review the information you’ve provided to ensure everything is accurate.',
  annual_report_requisites_fulfilled_banner_description_2:
    'If any additional documents or information are required, we’ll notify you by email.',
  annual_report_requisites_approved_banner_title: 'Great news! Your requisites have been approved',
  annual_report_requisites_approved_banner_description_:
    'We’re preparing your documents for review. They’ll be available for download shortly, and we’ll keep you updated by email every step of the way.',
  annual_report_missing_requisites_alert:
    '<b>SOME Requisites need attention:</b> Please review the sections below to complete or update any missing or rejected items.',
  annual_report_has_profit_of: 'You made a profit of {{profit}} €',
  annual_report_has_loss_of: 'Your company had a loss of {{loss}} €',
  annual_report_profit_description:
    'Specify the amount of profit you wish to distribute as dividends. If you choose not to distribute any profit, type 0 and click Confirm.',
  annual_report_loss_description:
    '<b>According to your financial reports, your company recorded a loss this year.</b> We have identified a few ways to prevent this situation. Please select one of the options below and upload the required document, digitally signed with your e-Residency card. More info <a href="https://help.companio.co/en/article/i-have-losses-what-can-i-do-12qy9j6/?bust=1765966522848" target="_blank" rel="noreferrer">here</a>.',
  upload_file_choose_pdf: 'Upload a file (Choose a PDF)',
  waive_loan_debt: 'Waive loan debt',
  annual_report_tour_welcome_step_title: 'Welcome to your annual report panel',
  annual_report_tour_welcome_step_description:
    '<p><strong>This process has 4 main stages.</strong></p><p>Let’s start with Requisites, where you’ll complete any actions needed for us to prepare your Annual Report</p><p><strong>Depending on your activity this year, you may see several sections here — or just a few.</strong></p><p>If there’s anything to complete, we’ll guide you step by step so you know exactly what to do.</p>',
  annual_report_tour_requisites_step_title: 'Let’s take a closer look.',
  annual_report_tour_requisites_step_description:
    'To get started, you will need to click on the "Start" button on any section. <strong>Each one will walk you through the specific steps you need to complete</strong> — if any apply to your case.',
  annual_report_tour_banks_reconnect_description:
    'Each section includes simple, guided steps <strong>to complete any requisites you may have</strong> — just follow the instructions shown.',
  annual_report_tour_missing_documents_step_description:
    '<p>In some sections — like Missing documents for transactions — <strong>you’ll need to review each item and choose an option from the dropdown</strong>. </p><p>Depending on what you select, you may need to upload a document, match it, generate an invoice, or simply confirm that no action is required in the “Actions” column.</p>',
  annual_report_tour_missing_documents_confirm_step_description:
    'When a section is fully completed, the "Confirm" button will activate. <strong>Just click it to move forward.</strong>',
  annual_report_tour_requisites_last_step_description:
    '<p>Once all requisites are completed, you’ll be taken to the overview screen to double-check that everything is ready for us to begin preparing your report. </p><p><strong>After this stage, you’ll move on to the next three steps that complete your annual report.</strong></p><p>We’ll keep you updated by email as your report progresses.</p>',
  why_was_this_rejected: 'Why was this rejected?',
  annual_report_rejected_reasons_alert:
    '<b>Check the items with the red icon and click on the arrow to see the reasons for rejection and correct them.</b>',
  delete_other_document_confirm:
    'Are you sure you want to delete this document? This action cannot be undone.',
  annual_report_preparation_reject_success_title: 'Comment submitted successfully!',
  annual_report_preparation_reject_success_description:
    'Thank you for your feedback. Our system will review your comment and notify you once everything is ready.',
  annual_repot_preparation_rejected_alert:
    '<b>We’ve received your comments and our system is reviewing them.</b> You’ll be notified by email once the documents have been updated.',
  annual_report_preparation_rejection_reason_description:
    'Here you can review the comment you submitted and any document you attached.',
  annual_report_confirm_documents_profit_with_dividends_title:
    'You have decided to distribute {{dividends}}€ in dividends ',
  annual_report_confirm_documents_profit_no_dividends_title:
    'You have decided not to distribute any profits this year',
  annual_report_confirm_documents_loss_title: "You've decided to declare losses as {{loss_option}}",
  annual_report_confirm_documents_profit_with_dividends_description:
    'Before continuing, please check that the entered amount is correct.<br/><br/>Our system will move forward once you confirm.',
  annual_report_confirm_documents_profit_no_dividends_description:
    'Please confirm that this is the option you want to proceed with.<br/><br/>Our system will move forward once you confirm.',
  annual_report_confirm_documents_loss_description:
    'Please confirm that <b>you have read the description of the option and attached the document</b>.<br/><br/>Once confirmed, our system will proceed with the next step of your annual report.',
  annual_report_information_submitted_banner_title:
    'Your information has been submitted successfully.',
  annual_report_information_submitted_banner_description:
    'We’ll review everything carefully and notify you by email as soon as the next step is ready.',
  annual_report_reviewing_loss_banner_title: 'We’re reviewing your loss-management choice',
  annual_report_reviewing_loss_banner_description:
    'We are verifying the action you chose to manage your company’s losses. We’ll confirm the outcome and next steps by email once the review is complete.',
  amount_of_confirmed_profits: 'Amount of confirmed profits',
  balance_sheet_and_income_statement: 'Balance sheet and income statement',
  financial_reports: 'Financial reports',
  reason_for_revision: 'Reason for revision',
  balance_sheet_preview_description:
    'This is a sample of reports (Statement of Profit or Loss (Scheme 1) and Statement of Financial Position), so you can see the approximate data included in your annual report.',
  balance_sheet_final_preview_description:
    'This is the final annual report filed with the registry. You can view and download it at any time.',
  period_start_date: 'Period start date',
  period_end_date: 'Period end date',
  submission_date: 'Submission date',
  statement_of_profit_or_loss_scheme: 'Statement of Profit or Loss (Scheme1)',
  revenue: 'Revenue',
  total_profit_loss: 'Total profit (loss)',
  profit_loss_before_income_tax: 'Profit (loss) before income tax',
  net_profit_loss_for_financial_year: 'Net profit/loss for financial year',
  assets: 'Assets',
  current_assets: 'Current assets',
  cash_and_cash_equivalents: 'Cash and cash equivalents',
  receivables_and_prepayments: 'Receivables and prepayments',
  trade_receivables: 'Trade receivables',
  receivables_from_connected_parties: 'Receivables from connected parties',
  tax_prepayments_and_receivables: 'Tax prepayments and receivables',
  other_receivables: 'Other receivables',
  total_current_assets: 'Total current assets',
  total_fixed_assets: 'Total fixed assets',
  total_assets: 'Total assets',
  current_liabilities: 'Current liabilities',
  trade_payables: 'Trade payables',
  tax_payables: 'Tax payables',
  issued_capital: 'Issued capital',
  profit_loss_for_the_year: 'Profit (loss) for the year',
  total_current_liabilities: 'Total current liabilities',
  total_liabilities: 'Total liabilities',
  total_liabilities_and_owners_equity: "Total liabilities and owners' equity",
  annual_report_final_file_submitted: 'Annual report final file submitted',
  final_annual_report_submission: 'Final Annual Report submission',
  financial_investments: 'Financial Investments',
  total_receivables_and_prepayments: 'Total receivables and prepayments',
  inventories: 'Inventories',
  total_inventories: 'Total inventories',
  fixed_assets: 'Fixed assets',
  tangible_assets: 'Tangible assets',
  total_property_plant_and_equipment: 'Total property, plant and equipment',
  intangible_fixed_assets: 'Intangible fixed assets',
  loan_liabilities: 'Loan liabilities',
  total_loan_commitments: 'Total loan commitments',
  payables_and_prepayments: 'Payables and prepayments',
  total_payables_and_prepayments: 'Total payables and prepayments',
  non_current_liabilities: 'Non-current liabilities',
  total_non_current_liabilities: 'Total non-current liabilities',
  equity: 'Equity',
  uncalled_capital: 'Uncalled capital',
  unregistered_share_capital: 'Unregistered share capital',
  retained_earnings_deficit: 'Retained earnings (deficit)',
  total_owners_equity: "Total owners' equity",
  liabilities_and_owners_equity: "Liabilities and owners' equity",

  // Contractors
  contractors: 'Contractors',
  position: 'Position',
  salary: 'Salary',
  pending_employee_signature: 'Pending signature',
  termination_requested: 'Termination requested',
  all_contractors: 'All Contractors',
  new_contractor: 'New Contractor',
  personal_data: '1. Personal Data',
  contract_data: '2. Contract Data',
  payment_information: '3. Payment Information',
  add_contractor: 'Add Contractor',
  contractor_avatar_description:
    'The photo will help you differentiate your employees. Max Photo size 1 MB.',
  contractor_address_description:
    '* This field represents the country where the contractor is registered for tax purposes, typically their home country or a country where they are registered as a freelancer or equivalent. This is essential for their eligibility to work as a contractor in that country.',
  activity: 'Job position',
  generated_by_ai_description:
    'This job position has been generated by AI. Please feel free to adjust it to your needs',
  currency: 'Currency',
  work_hours_per_week: 'Working hours/week',
  start_date: 'Start date',
  end_date_optional: 'End date (optional)',
  yearly_vacation_days: 'Yearly vacation days',
  notice_period_in_days: 'Notice days',
  gross_salary: 'Gross salary',
  add_contractor_step_footer_description:
    'The final amount would be different from the gross salary due to taxes and our fees. Our EOR Partner will contact you in the next few days to notify you of the total amount for your review. Amount may vary each month.',
  please_select_currency: 'Please select a currency',
  iban_contractor: 'IBAN/Account number',
  bic_contractor: 'BIC/SWIFT/Routing number',
  contractors_documents_required: 'Documents required',
  contractors_documents_required_description:
    'Enter proof of residence, ID or residence ID of the employee.',
  ai_generating_job_description:
    'We are generating the job description through AI... Feel free to modify it as needed.',
  please_select_notice_period: 'Please select a cancellation/end of contract notice days',
  creating_contractor: 'Creating contractor...',
  contractor_created: 'Contractor created successfully',
  back_to_contractors: 'Back to Contractors',
  account_wage_payments: 'Account for wage payments',
  retry_pending_payment: 'Retry pending payment',
  terminate_contractor_contract: 'Terminate contract',
  payrolls_not_started: 'Payrolls not started',
  invoices_stopped: 'Invoices stopped',
  invoices_scheduled: 'Invoices scheduled',
  payrolls_stopped: 'Payrolls stopped',
  update_info: 'Update info',
  replace_contract: 'Replace the contract',
  regenerate_contract: 'Re-generate the contract',
  payrolls: 'Payrolls',
  invoice_not_matched: 'Invoice not matched',
  invoice_matched: 'Invoice paid & matched',
  invoices: 'Invoices',
  match_invoice: 'Match invoice',
  see_transaction: 'See transaction',
  has_not_matched_invoices:
    'There are invoices that have not been matched. Please proceed to match them.',
  all_invoices_are_matched:
    'All invoices processed. Thanks for keeping track of your contractor’s wage payments.',
  pending_signature_alert:
    'We need the contractor to sign the services agreement to continue the process.',
  terminate_contract_modal_title: 'Are you sure you want to cancel this contract?',
  terminate_contract_modal_description:
    '<strong style="font-weight: bold">Important:</strong> The contract will terminate on {{terminationDate}}. This means that the status of the contract will change to "In termination" and in the meantime the contractor can upload his last invoice, so this action is not immediate. Do you still want to continue?',
  terminate_contract_successfully_modal_title: 'Contractor cancelation initiated',
  terminate_contract_successfully_modal_description:
    'Employee cancellation initiated: Our team is reviewing the request and will follow up with both you and the employee shortly. The cancellation process may require input from both the employer (you) and the employee.',
  termination_requested_alert:
    'Termination requested. Allow for one month time while the contract is terminated.',
  terminated_alert:
    'The services agreement of this contractor was terminated on {{terminationDate}}.',
  replace_contract_modal_title: 'Replace the contract',
  replace_contract_modal_description:
    'Please upload the new contract for the contractor. This will replace the previous one, so make sure the new contract includes all necessary details before submitting.',
  confirm_regenerate_contract_modal_title: 'Are you sure you want to regenerate the contract?',
  confirm_regenerate_contract_modal_description:
    'This action will regenerate the contract. Any existing contracts will be deleted, and a new contract will be generated based on the current data. Please confirm before proceeding.',
  contract_regenerated_successfully_modal_title: 'Contract regenerated',
  contract_regenerated_successfully_modal_description:
    'The previous contract has been replaced and saved in the system.',
  edit_contractor: 'Edit contractor',
  regenerate: 'Regenerate',
  contractor_updated_successfully_modal_title: 'Contractor information has been updated',
  contractor_updated_successfully_modal_description:
    'Before you go, would you like to regenerate the contractor’s contract or upload a new one?',
  pending_contractor_updated_successfully_modal_title: 'Contractor information has been updated',
  pending_contractor_updated_successfully_modal_description:
    'The contractor information has been updated and the contract has been regenerated successfully.',
  reupload_contract: 'Reupload contract',
  want_upload_my_own_contract_label:
    'I want to upload my own contract document (otherwise, we will generate one for you).',
  contractor_created_successfully_modal_title: 'Contractor notified!',
  contractor_created_successfully_modal_description:
    'We have requested your contractor to review and sign the contract. Once completed, the agreement will be activated.',
  contractor_termination_pending_modal_title: 'Contractor termination pending',
  contractor_termination_pending_modal_description:
    'A contractor with this email is currently pending termination. Would you like to complete the termination process and continue creating a new contractor?',
  one_week: 'One week',
  fifteen_days: 'Fifteen days',
  one_month: 'One month',
  two_months: 'Two months',
  terminated_alert_without_date: 'The services agreement of this contractor was terminated.',
  contract_replaced_successfully: 'Contract replaced successfully',
  contract_attached_successfully_modal_title: 'Contract Attached Successfully',
  contract_attached_successfully_modal_description:
    'We’ve extracted key information from your contract and pre-filled some of the form fields for you.',
  download_invoice: 'Download invoice',
  link_invoice: 'Link invoice',
  wage: 'Wage',
  terminating_contractor_contract_loading: 'Terminating contractor contract, please wait...',
  confirm_terminate_contractor_modal_title: 'Cancel contractor’s profile?',
  confirm_terminate_contractor_modal_description_one:
    'You’re about to cancel this contractor’s profile. Since the services agreement hasn’t been signed yet, no further action is required.',
  confirm_terminate_contractor_modal_description_two:
    '<strong style="font-weight: bold">This action is permanent and will remove the contractor from the list</strong>. It also means there will be no collaboration with this contractor through Companio.',
  pending_contract_terminated_successfully: 'The contractor has been successfully eliminated.',
  active_contractor_edit_alert:
    'Some fields are locked because this contractor has an active contract. You can still update financial and contact information.',
  contractor_active_contract_updated_modal_title: 'Contract terms have been updated',
  contractor_active_contract_updated_modal_description:
    'The contractor has been notified and will receive a new contract to review and sign.',

  // Employees
  employees: 'Employees',
  all_employees: 'All Employees',
  new_employee: 'New Employee',
  pending_registration_payment: 'Pending Reg. Payment',
  in_registration: 'In Registration',
  resend_signature_request: 'Resend signature request',
  cancel_hiring: 'Cancel hiring',
  cant_cancel_anymore: 'Can’t cancel anymore',
  see_details_payrolls: 'See details & payrolls',
  terminate_employment: 'Terminate employment',
  termination_in_progress: 'Termination in progress',
  add_employee: 'Add Employee',
  employee_address_description:
    '* This field represents the country where the employee is a resident for tax purposes, typically their home country or a country where they are living now. This is essential for their eligibility to work as an employee in that country.',
  work_engagement_type: 'Work engagement type',
  please_select_work_engagement_type: 'Please select the work engagement type',
  full_time: 'Full time',
  part_time: 'Part time',
  remote: 'Remote',
  on_site: 'On site',
  hybrid: 'Hybrid',
  work_location_mode: 'Work location mode',
  probation_period_in_months: 'Probation period',
  three_months: 'Three months',
  four_months: 'Four months',
  five_months: 'Five months',
  six_months: 'Six months',
  notice_period_in_months: 'Notice period',
  please_select_work_location_mode: 'Please select the work location mode',
  please_select_probation_period_in_months: 'Please select the probation period',
  please_select_notice_period_in_months: 'Please select the notice period',
  please_upload_employees_id: 'Please upload employee’s ID',
  employee_created_successfully_modal_title: 'Employment request received!',
  employee_created_successfully_modal_description:
    'We will prepare a quote for hiring the employee, including the gross salary, applicable taxes, and fees, and send it to you soon.',
  eor_quote_provided: 'Quote Provided',
  eor_quote_rejected: 'Rejected',
  eor_quote_requested: 'Quote Requested',
  terminate_employee_contract_modal_title: 'Are you sure you want to cancel this contract?',
  terminate_employee_contract_modal_description:
    'This action is irreversible and will terminate the contract between you and your employee.',
  resend_employee_signature_email_success:
    'The signature email has been successfully resent to the employee.',
  resend_employee_signature_email_loading: 'Resending signature email...',
  terminate_contract_reason_modal_title: 'Contract cancellation',
  terminate_contract_reason_modal_description: 'We need some data before proceeding',
  termination_date: 'Termination date',
  reason_cancelation_employee_contract_label: 'Enter a detailed reason for your request',
  has_company_assets_label:
    'This employee currently possesses company equipment and/or documentation that need to be returned.',
  termination_initiated_modal_title: 'Employee cancelation initiated',
  termination_initiated_modal_description:
    'Employee cancellation initiated: Our team is reviewing the request and will follow up with both you and the employee shortly. The cancellation process may require input from both the employer (you) and the employee.',
  terminate: 'Terminate',
  resignation_requested: 'Resignation requested',
  resigned: 'Resigned',
  back_to_employees: 'Back to employees',
  account_salary_payments: 'Account for salary payments',
  payrolls_scheduled: 'Payrolls scheduled',
  contract_cancelled: 'Contract cancelled',
  cancel_employment_request: 'Cancel the employment request',
  quote_requested_alert:
    'We have received your request and will send you a quote as soon as possible.',
  salary_for: 'Salary for {{date}}',
  salary_paid: 'Salary paid',
  pending_payrolls_alert:
    'There are pending payrolls. Please upload the payroll documents for the employee.',
  all_payrolls_paid_alert:
    'All payrolls processed. Thanks for keeping track of your employee’s salary payments.',
  pending_bonus: 'Pending Bonus',
  bonus_provided: 'Bonus Provided',
  preparing: 'Preparing',
  pending_company_payment: 'Pending Co. payment',
  pending_eor_partner_payment: 'Pending EOR payment',
  pending_payslip: 'Pending Payslip',
  payroll_preparing: 'In preparation',
  cancel_quote: 'Cancel quote',
  accept_quote: 'Accept quote',
  pay_invoice: 'Pay invoice',
  accept_employment_quote: 'Accept employment quote',
  quote_provided_alert:
    'Kindly review and accept the employment quote to kickstart the hiring process.',
  quote_details: 'Quote details',
  contract_details: 'Contract details',
  contract_start_date: 'Contractor’s start date',
  contract_type: 'Contract type',
  fixed_date: 'Fixed date',
  entity: 'Entity',
  job_title: 'Job title',
  payment_details: 'Payment details',
  rate: 'Rate',
  montly: 'Monthly',
  invoice_cicle_ends: 'Invoice cycle ends',
  last_day_of_the_month: 'Last day of the month',
  payment_due: 'Payment due',
  same_day: 'Same day',
  pay_ahead_weekend: 'Pay ahead of the weekend',
  on: 'On',
  social_taxes: 'Social taxes',
  fee: 'Fee',
  setup_fee: 'Setup fee',
  first_payment: 'First payment',
  quote_rejected: 'Quote Rejected',
  delete_employment_request: 'Delete employment request',
  quote_rejected_banner_title: 'This quote has been rejected',
  quote_rejected_banner_description:
    'You cannot edit these details. If you want to reinstate this employee or change the quote data, please contact our Customer Support team through the <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> to update the contract information.',
  quote_rejected_banner_button: 'View reasons',
  review_quote: 'Review quote',
  quote_available_banner_title: 'Quote Available',
  quote_available_banner_description:
    'Great news! We have generated the quote for the employee registration and monthly costs. Please take a moment to review all the details carefully. Once you’re ready, we can proceed with the registration process.',
  cannot_edit_contract_quote_alert:
    'You can not edit contract details. Please contact our Customer Support team through the <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> to update the contract information.',
  quote_provided: 'Quote Provided',
  contract: 'Contract',
  contract_session_details:
    'Please ensure that you download the contract and read it carefully and entirely. It is important to thoroughly review all the details contained within the document.',
  payment_due_on_weekend: 'If the payment due is on a weekend, pay on Friday.',
  monthly_payment: 'Monthly payment',
  monthly_payment_description:
    'This is the approximate amount that your company will pay every month for the employee. The final amount includes not only the gross salary, but also the social taxes and the service fee. The amount may vary slightly each month due to how taxes get calculated during the financial year. <a href="https://help.companio.co/en/article/how-much-do-i-pay-for-an-employee-with-companio-work-17roduz/" target="_blank" rel="noreferrer">Why is that?</a>',
  total_monthly_payment: 'Total amount to pay every month',
  first_payment_description:
    'Important: Your first payment will be different from the monthly payment specified above. It will include the regular payment plus a setup fee and a security deposit. The setup fee covers initial contract costs, while the security deposit safeguards the agreement. Rest assured, the security deposit will be fully refunded at the contract’s end, subject to meeting all terms and conditions.',
  regular_monthly_fee: 'Regular monthly fee',
  security_deposit: 'Security deposit',
  total_first_payment: 'Total amount to pay the first month',
  do_not_agree: 'I do not agree',
  approve_sign: 'Approve and sign',
  employee_sign_modal_title: 'Employee agreement',
  customer_signature: 'Customer signature',
  your_signature: 'Your signature',
  agree_sign: 'Agree and sign',
  enter_your_signature: 'Enter your full name ({{customerName}})',
  quote_signed_successfully_modal_title: 'The employment quote has been approved!',
  quote_signed_successfully_modal_description:
    'The employee will now be invited to sign the contract. Once both parties have signed, we’ll proceed with registration and notify you when the employee becomes active.',
  confirm_decline_quote_modal_title: 'Are you sure you want to reject this quote?',
  confirm_decline_quote_modal_description:
    'Before proceeding, please confirm your decision to reject the quote. You will be asked to provide a reason for your rejection so our team can review it and suggest any possible adjustments if needed.',
  reason_decline_quote_modal_title: 'Let us know why you’re rejecting this quote',
  reason_decline_quote_modal_description:
    'Please provide a reason for your rejection so our team can review it and suggest any possible adjustments if needed.',
  decline_quote_successfully_modal_title: 'Your feedback has been submitted',
  decline_quote_successfully_modal_description:
    'Your reason for rejecting the quote has been successfully sent. We will review your feedback and contact you if further clarification or adjustments are needed.',
  confirm_sign_quote_modal_title: 'Do you want to approve the application?',
  confirm_sign_quote_modal_description:
    'By approving this quote, you will be asked to sign the employee agreement. Once you’ve signed, we’ll send the contract to the employee for their review and signature. <strong style="font-weight: bold">Do you want to continue?</strong>',
  resend_signature_banner_title: 'Employee’s signature is missing!',
  resend_signature_banner_description:
    'We need the employee to sign the employment contract to continue the process. If you need to remind them, enter their email below and forward the info to them.',
  resend_signature_banner_input_placeholder: 'Enter the email here',
  resend_signature_banner_button: 'Re-send invite',
  invalid_email_error: 'Please enter a valid email',
  resend_signature_email_loading: 'Sending signature email...',
  resend_signature_email_success:
    'The signature email has been successfully re-sent to the employee.',
  in_registration_alert: 'Kindly wait while we register the employee with the local authorities. ',
  terminate_employee_contract: 'Terminate employee’s contract',
  add_bonus: 'Add bonus',
  retry_payment: 'Retry payment',
  download_payroll: 'Download payroll',
  download_payslip: 'Download payslip',
  actions_for_remaining_days_label: 'Action for remaining vacation days',
  enjoy_unused_vacation_days: 'Enjoy the unused vacation days',
  get_paid_unused_vacation_days: 'Get paid for the unused vacation days',
  select_remaining_vacation_days: 'Please select remaining vacation days',
  termination_date_less_than_30_days_warning:
    'The selected termination date is less than one month away and must be negotiated with the employee. <strong style="font-weight: bold">You can still proceed, but the date needs confirmation</strong>.',
  terminate_employee_less_than_30_days_successfully_modal_title: 'Action Requested to our HR',
  terminate_employee_less_than_30_days_successfully_modal_description:
    'Our HR has been notified and is currently handling the employee termination.',
  terminate_employee_less_than_30_days_modal_disclaimer:
    'DISCLAIMER: Please do not discuss this termination directly with the employee under any circumstances. Our HR experts will manage the entire process to ensure a smooth offboarding experience and your peace of mind.',
  unable_to_load_employee_data: 'Unable to load employee data',
  updating_employee_photo: 'Updating employee photo...',
  employee_photo_updated_successfully: 'Employee photo has been updated successfully',
  edit_employee: 'Edit employee',
  employee: 'Employee',
  will_send_confirmation_email: 'We’ll send a confirmation email to ensure the address is valid.',
  updating_employee_data: 'Updating employee data...',
  employee_updated_successfully: 'Employee has been updated successfully',
  detailed_reason: 'Detailed reasons',
  cancel_contract_pending: 'Canceling employee contract...',
  confirm_delete_employee_modal_title: 'Are you sure you want to delete this employee?',
  confirm_delete_employee_modal_description:
    'This employee will be removed from your list. This action is irreversible.',
  employee_deleted_successfully: 'The employee has been successfully deleted.',
  add_bonus_modal_title: 'Add bonus',
  add_bonus_this_month: 'Add bonus this month',
  no_bonus_this_month: 'No bonus this month',
  has_bonus_radio_label: 'Confirm bonus by the 4th of this month',
  bonus_description: 'Bonus description',
  eor_partner_paid: 'Partner paid',
  bonus_added_successfully_modal_title: 'Bonus successfully added!',
  bonus_added_successfully_modal_description:
    'The bonus has been added to this employee’s upcoming payroll. Please note that it will be reflected in the next payslip.',
  add_employee_step_footer_description:
    'The final amount would be different from the gross salary due to taxes and our fees. Our EOR Partner will contact you in the next few days to notify you of the total amount for your review. Amount may vary each month. <a href="#" target="_blank" rel="noreferrer" style="text-decoration: none">Why is that?</a>',
  request_salary_update: 'Request salary update',
  requested_salary_update_modal_title: 'Salary update request received',
  requested_salary_update_modal_description_one:
    'Thanks for updating your employee’s salary. Please note that salary changes are not applied immediately.',
  requested_salary_update_modal_description_two:
    '<strong style="font-weight: bold">We need to coordinate this update with our EOR partner to adjust the employment contract, salary, taxes, insurance contributions, and other related obligations.</strong>',
  requested_salary_update_modal_description_three:
    'Once the update is confirmed by our partner, we’ll notify you and apply the changes accordingly.',
  know_more: 'Know more',
  migrate_country_warning_modal_title: 'An employee cannot simply be "migrated" to a new country.',
  migrate_country_warning_modal_description_one:
    'To ensure compliance and accuracy when changing an employee’s country, please follow the steps outlined below:',
  migrate_country_warning_modal_description_two:
    '<strong style="font-weight: bold">Terminate Current Contract</strong>: Initiate termination in the current country, adhering to employment laws.',
  migrate_country_warning_modal_description_three:
    '<strong style="font-weight: bold">Start New Employment Contract</strong>: Begin a new contract in the new country, ensuring compliance with local regulations.',
  migrate_country_warning_modal_description_four:
    'By adhering to these procedures, we can ensure that the employee’s transition to the new country of residence is carried out in full compliance with local employment laws and regulations.',
  migrate_country_warning_modal_description_five:
    '<strong style="font-weight: bold">For assistance, reach out to our team. Thank you for your cooperation.</strong>',
  salary_update_under_input_description: 'Salary updates need approval from our HR team.',
  payment_failed_banner_title: 'Oops! The payment didn’t go through',
  payment_failed_banner_description:
    'The payment for this employment request failed. To complete the process, please click the button below to try the payment again.',
  payment_processing_banner_title: 'Payroll payment being processed',
  payment_processing_banner_description:
    'The current month’s payroll payment for this employee is currently being processed in our payment gateway. We will notify you as soon as the payment settles.',
  contract_not_found: 'Contract not found',
  contract_type_info_modal_title: 'What does "Contract Type" mean?',
  contract_type_info_modal_description_one:
    'This refers to the employee’s work engagement type with your company.',
  contract_type_info_modal_description_two:
    '<b>Full-time:</b> The employee works the standard number of hours defined as full-time in your company or jurisdiction.',
  contract_type_info_modal_description_three:
    '<b>Part-time</b>: The employee works fewer hours than a full-time role, based on the terms defined in the contract.',
  delete_employee_pending: 'Deleting employee...',
  payroll_history_unavailable_message:
    'You will be able to see the payroll history when the employee is registered.',
  enter_bank_details_employee: 'Please enter the bank details of this employee.',
  upload_valid_pdf_or_image: 'Upload a valid PDF or Image file to begin',
  job_position: 'Job position',
  job_description: 'Job description',
  view_more: 'View more',
  view_less: 'View less',
  needs_migration: 'Needs migration',
  deprecated_employee_banner_title: 'Old Estonian employee (deprecated)',
  deprecated_employee_banner_description:
    "With the launch of Companio Work, we're transitioning all employees currently using the old employment schema to either contractors or regular employees within the Companio Work framework. The old employment schema is now deprecated, and support for these employees will be discontinued in the near future. To migrate your employee, cancel this contract and add a new employee either as a contractor or a Companio Work employee.",
  search_by_name_email_position: 'Search by name, email and position',
  gross_salary_warning_description_1:
    '<b>IMPORTANT — READ BEFORE ENTERING THE SALARY:</b> The amount entered here is the <b>GROSS salary, NOT the NET</b> salary the employee will receive. <b>GROSS</b> salary is the contractual salary before taxes and social contributions. The <b>NET</b> salary (the amount the employee actually receives in their bank account) will be lower.',
  gross_salary_warning_description_2:
    'Employment contracts are always defined using GROSS salary, because the NET amount depends on several personal factors, such as: marital status, number of children, place of residence, tax deductions, etc. For this reason, the final NET salary cannot be calculated precisely without the employee’s full tax profile.',
  read_more_about_gross_vs_net_salary:
    '👉 <a href="https://help.companio.co/en/article/how-do-i-register-a-new-employee-with-companio-work-1gzqzai/" target="_blank" rel="noreferrer">Read more about GROSS vs NET salary</a>',
  gross_salary_warning_description_3:
    'If you want to estimate the GROSS salary required to reach your desired NET salary, please <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">contact our team</a> and we will assist you.',
  effective_date: 'Effective Date',

  // Feedback
  feedback_modal_title: 'Got Feedback? Share It!',
  feedback_modal_description:
    'We Love Your Thoughts! Leave us your comments, whether they be suggestions or appreciations. <strong style="font-weight: bold">Your feedback helps us improve!</strong>',
  feedback_input_label: 'Speak your mind',
  positive_feedback_modal_title: 'Thank you for your feedback!',
  positive_feedback_modal_description:
    'If you are happy with our services, we would appreciate it if you could write a review on <strong style="font-weight: bold">Google My Business</strong> or the <strong style="font-weight: bold">Trustpilot</strong>. It will take you just one minute.',
  marketplace: 'Marketplace',
  trustpilot: 'Trustpilot',
  google_my_business: 'Google Business',
  negative_feedback_modal_title: 'Thanks for your feedback — we’re on it',
  negative_feedback_modal_description:
    'We’re sorry to hear that your experience didn’t meet your expectations. <strong style="font-weight: bold">We’ll review your feedback carefully to understand what went wrong and how we can improve</strong>. <br/><br/>Thank you for helping us do better.',

  // Notifications
  notifications: 'Notifications',
  notifications_clean_all: 'Clean All',
  notification_payment: 'Payment Required',
  notification_payment_text:
    'You have a pending payment that requires your attention. Complete it to continue using our services.',
  notification_invoice_missing: 'Missing Invoice',
  notification_invoice_missing_text:
    'We need the invoice for one of your recent transactions. Please upload it to complete your accounting.',
  notification_invoice_unclear: 'Clarify Invoice Details',
  notification_invoice_unclear_text:
    'One of your invoices needs more information to be processed. Please review and update the details.',
  notification_transfer_missing: 'Missing Transfer Invoice',
  notification_transfer_missing_text:
    'We need an invoice for one of your transfers. Please upload the document to complete the transaction.',
  notification_transfer_unclear: 'Clarify Transfer Information',
  notification_transfer_unclear_text:
    'We need more details about a recent transfer to process it correctly.',
  notification_transfers_missing: 'Pending Transactions',
  notification_transfers_missing_text:
    'You have more than 20 pending transactions for over two months. Please complete the transactions.',
  notification_report_ready: 'Your Report is Ready',
  notification_report_ready_text:
    'Your {{report}} accounting report is now available for review and download.',
  notification_pending_package: 'Pending Package Delivery Address',
  notification_pending_package_text:
    'We have received a package for your company. Kindly indicate the address where we should forward it.',
  notification_ticket_answered: 'Support Response Received',
  notification_ticket_answered_text:
    'Our support team has replied to your request. Check the message for more details.',
  vat_report: 'VAT',
  oss_report: 'OSS',
  tsd_report: 'TSD',
  no_notifications: 'Nothing to see here!',

  // Support page
  get_help_support_tab: 'Get help',
  my_tickets_support_tab: 'My tickets',
  page_title_support: 'Support',
  articles_card_title: 'Take a look at our most searched articles',
  articles_card_description: `Can't find the solution you're looking for in this articles? Don't worry! Visit our knowledge base for a wide range of articles. You're bound to find the solution you're looking for!`,
  e_residency_article_link: 'e-Residency of Estonia: 5 Simple Steps to Apply for It',
  annual_report_article_link: '5-Step Annual Report Submission With Companio',
  grant_permission_article_link: 'How to Grant Permission to Prepare the Annual Report',
  change_legal_address_article_link: 'How to Change the Legal Address of Your Company?',
  knowledge_base: 'Knowledge base',
  chat_card_title: 'Chat with us!',
  chat_card_description: `You can contact our customer support agents from 09:00 to 18:00 CET. Wondering why you should use the chat? Let us share 3 compelling reasons:`,
  live_answers_title: '✅ Live answers: ',
  live_answers_description: `We are always available to answer your questions live (and it is much faster than opening a ticket).`,
  saves_times_title: '✅ Saves time:',
  saves_times_description: `We have a lot of ticket activity, so you may not get a quick reply. That's time you could use for something else, that's why chat is the best option.`,
  chat_with_human_title: '✅ Chat with a human:',
  chat_with_human_description: `Behind the chat, there is a human being who will answer your questions in a friendly and fast way so you can solve your doubts.`,
  lets_chat_button: `Let's chat!`,
  tickets_table_title: 'All tickets',
  ticket_table_header_details: 'Ticket details',
  ticket_table_header_customer_name: 'Customer name',
  ticket_table_header_date: 'Date',
  ticket_table_status: 'Status',
  see_ticket_details: 'See details',
  mark_ticket_as_solved: 'Mark as solved',
  ticket_update_pending: 'Updating ticket...',
  ticket_update_success: 'Ticket updated successfully.',
  ticket_update_error: 'There was an error while updating the ticket.',
  confirm_solve_ticket_title: 'Confirm update',
  confirm_solve_ticket_description: 'Are you sure you want to solve this ticket?',
  page_title_ticket_details: 'Back to support',
  support_rate_modal_title: 'How was our support?',
  support_rate_modal_text:
    'Could you please take a moment to rate our support? Feel free to add any comments. <b>Your feedback helps us improve!</b>',
  create_feedback_pending: 'Registering your feedback...',
  feedback_create_success: 'Feedback registered successfully',
  feedback_create_error: 'Error while registering feedback ',
  thank_you_feedback_title: 'Thank you for your feedback!',
  thank_you_description:
    'If you are happy with our services, we would appreciate it if you could write a review on <bold>Google My Business</bold> or the <bold>e-Residency Marketplace</bold>. It will take you just one minute.',
  marktplace_button: 'Marketplace',
  google_business_button: 'Google Business',
  we_are_on_it_title: 'Thanks for your feedback — we’re on it',
  we_are_on_it_description:
    'We’re sorry to hear that your experience didn’t meet your expectations. <bold>We’ll review your feedback carefully to understand what went wrong and how we can improve</bold>. <br /> <br />Thank you for helping us do better.',
  send_message_button: 'Send message',
  resolved: 'Resolved',
  ticket_message_create_success: 'Message sent successfully',
  create_ticket_message_pending: 'Creating ticket message...',
  ticket_filter_open: 'Pending',
  ticket_filter_processing: 'In progress',
  ticket_filter_solved: 'Solved',
  translate_english: 'English',
  translate_spanish: 'Spanish',
  confirm_resolve_ticket_modal_title: 'Ready to resolve this ticket?',
  confirm_resolve_ticket_modal_description:
    'Are you sure your issue has been resolved? If everything’s working fine now, you can go ahead and confirm it.',
  ticket_resolved_success:
    '<b>Your ticket is now marked as resolved!</b> <br /> We’re glad everything’s working smoothly again.',
  support_rate_modal_textarea_placeholder: 'Add your comment here...',
  ticket_table_last_message_date: 'on {{date}}',
  replied: 'Replied',
  unanswered: 'Unanswered',

  // Agreements Page
  agreement_from_company: 'Loan from business',
  agreement_to_company: 'Loan to business',
  agreement_from_member: "Member's loan",
  agreement_created: 'Created',
  agreement_started: 'Started',
  agreement_in_progress: 'In Progress',
  agreement_concluded: 'Concluded',
  agreement_deleted: 'Deleted',
  all_agreements: 'All Agreements',
  agreement_deleted_pending: 'Deleting Loan agreement...',
  agreement_deleted_success: 'Loan Agreement deleted successfully.',
  agreement_deleted_error: 'There was an error deleting the Loan Agreement.',
  agreement_delete_confirmation_modal_title: 'Are you sure you want to delete this loan agreement?',
  agreement_delete_confirmation_modal_description:
    'This action cannot be undone. All data related to this agreement will be permanently deleted.',
  documents: 'Documents',
  document: 'Document',
  add_agreement_warning_modal_title: 'Before you add a new loan…',
  add_agreement_warning_modal_description_html:
    'Please, follow the exact loan amounts stated in your agreement. To ensure accurate accounting, <b>all loan-related payments must exactly match the amounts defined there</b>. <a href="https://help.companio.co/en/article/why-do-i-need-to-follow-the-loan-amounts-exactly-as-stated-in-the-agreement-x6nnnl/?bust=1745330681766" target="_blank" rel="noreferrer">Read more</a>.',
  agreement_active: 'Active',
  date_can_be_set_one_year: 'The date can be set up to one year in the future.',
  no_members_found: 'No members found',
  why_is_this_date_fixed:
    'Why is this <a href="https://help.companio.co/en/article/how-do-loans-work-in-companio-can-i-lend-money-to-my-business-3re9w7/" target="_blank" rel="noreferrer">date fixed</a>?',

  // Add Agreement
  add_agreement_title: 'Add Loan Agreement',
  add_agreement_description:
    'Add new agreements as needed and keep track of existing ones with ease.<b> Please note: Loans from your business to individuals are not allowed, and companies without a FFA license cannot lend to individuals.</b>',
  add_agreement_lend_to_company: 'Lend Money to Company',
  add_agreement_lend_to_company_description: 'I want my business to lend money to another company',
  add_agreement_borrow_from_company: 'Borrow from a Company',
  add_agreement_borrow_from_company_description:
    'I want another company to lend money to my business',
  add_agreement_member_lend_to_business: 'Member Lending to Business',
  add_agreement_member_lend_to_business_description:
    'A member of the company wants to lend money to the business',
  name_of_borrower_business: "Name of borrower's business",
  borrower_business_information: "Borrower's business information",
  lender_business_information: "Lender's business information",
  member_information: 'Member information',
  financial_data_of_loan: 'Financial data of the loan',
  amount_to_lend: 'Amount to lend',
  amount_to_borrow: 'Amount to borrow',
  final_interest_amount: 'Installment amount',
  installments_amount: 'Installment amount',
  starting_date_installments: 'Starting date of Installments',
  agreement_date: 'Agreement date',
  loan_total: 'Loan total',
  calculate_loan: 'Calculate Loan',
  loan_calculation_in_progress: 'Loan Calculation in Progress',
  loan_calculation_in_progress_description:
    'Please allow a few minutes for this process to complete.',
  loan_interest_1_to_20: 'Interest Rate (from 0 to 20%)',
  loan_confirm_modal_title: 'Are you sure you want to add this loan?',
  loan_confirm_modal_description:
    '<b>It cannot be deleted once it has been created</b>, so check that everything is in order before confirming.',
  agreement_created_modal_title: 'Loan Agreement successfully created!',
  agreement_created_modal_description:
    'You can download the Loan Agreement and email it to the {{lender_name}}, just enter the company email below.',
  agreement_send_email_pending: 'Sending email with the agreement...',
  agreement_send_email_success: 'Email with the agreement has been sent successfully.',
  agreement_send_email_error: 'There was an error sending the email with the agreement.',
  name_of_lender_business: "Name of lender's business",
  download_agreement: 'Download agreement',
  number_of_installments: 'Number of installments',

  // Projects Page
  page_title_projects: 'All projects',
  projects_table_header_project_name: 'Project name',
  projects_table_header_creation_date: 'Creation date',
  projects_table_header_responsible_person: 'Responsible person',
  projects_table_header_budget_goals: 'Budget & goals',
  projects_table_header_status: 'Status',
  projects_table_title: 'All projects',
  projects_table_header_add_project_button: 'Add project',
  project_create_success: 'Project created successfully',
  project_create_error: 'There was an error while creating the new project',
  add_project: 'Add Project',
  project_name_placeholder: 'Type here...',
  project_name: 'Project Name',
  responsible_person: 'Responsible person',
  project_responsible_person_placeholder: 'Choose one',
  project_email_placeholder: 'Select user first',
  project_email: 'Email',
  project_budget_placeholder: 'Type here...',
  project_budget: 'Budget',
  project_sales_goal_placeholder: 'Type here...',
  project_sales_goal: 'Sales goal',
  project_expenses_budget: 'Expenses Budget',
  project_email_settings: 'Email settings (Optional)',
  early_budget_alerts: 'Early budget alerts',
  early_budget_alerts_description:
    'Receive early alerts via email when your project budget is approaching its limit (80%), and a final notification once the budget is fully reached.',
  early_sales_goals_alerts: 'Early sales goal alerts',
  early_sales_goals_alerts_description:
    'Receive early alerts via email when your project sales goal is approaching its limit (80%), and a final notification once the sales goal is fully reached',
  delete_project_title: 'Are you sure you want to delete this project?',
  page_title_project_details: 'Back to project',
  responsible_person_label: 'Responsible person',
  responsible_person_email_label: 'Email',
  expenses_stats: 'Expense Stats',
  sales_stats: 'Sales Stats',
  change_budget: 'Change Budget',
  change_sales_goal: 'Change Sales Goal',
  budget_value: 'Budget',
  sales_goal_value: 'Sales Goal',
  reached: 'Reached',
  remaining: 'Remaining',
  sales: 'Sales',
  purchases: 'Purchases',
  other_document: 'Other document',
  processing: 'Processing',
  processed: 'Processed',
  project_documents_table_title: 'List of invoices',
  project_documents_table_header_add_invoice_button: 'Add invoice',
  document_date: 'Date',
  document_type: 'Type',
  document_amount: 'Amount',
  delete_invoice_title: 'Are you sure you want to delete this invoice?',
  remove_invoice_from_project: 'Remove from the project',
  change_project_budget_title: 'Change budget',
  project_current_budget_label: 'current budget',
  project_new_budget_label: 'new budget',
  project_update_budget_pending: 'Updating budget...',
  project_update_budget_success: 'Budget updated successfully',
  project_update_budget_error: 'There was an error while updating budget',
  change_project_sales_goal_title: 'Change sales goal',
  project_current_sales_goal_label: 'current sales goal',
  project_new_sales_goal_label: 'new sales goal',
  project_update_sales_goal_pending: 'Updating sales goal...',
  project_update_sales_goal_success: 'Sales goal updated successfully',
  project_update_sales_goal_error: 'There was an error while updating sales goal',
  mark_concluded_project_title: 'Are you sure you want to mark this project as concluded?',
  mark_project_concluded_pending: 'Marking project as concluded...',
  mark_project_concluded_success: 'Project marked as concluded successfully',
  mark_project_concluded_error: 'There was an error while marking project as concluded',
  delete_project_pending: 'Deleting project...',
  delete_project_success: 'Project deleted successfully',
  delete_project_error: 'There was an error while deleting project',
  project_option_higher_1:
    '<span style="color: #00DA8B;font-weight: 600;">+25%</span> above average',
  project_option_higher_2:
    '<span style="color: #00DA8B;font-weight: 600;">25%</span> higher than average',
  project_option_higher_3:
    'Above average by <span style="color: #00DA8B;font-weight: 600;">25%</span>',
  project_option_lower_1:
    '<span style="color: #FE2142;font-weight: 600;">-15%</span> below average',
  project_option_lower_2:
    '<span style="color: #FE2142;font-weight: 600;">15%</span> lower than average',
  project_option_lower_3:
    'Below average by <span style="color: #FE2142;font-weight: 600;">15%</span>',
  project_option_average_1: 'At the average',
  project_option_average_2: 'Matching average',
  project_option_average_3: '100% of average',
  welcome_to_projects_title: 'Welcome to Projects!',
  welcome_to_projects_description:
    'With Projects, you can now take control of your business finances with a more organized, project-based approach. Whether you’re working on multiple client projects or handling internal initiatives, Projects will help you stay on top of your budget, profit, and expenses for each specific endeavor.',
  why_use_projects_title: 'Why use Projects?',
  set_budget_description:
    '<bold>Set Budgets:</bold> Define a budget for each project and receive early alerts when you’re approaching your limit, helping you stay on track.',
  track_profit_description:
    '<bold>Track Profit:</bold> Easily classify and monitor profit per project, ensuring you know exactly how each project contributes to your bottom line.',
  organize_finance_description:
    '<bold>Organize Finances:</bold> Divide and manage expenses and sales according to specific projects, so your accounting stays clean, organized, and transparent',
  projects_premium_warning: 'Projects are a Premium feature.',
  projects_note:
    "<bold>Note:</bold> Projects don't affect accounting or distribute accounting into separate projects. This feature is just for financial clarity and organizational purposes.",
  projects_premium_upgrade_description:
    "To manage and track your company’s projects directly from the dashboard, you’ll need to upgrade to our Premium plan. This feature is not available in the Pro plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  closure: 'Closure: {{closeDate}}',
  closure_date_label: 'Closure date (Optional)',
  remove_invoice_from_project_modal_title:
    'Are you sure you want to remove this invoice from the project?',
  remove_invoice_from_project_modal_description:
    'The invoice will be removed from the project, however you can add it again later if you want.',
  invoice_deleted_successfully: 'Invoice successfully removed from the project.',
  back_to_projects_list: 'Back to projects',
  remove_invoice_from_project_bulk_action_modal_title:
    'Are you sure you want to remove these invoices from the project?',
  remove_invoice_from_project_bulk_action_modal_description:
    'The invoices will be removed from the project, however you can add them again later if you want.',
  add_invoices_to_project_api_error_description:
    'We could not add the selected invoices because <strong style="font-weight: bold;">{{errorMessage}}</strong>. If you believe this is an error, please contact our Customer Support team through the <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. Our team will be happy to help you.',

  // Workflows page
  page_title_workflows: 'Workflows',
  workflows_table_title: 'All workflows',
  workflows_table_header_add_workflow_button: 'Add workflow',
  workflow_name: 'Workflow name',
  workflow_type: 'Type',
  workflow_status: 'Status',
  workflow_created_date: 'Creation date',
  workflow_categorized_invoices: '# of categorized invoices',
  update_workflow: 'Update',
  disable_workflow: 'Disable',
  delete_workflow: 'Delete',
  add_workflow: 'Add workflow',
  categorize_as: 'Categorize as',
  conditions_for_workflow: 'Conditions for the workflow',
  workflow_choose_type: 'Choose a type',
  tag_category: 'Tag category',
  workflow_clients_input: 'Clients / Providers',
  workflow_description_input: 'Description',
  transaction_description: 'Transaction description',
  transaction_type: 'Transaction type',
  both: 'Both',
  only_debit: 'Only debit',
  only_credit: 'Only credit',
  apply_to_month_invoices: 'Apply workflow to this month invoices',
  add_condition_workflow: 'Add condition',
  workflow_create_pending: 'Creating workflow...',
  workflow_create_success: 'Workflow created successfully',
  workflow_create_error: 'There was error while creating workflow',
  workflow_update_pending: 'Updating workflow...',
  workflow_update_success: 'Workflow update successfully',
  workflow_update_error: 'Error while updating workflow',
  workflows_premium_upgrade_description:
    "To create and optimize your company’s workflows in the dashboard, you’ll need to upgrade to our Premium plan. This feature is not available in the Pro plan. For details on monthly pricing, kindly refer to our <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>pricing page</a>. Are you ready to proceed with the upgrade?",
  categorize_as_input_placeholder: 'Choose one',
  create_workflow_modal_title: 'Workflow created successfully!',
  create_workflow_modal_description:
    'Your new workflow is ready and active. <bold>It will automatically categorize your invoices or transactions based on the conditions you’ve set </bold>. You can update it anytime from the workflow list.',
  invoice_description: 'Invoice description',
  invoice_type: 'Invoice type',
  choose_category_first: 'Choose a category first',

  // Transactions Page
  transactions: 'Transactions',
  transaction_status_booked: 'Booked',
  transaction_status_pending: 'Pending',
  match_with_purchase_invoice: 'Match with uploaded purchase invoice',
  match_with_sales_invoice: 'Match with uploaded sales invoice',
  this_is_internal_transfer: 'This is an internal transfer between accounts',
  this_is_non_business_expense: 'This is a non-business expense',
  other_matching_options_modal_title: "What's this transaction?",
  other_matching_options_modal_description:
    "Choose an option to learn more about the available matching types or <a href='https://help.companio.co/en/article/matching-options-for-transactions-and-how-to-choose-the-right-one-g1twsa/' target='_blank' rel='noreferrer'>click here to read more</a>.",
  bank_fee: 'Banking fee',
  state_fee: 'State fee',
  share_capital: 'Share capital',
  dividends: 'Dividends',
  interest_paid: 'Interest paid',
  none_of_the_above: 'None of the above',
  unmatching_bulk_transactions_pending: 'Unmatching transactions...',
  unmatching_bulk_transactions_success: 'Transactions unmatched successfully.',
  unmatching_bulk_transactions_error: 'There was an error unmatching the transactions.',
  match_internal_transactions_pending: 'Matching internal transactions...',
  match_internal_transactions_success: 'Internal transactions matched successfully.',
  match_internal_error: 'There was an error matching the internal transactions.',
  match_bank_transaction: 'Match bank transaction',
  upload_and_match_purchase_invoice: 'Upload & Match with purchase invoice',
  upload_and_match_sales_invoice: 'Upload & Match with sales invoice',
  match_with_amazon_vat_declaration: 'Match with VAT declaration (Amazon)',
  pending_transaction_label: '[🔒Pending] ',
  transaction_tooltip_description_disabled:
    'This transaction is currently <strong>pending</strong>. It has been initiated by the bank but <strong>has not yet been booked or confirmed</strong>, meaning it can still be reverted or canceled. Therefore, <strong>it cannot be matched</strong> and is displayed only for informational purposes and to verify the accuracy of balances.',
  transaction_search_filter_placeholder: 'Search by description',
  see_matching_details: 'See matching details',
  add_document_to_this_matching: 'Add document to this matching',
  add_transaction_to_this_matching: 'Add transaction to this matching',
  transactions_page_empty_table_description:
    'No active bank accounts are available because you’re hiding closed accounts. <p>Need a tip? <0>Show closed accounts</0></p>',
  no_eligible_banks: 'No eligible banks',
  connect_bank_due_no_bank_account_connected:
    'To provide you with transaction information, please connect at least one bank account and upload your bank statements.',
  connect_your_bank_account: 'Connect your bank account',
  connect_your_bank_account_description:
    'We need you to connect at least one bank account to move forward',
  connect_now: 'Connect now',
  provide_transaction_information:
    'To provide you with transaction information, please connect at least one bank account and upload your bank statements.',

  // Statements Page
  back_to_banks: 'Back to banks',
  statements_table_title: 'Statements',
  statements_table_header_name: 'Name of Document',
  statements_table_column_from: 'From: {{from}}',
  statements_table_options_download: 'Download',
  statements_table_options_change_type: 'Change type',
  statements_table_options_move_to: 'Move to {{date}}',
  statements_table_options_edit_name: 'Edit name',
  statements_table_options_edit_description: 'Edit description',
  statements_table_options_delete: 'Delete',
  statements_table_header_bulk_actions: 'Bulk actions',
  all_banks: 'All banks',
  statements_table_header_date: 'Upload Date',
  statements_table_header_status: 'Status',
  no_bank_accounts_connect_message:
    'No bank accounts linked to your company were found. To match bank movements with invoices, salaries or trips, or get stats of revenue and expenditure of your business, <0>link your first bank account now</0>.',
  statements_table_upload_button: 'Upload',
  statements_upload_modal_title: 'Upload statement',
  bank_account: 'Account',
  statements_upload_pdf_image: 'Upload a valid PDF, PNG, JPG or CSV file to begin',
  select_bank_account_to_statement: 'Select a bank account to upload the statement',
  show_all_banks: 'Show all banks',

  // My business page
  page_title_my_business: 'Business info',
  general_tab: 'General',
  registry_tab: 'Registry',
  digital_products_tab: 'Digital products',
  poa_tab: 'PoA',
  other_documents_tab: 'Other documents',
  digital_products_page_description:
    "If you offer digital services or products that can be downloaded or enjoyed automatically by your customers without your intervention (think e-Book downloads, streaming services, or a second-hand platform allowing buyers to sell stuff from senders while you get a fee), then we need to register you as an OSS provider (selling digital products or services). If that's the case, please let us know and specify which services or products you offer",
  offer_digital_products_checkbox:
    'Yes, I offer digital products or services that can be acquired, downloaded or enjoyed by my clients without my intervention',
  oss_up_to_date_checkbox: 'OSS registration and details are up to date in the Estonian registry',
  oss_registration_status: 'OSS registration status',
  oss_registered: 'registered',
  oss_unregistered: 'unregistered',
  digital_products_countries_list:
    'Comma-Separated List of Countries With Establishments or Facilities',
  digital_products_products_list: 'Comma-Separated List of OSS Products',
  other_vats: 'Other vats',
  other_vats_description:
    'If your Estonian business has VATs in other countries, please let us know by adding them here',
  digital_products_vats_list: 'Comma-Separated List of VATs From Other Countries',
  company_bank_information: "Company's bank account information",
  digital_products_iban_list: 'IBAN',
  digital_products_swiftCode_list: 'Swift code',
  oss_status_changing_warning:
    "Please note that changing your OSS status will require changes to your company's OSS registration. It may take some time to process these changes.",
  digital_products_update_pending: 'Updating digital products...',
  digital_products_update_success: 'Digital products updated successfully',
  digital_products_update_error: 'There was an error while updating digital products',
  annual_report_poa_modal_title: 'We need a Power of Attorney to submit your annual report',
  annual_report_poa_modal_description:
    "We need you to grant us Power of Attorney, as a standard requirement to operate with the Estonian authorities. <strong>Please, press the 'Grant PoA' button to proceed.</strong>",
  accounting_poa_modal_title: 'We need a Power of Attorney to do your accounting',
  accounting_poa_modal_description:
    "We need you to grant us Power of Attorney, as a standard requirement to operate with the Estonian authorities. <strong>Please, press the 'Grant PoA' button to proceed.</strong>",
  stats_poa_modal_title:
    'We need a Power of Attorney to Submit Your company’s information to the eSTAT Portal',
  stats_poa_modal_description:
    "As an Estonian company, you need to submit information about your company through the eSTAT online portal. If you want to grant us permission to do it on your behalf, press the 'Grant PoA' button.",
  remind_me_later: 'Remind me later',
  review_account: 'Review account',
  grant_poa: 'Grant PoA',
  card_description_label: 'How to grant us Power of Attorney?',
  accounting_card_description_text:
    'To do your accounting, we need you to grant Power of Attorney to one of our accountants. It’s a standard requirement to operate seamlessly with the Estonian authorities. You can find out how to do it step by step <0>here</0>.',
  annual_report_card_description_text:
    'To submit your annual report, we need you to grant us Power of Attorney. It’s a standard requirement to operate seamlessly with the Estonian authorities. You can find out how to do it step by step <0>here</0>.',
  stats_card_description_text:
    'As an Estonian company, you need to submit information about your company through the eSTAT online portal. If you want to grant permission to one of our accountants to submit this information on your behalf, you can find out how to do it step by step <0>here</0>.',
  accounting_poa: 'Accounting PoA',
  annual_report_poa: 'Annual Report PoA',
  stats_poa: 'Stats PoA',
  not_requested: 'not requested',
  mark_as_granted: 'Mark as granted',
  requested_date: 'Requested date',
  granted_date: 'Granted date',
  poa_grant_confirm_modal_title: 'Has this PoA been granted and verified?',
  poa_grant_confirm_modal_description:
    'Make sure that the PoA has been checked in the e-Business registry before marking it as granted.',
  poa_grant_confirm_modal_cancel: "I'll check again",
  poa_status_update_pending: 'Updating power of attorney...',
  poa_status_update_success: 'Power of attorney updated successfully',
  poa_status_update_error: 'There was an error while updating power of attorney',
  digital_products_modal_title: 'Are you sure you want to change this information?',
  digital_products_modal_description:
    'Our accountant will receive a notification to review this new information with the registry for approval. <b>It may take a while, but would you still like to proceed?</b>',
  registry_date_registered: 'date registered',
  registry_vat_number: 'VAT number (optional)',
  registry_vat_since_date: 'VAT liable since date',
  current_members: 'Current members',
  need_to_make_changes: 'Need to make changes here?',
  registry_support_text:
    'If you made changes in the registry or want to make them please contact our support team through <0>the chat</0>.',
  general_support_text:
    'If you made changes in the general or want to make them please contact our support team through <0>the chat</0>.',
  company_data_update_pending: 'Updating company data...',
  company_data_update_success: 'Company data updated successfully',
  company_data_update_error: 'There was an error while updating company data',
  general_data_title: 'Company data',
  general_data_company_name: 'company name',
  general_data_company_plan: 'plan',
  general_data_company_status: 'status',
  general_data_company_support_pin: 'support pin',
  general_data_company_email: 'email',
  general_data_company_phone_number: 'phone number',
  general_data_company_registry_number: 'registry code',
  general_data_company_registered_since: 'regitered since',
  general_data_company_vat_number: 'vat number',
  general_data_company_vat_number_since: 'vat number since',
  general_data_company_share_capital: 'share capital',
  general_data_company_share_capital_date: 'share capital registered',
  general_data_company_in_accounting_date: 'in accounting since',
  general_data_company_other_vats: 'other vats',
  general_data_company_street_address: 'street address',
  general_data_company_city_address: 'city',
  general_data_company_zip_address: 'zip code',
  general_data_company_country_address: 'country',
  general_data_company_activity: 'activity',
  board_member_type: 'Board member',
  shareholder_type: 'Shareholder',
  both_type: 'Both',
  edit_info: 'Edit info',
  company_member_update_pending: 'Updating profile...',
  company_member_update_success: 'Profile updated successfully.',
  company_member_update_error: 'There was an error while updating your profile.',
  all_types: 'All types',
  other_documents_title: 'Other Documents',
  other_documents_table_header_add_invoice_button: 'Upload document',
  document_type_other: 'Other',
  document_type_passport_pic: 'Passport picture',
  document_type_company_data: 'Company data',
  document_type_contract: 'Contract',
  document_type_company_registration: 'Company registration',
  document_type_business_trip_doc: 'Business trip document',
  document_type_scanned_letter: 'Scanned letter',
  document_type_employment_contract: 'Employment contract',
  document_type_member_residence_proof: 'Member residence proof',
  document_type_statement_profit_losses_archive: 'Profit and losses archive',
  document_type_balance_sheets_archive: 'Balance sheets archive',
  document_type_general_ledger_archive: 'General ledger archive',
  document_type_bank_statements_archive: 'Bank statements archive',
  document_type_accounts_payable_receivable_archive: 'Accounts payable and receivable archive',
  upload_other_documents_modal_title: 'Upload documents',
  upload_other_documents_modal_dismiss_button: 'Dismiss',
  upload_other_documents_modal_description:
    'Please select the type of document you are uploading, then choose the file and click the button to proceed with the upload.',
  type_of_document: 'Type of document',
  select_type_of_document: 'Select type of document',
  upload_other_documents_modal_drop_files_description: 'You can also drop your files here',
  other_documents_upload_pdf_csv_image:
    'Upload a valid PDF, DOC, DOCX, PNG, JPG or CSV file to begin',
  upload_other_documents_modal_uploading_files:
    'Uploading 1 - Uploaded {{filesUploaded}} of {{filesToUpload}} successfully',
  upload_other_documents_modal_uploaded_files:
    'Uploaded {{filesUploaded}} of {{filesToUpload}} successfully',
  upload_other_documents_modal_uploaded_files_failed: '- {{filesFailed}} failed',
  other_documents_table_header_bulk_actions: 'Bulk actions',
  delete_other_document_modal_title: 'Confirm deletion',
  delete_other_document_modal_description_multiple:
    'Please, confirm that you want to delete the following documents:',
  delete_other_document_modal_description_single:
    'Are you sure you want to delete this document? This action cannot be undone. Once deleted, you will not be able to upload the document again, as our system remembers a digital fingerprint of the file to prevent for duplicate submissions.',
  delete_other_document_modal_cancel_button: 'Cancel',
  delete_other_document_modal_confirm_button: 'Confirm',
  invoice_photo_description:
    'This photo will be displayed on the generated invoices. Max Photo size 1 MB.',
  company_email_updated_successfully: 'Company email updated successfully.',
  user_email_updated_successfully: 'User email updated successfully.',
  power_of_attorney_grant_sent_to_accountant_success:
    '<strong>A notification has been sent to the accountant</strong>. <br /> We will let you know if we need anything else.',
  business_info_email_note:
    'This is your company’s email address, not your user login email. If you want to change the email you use to access Companio, go to the Profile section.',

  // Companion page
  page_title_companion: 'companion®',
  what_is_companion_title: 'What is a companion',
  what_is_companion_description:
    'A Companion is a dedicated professional provided exclusively to our VIP customers to assist with business management and accounting tasks. Think of them as a personal trainer for your business—focused on your unique needs and goals. With expertise in bookkeeping, taxation, and administration, Companions are more than assistants; they are strategic allies. As part of the Companio team, they offer seamless access to our resources and experts, ensuring your business is supported every step of the way. Want to learn more about how a Companion can support your business? <0>Click here to get more information</0>.',
  why_having_companion_title: 'Why having a companion ',
  accounting_support_description:
    '<bold>Comprehensive support in accounting, administration, and finance</bold>. Your Companion is a finance and administration expert dedicated to your business at a fraction of the cost of hiring full-time staff.',
  administration_description:
    '<bold>Simple administration and complete flexibility</bold>. We handle the complex HR tasks for you, offering a pool of trained candidates ready to contribute to your business. If you’re not satisfied, we’ll replace your Companion at no additional charge.',
  issue_resolution_description:
    '<bold>Fast issue resolution with direct access to Companio</bold>. Your Companion works closely with Companio’s accounting and customer support teams, ensuring swift problem-solving and seamless coordination.',
  get_your_companio_button: 'Get your companio now!',
  companion_name: 'Name',
  companion_assigned_hours: 'Default assigned hours',
  active_since: 'Active since',
  cancel_companion_service: 'Cancel companion service',
  companion_modal_title: 'Are you sure you want to cancel companion service?',
  companion_creating_pending: 'Creating companion service...',
  companion_creating_success: 'Companion service created successfully',
  companion_creating_error: 'There was an error while creating companion service',
  companion_ticket_table_header_details: 'Ticket details',
  companion_ticket_table_header_date: 'Date created',
  companion_ticket_table_header_closed: 'Date closed',
  companion_ticket_table_status: 'Status',
  page_title_companion_ticket_details: 'Back to chats',
  companion_table_header_add_ticket: 'Add new',
  ticket_create_pending: 'Creating conversation...',
  ticket_create_success: 'Conversation created successfully',
  ticket_create_error: 'There was an error while creating conversation',
  companion_ticket_subject: 'Subject',
  companion_ticket_topic: 'Topic',
  companion_ticket_description: 'Description',
  new_companion_ticket_modal_title: 'Add new conversation',
  companion_update_pending: 'Updating companion service...',
  companion_update_success: 'Companion service updated successfully',
  companion_update_error: 'There was an error while updating companion',
  companion_files_table_title: 'All files',
  companion_files_table_header_document_name: 'Document name',
  companion_files_table_header_document_created: 'Creation date',
  companion_files_table_header_add_document_button: 'Add files',
  add_companion_files_modal_title: 'Upload files',
  confirm_companion_document_title:
    'Are you sure you want to delete this document? This action cannot be undone.',
  activate_companion_modal_title:
    'Activate companion as an additional service on your current plan',
  activate_companion_modal_description:
    'To enable companion, <bold>a monthly fee of €799 (VAT not included)</bold> will be added to your current subscription. Would you like to proceed with the activation of this service?',
  companion_activation_sucess_modal_title: 'Companion successfully activated',
  companion_activation_success_modal_description:
    'The companion service has been added to your monthly subscription.',
  companion_activation_error_modal_title: 'Activation failed',
  companion_activation_error_modal_description:
    'We couldn’t activate the companion service. Please try again, and if the issue persists, contact our Customer Support team through the <0>chat</0>. Our team will be happy to help you.',
  chat: 'Chat',
  files: 'Files',

  // Marketplace page
  marketplace_page_title: 'Marketplace',
  marketplace_list_your_business: 'List Your Business',
  marketplace_category_all: 'All offers',
  marketplace_category_banking_payments: 'Banking',
  marketplace_category_legal: 'Legal',
  marketplace_category_marketing: 'Marketing',
  marketplace_category_tech_development: 'Tech',
  marketplace_category_other: 'Other',
  marketplace_load_error: 'Something went wrong loading the marketplace. Please try again later.',
  marketplace_empty: 'No offers available in this category yet.',
  partners: 'Partners',
  wise_card_title:
    'Send and receive money worldwide with real rates and low, transparent conversion fees.',
  wise_card_description:
    'Manage multi-currency accounts, pay invoices and get paid globally with low fees and total transparency—all in one simple platform.',
  wise_card_alert:
    '👉 Transfer up to 10,000 EUR fee-free through our exclusive partnership with Wise and Companio',
  create_account: 'Create account',
  payoneer_card_title:
    'Global payment platform built for freelancers, startups, and digital-first businesses',
  payoneer_card_description:
    'Accept international payments, withdraw in local currency, and manage global income with no monthly fees from one account.',
  payoneer_card_alert:
    '👉 Get global payment access with no hidden fees through Companio’s Payoneer setup',
  revolut_card_title:
    'Transfer money in 30+ currencies, including crypto, with no monthly fees on free plans',
  revolut_card_description:
    'Open multi-currency accounts, send local transfers and manage spending from one intuitive app designed for global business.',
  revolut_card_alert:
    '👉 Enjoy 1 month free of Revolut Business with advanced tools—exclusively via Companio',

  // Accounting reports
  page_title_reports: 'Accounting reports',
  accounting_reports_table_title: 'All reports',
  accounting_reports_table_description: 'Description',
  accounting_reports_table_status: 'Status',
  accounting_reports_table_date: 'Creation date',
  accounting_reports_table_taxes: 'Taxes to be paid',
  accounting_table_dropdown_view: 'View details',
  accounting_reports_table_description_column: '{{type}} Report {{month}}/{{year}}',
  accounting_reports_table_description_column_quarter: '{{type}} Report Q{{quarter}}',
  back_to_accounting_reports: 'Back to reports',
  accounting_report_details_step_in_preparation: '1. In preparation',
  accounting_report_details_step_prepared: '2. Prepared',
  accounting_report_details_step_submitted: '3. Submitted',
  accounting_report_details_step_taxes_paid: '4. Taxes paid',
  report_details_in_preparation_title: 'Your report is in progress!',
  report_details_in_preparation_description:
    'Our system is currently reviewing your data to prepare your report. If we need any additional documents or clarifications, you’ll receive an email with the next steps.',
  accountancy_completed_title: 'Accountancy completed',
  accountancy_completed_description:
    'As a result of the {{reportType}} calculations of your activities during that period, you need to pay {{reportType}} in the amount of {{amount}}{{currency}} to the Estonian Tax Office.',
  payment_deadline: 'Payment deadline',
  accounting_report_instructions: 'Instructions',
  accounting_report_instructions_1:
    'Verify your reference number <a href="https://apps.emta.ee/saqu/public/reference?lang=en" target="_blank">here</a> via your company registration code.',
  accounting_report_instructions_2:
    'Verify the Tax Office bank account info <a href="https://www.emta.ee/en/business-client/taxes-and-payment/payment-arrears/payment-taxes#bank-transfer" target="_blank">here</a>.',
  accounting_report_instructions_3:
    'Use your company reference number {{reference}} to pay the amount.',
  tax_office: 'Tax Office',
  tax_office_bank: 'Bank: {{bank}}',
  tax_office_bank_account: 'Bank account IBAN: {{iban}}',
  tax_office_bic_swift: 'BIC/Swift: {{bicSwift}}',
  tax_office_reference: 'Reference: {{reference}}',
  tax_office_concept: 'Concept: {{concept}} taxes {{date}}',
  thank_you_for_keeping_it_fair: 'Thank you for keeping it fair! 🙌',
  report_document_table_title: 'Report document',
  report_document_table_description: 'Description',
  report_document_table_date: 'Date',
  paid_taxes: 'Paid taxes',
  download_reports: 'Download Reports',
  confirm_paid_taxes_modal_title: 'You are about to confirm this action',
  confirm_paid_taxes_modal_description:
    'Have you paid the corresponding taxes to the tax office bank account?',
  report_details_submitted_title: '{{type}} report for: {{date}}',
  updating_report_status_loading: 'Updating report status...',
  updating_report_status_success: 'Report status updated successfully',
  choose_a_bank_first: 'Please choose a bank first',
  report_details_prepared_title: 'Your report is ready!',
  report_details_prepared_description:
    'Our system has finished reviewing your data to prepare the report. However, we need time to submit it to the tax authority and will inform you soon about the results. If we need additional documents or clarifications, you’ll receive an email with next steps.',
  accountancy_completed_description_no_taxes:
    'The outcome of this report is that <strong style="font-weight: bold">your company does not need to pay any taxes.</strong>',
  oss_report_quarter_concept: 'Concept: {{concept}} taxes Q{{quarter}} {{year}}',
  report_details_submitted_title_oss: '{{type}} report for: Q{{quarter}} {{year}}',
  mark_as_paid: 'Mark as Paid',
  report_details_download: 'Download',
  report_details_vat_to_pay: '{{type}} to pay',
  report_details_vat_paid: '{{type}} paid',
  report_details_submitted_date: 'Submitted date',
  report_details_what_to_do: 'What you need to do:',
  report_details_no_pay_instruction_1:
    'Good news — <strong>no taxes are due for this period.</strong>',
  report_details_no_pay_instruction_2:
    'Mark the report as completed by using the button at the top.',
  report_details_instruction_1:
    'Verify your company reference number {{reference}} <a href="https://apps.emta.ee/saqu/public/reference?lang=en" target="_blank" rel="noopener noreferrer">here</a> and use it to pay the amount ({{currency}}{{amount}}).',
  report_details_instruction_2:
    'Verify the Tax Office bank account information <a href="https://www.emta.ee/en/business-client/taxes-and-payment/payment-arrears/payment-taxes#bank-transfer" target="_blank" rel="noopener noreferrer">here</a>.',
  report_details_instruction_3: 'Mark the payment as completed using the button at the top.',
  report_details_payment_details: 'Payment details:',
  report_details_bank: 'Bank',
  report_details_iban: 'IBAN',
  report_details_bic_swift: 'BIC/Swift',
  report_details_reference: 'Reference',
  report_details_concept: 'Concept',
  report_details_compliance_note:
    'Your {{type}} report is ready. One step left to stay compliant. 🙌',
  report_details_not_started_banner_title: 'Report not started yet',
  report_details_not_started_banner_description:
    'Our system is currently reviewing whether this report needs to be started. If required, we’ll initiate it shortly and begin gathering all the necessary information — including any documents or details we may need from you.',

  // Accounting
  accounting_tab_overdue: 'Overdue',
  accounting_tab_rejected: 'Rejected',
  accounting_tab_current: 'Current ({{currentFiscalDate}})',
  accounting_tab_next_month: 'Next Month',
  accounting_tab_matched: 'Matched',
  accounting_current_month_info:
    'IMPORTANT: Please match your transactions and upload your documents before {{date}}',
  accounting_current_month_title: 'Movements of {{month}}',
  accounting_description: 'Description',
  accounting_type: 'Type',
  accounting_date: 'Date',
  accounting_upload_or_match: 'Upload or match',
  accounting_amount: 'Amount',
  back_to_accounting: 'Back to accounting',
  matching_explanation_none_of_the_above:
    "Unsupported matching types will be declared as 'Non-business expenses'. This may incur in tax liability with the local tax authorities.",
  matching_explanation_sales_invoice:
    "Match transactions with invoices for digital services or goods delivered by your business to clients. For example, if you've provided web design services to a client, you'd match the payment received with the corresponding sales invoice.",
  matching_explanation_purchase_invoice:
    "Match transactions with invoices for goods or services delivered to you. For instance, if you've purchased office supplies from a vendor, you'd match the payment made with the purchase invoice received.",
  matching_explanation_bank_fee:
    "Identify monthly bank charges for account or card maintenance. For instance, if your bank deducts a monthly fee for maintaining your business account, you'd categorize it as a bank fee.",
  matching_explanation_state_fee:
    'Indicates fees payable to the Estonian government for activities with the e-Business registry or payment of taxes to the Tax Office.',
  matching_explanation_daily_allowance:
    "Identify reimbursements for daily expenses during business trips, after it has been approved. For instance, if you've paid yourself a daily allowance for meals during a business trip, you'd categorize it as a daily allowance.",
  matching_explanation_internal:
    "Indicate transfers between business accounts. For example, if you've transferred funds from your business checking account to your business savings account, you'd categorize it as an internal movement of funds. Don't use it for transactions between your Estonian business and another business, even if you own both businesses.",
  matching_explanation_other: 'Movement that cannot be classifed in any of the other categories',
  matching_explanation_share_capital:
    "Declare payments for share capital contributions. For example, if a shareholder adds additional funds into the company after increasing the share capital, you'd categorize it as a share capital contribution.",
  matching_explanation_dividends:
    "Distribute profits to shareholders. For example, if the company distributes profits to its shareholders after the submission of the annual report if the company had profit, you'd categorize it as dividends.",
  matching_explanation_card_verification:
    "Identify small charges for card verification. For example, if a merchant charges a nominal fee to verify your credit card, you'd categorize it as a card verification. Usually 0€, but can occassionally be a small amount, like 0.01€.",
  matching_explanation_bank_cashback:
    "Record cashbacks for interest earned. For example, if your business bank account offers cashback rewards for maintaining a minimum balance, you'd categorize it as a bank cashback.",
  matching_explanation_received_interest:
    "Identify interest income. For example, if your business earns interest on investments in regulated platforms, you'd categorize it as received interest.",
  matching_explanation_non_business_expense:
    "Identify expenses like food, beverages, meals, or clothing paid with corporate funds. For example, if you've used your company credit card to pay for a coffee or lunch, you'd categorize it as a non-business expense.",
  matching_explanation_personal_expense_refund:
    "A member of the company made a personal expense with the corporate funds of the company and later refunded the money back to the company. You'll be prompted to choose the matching transaction. The refund must come from the personal bank account of one of the members of the company.",
  matching_explanation_refunded_sale:
    'A customer received a payment (incoming transaction) that was later fully refunded (outgoing transaction). Both transactions must have the exact same amount, involve the same third party, and belong to the same accounting month. No invoice is required.',
  matching_explanation_refunded_purchase:
    'A payment was made to a supplier (outgoing transaction) that was later fully refunded back (incoming transaction). Both transactions must have the exact same amount, involve the same third party, and belong to the same accounting month. No invoice is required.',
  matching_explanation_state_refund:
    'This is a refund from the state, for example, a tax refund from EMTA. This refund must come from the Estonian government or an official Estonian institution (such as the e-Business Register or the Tax Office).',
  matching_explanation_commission_earnings:
    'This is a small commission or fee earned from a bank or service provider for some kind of affiliate sign up or referral. This commission must be small and occasional. If the main activity of the business is based on affiliate links or referral for products or services, you need to ask for an invoice to the agencies you work with.',
  matching_explanation_inner_trading:
    'Internal trading refers to transactions that occur within an investment platform where the business has added funds to invest. These internal transactions, such as buying and selling securities within the platform, are not relevant for the accounting of the company. The initial addition of funds to the investment platform and subsequent withdrawal should not be matched as Internal Trading.',
  matching_explanation_investment_add_funds:
    'This transaction represents the addition of funds to an investment platform. The company has added money to the platform to invest in securities or other financial instruments. This is an outgoing transaction, meaning the money is deducted from the account balance.',
  matching_explanation_investment_withdraw_funds:
    'This transaction represents the withdrawal of funds from an investment platform. The company has withdrawn money from the platform, typically after selling securities or other financial instruments. This is an incoming transaction, meaning the money is added back to the account balance.',
  matching_explanation_principal:
    'The principal amount must be greater than 0 and cannot be greater than {{transaction_amount}}.',
  matching_explanation_interest:
    'The interest amount must be greater than 0 and cannot be greater than {{transaction_amount}}.',
  matching_explanation_fees:
    'The fee amount should be 0 or more and less than {{transaction_amount}}.',
  matching_explanation_amount:
    'The total of principal, interest, and fees should equal {{transaction_amount}}.',
  matching_explanation_interest_paid:
    'Interest paid on loans or credit lines. For example, if a business pays interest on a loan or credit line, it is categorized as interest paid.',
  matching_explanation_repayment_installment:
    'A regular payment made to repay a loan. For example, if a business has a loan, each scheduled payment is an installment toward repayment.',
  matching_explanation_initial_principal_payment:
    'This matching type represents the initial transfer of funds from the lender to the borrower when a loan is granted. It records the disbursement of the principal amount of the loan to the borrower, not the repayment.',
  matching_explanation_held_fund_reserve:
    'A payment provider or bank withholds part of an incoming payment as a reserve, to cover potential future risks such as chargebacks or refunds. The money is temporarily “frozen” and not available to the business until it is released.',
  matching_explanation_released_fund_reserve:
    'The bank or payment provider releases the previously held funds and transfers them back to the company’s available balance.',
  accounting_upload_purchase_invoice: 'Upload new purchase invoice',
  accounting_upload_sales_invoice: 'Upload new sales invoice',
  accounting_table_current_empty_table:
    'Congratulations, all your documents for this period are matched!',
  need_connect_back_title: 'Disconnected bank accounts',
  need_connect_back_description: 'Please connect your bank account',
  missing_bank_statement_title: 'Missing bank statements',
  missing_bank_statement_description: 'Upload your {{bankName}} statement for {{month}} {{year}}',
  accounting_bank_statements_info:
    'To provide you with transaction information, please connect your bank accounts and upload your bank statements.',
  accounting_matched_title: 'Matched',
  accounting_matched: 'Matched',
  accounting_dropdown_upload_match_extra_document: 'Upload & match extra document',
  accounting_dropdown_add_extra_document: 'Add extra matching document',
  accounting_dropdown_see_transaction: 'See transaction',
  no_transaction_id_found: 'No transaction id found. Please try again.',
  no_document_type_found: 'No document type found. Please try again.',
  accounting_request_fix_invoice_modal_title_unavailable: 'Title unavailable. Please try again.',
  accounting_request_fix_invoice_modal_description_unavailable:
    'Description unavailable. Please try again.',
  request_info_modal_title: 'Provide Details for Transaction Categorization',
  request_info_modal_description:
    'To help us accurately categorize your transaction, please provide additional details when prompted. This will assist our accounting team if there are any uncertainties regarding the transaction.',
  notify_personal_expense_modal_title: 'Action Needed: Personal Expense Notification',
  notify_personal_expense_modal_description:
    'We believe this transaction might be a business expense. Please take one of the following actions:',
  notify_personal_expense_modal_action_1:
    'Upload a proper invoice if it’s a deductible business expense.',
  notify_personal_expense_modal_action_2:
    'Process a refund and categorize the transaction as a personal expense refund.',
  notify_personal_expense_modal_action_3: 'Match it as a non-business expense.',
  accounting_no_accounting_request_found: 'No accounting request found. Please try again.',
  accounting_dropdown_unmatch: 'Unmatch',
  accounting_info_not_matched_warning:
    'Expenses not matched within two months will be classified as ‘Non-business expenses’ and become subject to tax liability. Please review the list of overdue bank transactions and match them accordingly.',
  accounting_rejected_title: 'Rejected Documents',
  accounting_status: 'Status',
  accounting_rejection_status_detected: 'Rejection detected',
  accounting_rejection_status_verification_requested: 'Appeal requested',
  accounting_rejection_status_solved: 'Rejection solved',
  accounting_rejection_status_confirmed: 'Rejection confirmed',
  accounting_rejection_status_description_detected: 'By the system',
  accounting_rejection_status_description_verification_requested: 'Customer appeals',
  accounting_rejection_status_description_solved: 'By the accountant',
  accounting_rejection_status_description_confirmed: 'By the accountant',
  accounting_rejection_reasons: 'Rejection reasons',
  accounting_table_download: 'Download',
  accounting_table_appeal: 'Appeal rejection',
  accounting_table_why_rejected: 'Why was it rejected?',
  accounting_table_options_replace: 'Replace with correct document',
  accounting_table_options_delete: 'Delete',
  accounting_table_open_document: 'Open document',
  accounting_upload_or_match_placeholder: 'Match transaction',
  accounting_option_match_with_purchase_invoice: 'Match with purchase invoice',
  accounting_option_match_with_sales_invoice: 'Match with sales invoice',
  accounting_option_upload_purchase_invoice: 'Upload purchase invoice',
  accounting_option_upload_sales_invoice: 'Upload sales invoice',
  accounting_option_state_fee: 'State fee',
  accounting_option_non_business_expense: 'Non-business expense',
  accounting_option_daily_allowance: 'Daily allowance',
  accounting_option_internal_transfer: 'Internal transfer',
  accounting_option_other_option: 'Other option',
  accounting_upload_or_match_default_option_error: 'Option not found or allowed. Please try again.',
  from_table_header: 'From',
  match_personal_expense_refund_pending: 'Matching personal expense refund pending',
  match_personal_expense_refund_success: 'Matching personal expense refund success',
  match_refunded_sale_pending: 'Matching refunded sale pending',
  match_refunded_sale_success: 'Matching refunded sale success',
  match_refunded_purchase_pending: 'Matching refunded purchase pending',
  match_refunded_purchase_success: 'Matching refunded purchase success',
  select_company_member: 'Select company member',
  accounting_overdue_title: 'Overdue transactions',
  select_an_agreement: 'Select an agreement',
  no_loan_agreements_found: 'No loan agreements found',
  accounting_reset_all_banks: 'Reset all banks',
  accounting_banks_count: 'Selected ({{count}})',
  accounting_bank_filter_last_option_selected: 'Please keep at least one bank selected',
  reset_all_banks: 'Reset all banks',
  reset_all_balances: 'Reset all balances',
  all_balances: 'All balances',
  transaction_tooltip_description:
    '<strong style="font-weight: bold">Description:</strong> {{description}}',
  accounting_info_rejected_warning:
    'Some of your documents were rejected. Use the three-dot menu to view the reason, upload the correct document, or appeal if needed.',

  // Add invoices page
  parsed_invoices_table_header_name: 'Document name',
  parsed_invoices_table_header_date: 'Date',
  parsed_invoices_table_header_status: 'Status',
  parsed_invoices_table_header_transaction: 'Transaction',
  parsed_invoices_table_header_category: 'Tag',
  add_invoices_sales_tab: 'Sales',
  add_invoices_purchases_tab: 'Purchases',
  parsed_invoices_sales_table_title: 'Sales invoices',
  parsed_invoices_purchases_table_title: 'Purchases invoices',
  documents_table_header_add_document_button: 'Confirm Selection',
  parsed_invoices_sales_column: 'Sales',
  parsed_invoices_purchases_column: 'Purchases',
  assign_invoice_pending: 'Assigning invoice to project...',
  project_update_success: 'Project updated successfully.',
  project_update_error: 'There was an error while updating project.',
  invoices_assigned_success_title: 'The invoices have been added to the project',
  invoices_assigned_success_description:
    'You can download the invoices or remove them from the project details screen.',
  invoices_assigned_error_title: 'Oops! Something went wrong',
  invoices_assigned_error_description:
    'We could not add the selected invoices due to a connection problem. Please try again, and if the issue persists, contact our Customer Support team through the <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. Our team will be happy to help you.',
  parsed_documents_warning:
    'Only invoices that have been processed are shown here. If a specific invoice isn’t visible yet, don’t worry — it will appear shortly after our system finishes analyzing it. ',
  go_back: 'Go Back',
  closure_date_optional: 'Closure date (optional)',
  closure_date: 'Closure date',
  dividend_calculation_initial_message: 'You will pay €0 in tax and receive €0 as net dividend.',
  dividend_calculation_message:
    'You will pay €{{tax_amount}} in tax and receive €{{net_dividend}} as net dividend.',

  // Passport page
  street_address: 'Street address',
  zipcode: 'Zip Code',
  passport_table_title:
    '<p><bold>Please check this data</bold></p><p className="subtitle">Upload an updated version of the passport or EU national ID for the following members, and confirm their countries of residence.</p>',
  upload_passport_success_title: 'Upload complete',
  upload_passport_success_description:
    'Thanks for uploading your documents. You’ll be redirected to your dashboard in a moment.',
  upload_passport_warning_title: 'Identity Verification Required',
  upload_passport_warning_description:
    "To comply with the Anti Money-Laundering protocols requested by the authorities, we need you to submit some information. Don't worry, it will only take you 2 minutes!",
  upload_passport: 'Upload your passport',
  passport_uploaded_successfully: 'Passport uploaded successfully',
  transaction_locked_by_annual_report_title: 'Annual Report action required',
  transaction_locked_by_annual_report:
    'This transaction is part of the {{year}} Annual Report process and cannot be matched through the standard flow. Please review it directly in the Annual Report and select the appropriate option.',
  export: 'Export',
  export_csv: 'Export as CSV',
  export_pdf: 'Export as PDF',
  export_loading: 'Exporting, please wait...',
  export_modal_title: 'Export {{pageType}} as {{format}}',
  export_modal_description:
    'Choose the time period you want to export. The file will include all transactions matching the selected range.',
  export_period_placeholder: 'Select period',
  export_period_month_to_date: 'Month to date',
  export_period_previous_month: 'Previous month',
  export_period_current_quarter: 'Current quarter',
  exporting: 'Exporting...',
  export_error: 'An error occurred while exporting. Please try again.',
  export_queued_title: "We're preparing your file",
  export_queued_description:
    "Your file contains a large amount of information, so we're preparing it in the background. Once it's ready, we'll send it to your email in the selected format.",
  filter_section_bank_account: 'Bank Account',
  filter_section_balances: 'Balances',
  filter_section_display_options: 'Display Options',
  filter_section_export_data: 'Export Data',

  // MissingBank page
  review_transactions: 'Review transactions',
  missing_bank_transactions_description:
    'We’ve found transactions that may belong to a bank account that hasn’t been connected yet. <b>Please review them and choose how you’d like to proceed.</b>',
  missing_bank_transactions_description_resolved:
    'Here you can review the comment you submitted and review the transactions.',
  accountants_comment: "Accountant's comment",
  what_would_you_like_to_do: 'What would you like to do?',
  connect_a_bank_account: 'Connect a bank account',
  connect_bank_account_description:
    '<b>You’ll be redirected to connect your bank account.</b> Once connected, this issue will be resolved automatically.',
  no_additional_bank_accounts: 'No additional bank accounts',
  no_additional_bank_accounts_description:
    'If you don’t have any other bank accounts to connect, please add a comment to help us ensure your records are complete and accurate.',
  receiver: 'Receiver',
  add_a_comment: 'Add a comment',
  confirm_no_additional_bank_accounts_modal_title:
    'Are you sure there are no additional bank accounts?',
  confirm_no_additional_bank_accounts_modal_description_1:
    '<b>These transactions may indicate activity from a bank account that hasn’t been connected yet.</b> Connecting all accounts helps ensure your financial data is complete and accurate.',
  confirm_no_additional_bank_accounts_modal_description_2:
    'If you’re confident there are no additional accounts, you can continue.',
  review_again: 'Review again',
  missing_bank_success_modal_title: 'All set! We’re reviewing your case',
  missing_bank_success_modal_description_1:
    'Your response has been submitted and we’ll review it shortly.',
  missing_bank_success_modal_description_2:
    'If we need any additional information, we’ll reach out to you by email.',
  missing_bank_resolved_alert:
    "<b>We’ve received your comment and our system is reviewing it.</b> We'll notify you by email if we need anything else from you.",
  comment_details: 'Comment details',
  information_provided_by_the_accountant: 'Information provided by the accountant',
  pending_payment_warning: 'You have a pending payment',
  pending_payment_warning_description:
    'You have <strong>{{amount}} in pending payments</strong> related to your service plan. Please resolve them soon to avoid service interruptions or late fees.',
  help_title_label: 'Help and tutorials'
};
